import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: string; output: string };
  Upload: { input: File | FileList | Blob; output: File | FileList | Blob };
};

export type AddConversationAgentMessage = {
  answer?: InputMaybe<Scalars['Boolean']['input']>;
  attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  fieldValues: Array<ConversationStructuredTypeValueFieldValueInput>;
  forward?: InputMaybe<ForwardConversationAgentMessage>;
};

export type AddMeccaMessageAttachmentInputModel = {
  attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  messageId: Scalars['Float']['input'];
};

export type Address = {
  __typename?: 'Address';
  box?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  box?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AgentMessage = {
  __typename?: 'AgentMessage';
  channelType: ChannelType;
  content?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['ID']['output'];
  destination: Scalars['String']['output'];
  external?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  messageTime: Scalars['DateTime']['output'];
  sender: User;
  serviceId: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type AgentMessageResult = {
  __typename?: 'AgentMessageResult';
  attachments: Array<Attachment>;
  id: Scalars['ID']['output'];
  messages: Array<AgentMessage>;
  status: AgentMessageStatus;
  structuredMessage?: Maybe<AgentMessageStructuredMessage>;
};

/** The different statusses of agent message */
export enum AgentMessageStatus {
  Callback = 'CALLBACK',
  CallbackHimself = 'CALLBACK_HIMSELF',
  Cancellation = 'CANCELLATION',
  EmailBack = 'EMAIL_BACK',
  Finished = 'FINISHED',
  High = 'HIGH',
  Important = 'IMPORTANT',
  Info = 'INFO',
  Open = 'OPEN',
  Question = 'QUESTION',
  Urgent = 'URGENT',
}

export type AgentMessageStructuredMessage = {
  __typename?: 'AgentMessageStructuredMessage';
  fields: Array<ConversationStructuredTypeField>;
  name: Scalars['String']['output'];
  values: Array<AgentMessageStructuredMessageValue>;
};

export type AgentMessageStructuredMessageValue = {
  __typename?: 'AgentMessageStructuredMessageValue';
  sequence: Scalars['Float']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** Agents status for Customer */
export enum AgentsStatus {
  Available = 'AVAILABLE',
  Away = 'AWAY',
  Closed = 'CLOSED',
}

export type AgentsStatusResponse = {
  __typename?: 'AgentsStatusResponse';
  agentsStatus: AgentsStatus;
};

export type AssignMeccaMessageInputModel = {
  messageIds: Array<Scalars['Float']['input']>;
  userId: Scalars['String']['input'];
};

export type AssignSocialConversationInputModel = {
  messageIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AssignedUser = {
  __typename?: 'AssignedUser';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Assignment = {
  __typename?: 'Assignment';
  assignedBy: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Attachment = {
  __typename?: 'Attachment';
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type BlankConversation = Conversation & {
  __typename?: 'BlankConversation';
  archived: Scalars['Boolean']['output'];
  assignedToUsers?: Maybe<Array<AssignedUser>>;
  channelType: ChannelType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  events: Array<EventModel>;
  flagged: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  participants: Array<ConversationParticipant>;
  priority: Scalars['Float']['output'];
  read: Scalars['Boolean']['output'];
  related: Array<Conversation>;
  status: ConversationStatus;
};

export type CallBaseReporting = {
  title: Scalars['String']['output'];
  totalNrOfCalls: Scalars['Int']['output'];
  xAxisTitle: Scalars['String']['output'];
  xAxisValues: Array<Scalars['String']['output']>;
  yAxisTitle: Scalars['String']['output'];
  yAxisValues: Array<Scalars['Float']['output']>;
};

export type CallFilterInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CallModel = {
  __typename?: 'CallModel';
  callDateTime: Scalars['DateTime']['output'];
  callDuration: Scalars['Int']['output'];
  caller?: Maybe<Scalars['String']['output']>;
  dayNight: DayNightCallTypes;
};

export type CallReportingResult = {
  __typename?: 'CallReportingResult';
  durationTimeStatistics: DurationTimeReporting;
  missedCallStatistics: MissedCallsReporting;
  nrOfCallsPerHourStatistics: NrOfCallsPerHourReporting;
  waitingTimeStatistics: WaitingTimeReporting;
};

export type CallResult = {
  __typename?: 'CallResult';
  callList: Array<CallModel>;
  callStats: CallStats;
  phoneNumber: Scalars['String']['output'];
};

export type CallStats = {
  __typename?: 'CallStats';
  nrOfCallsDay: Scalars['Int']['output'];
  nrOfCallsNight: Scalars['Int']['output'];
  totalDurationDay: Scalars['Int']['output'];
  totalDurationNight: Scalars['Int']['output'];
};

/** Possible channels for communication */
export enum ChannelType {
  Blank = 'BLANK',
  CallMecca = 'CALL_MECCA',
  TextFacebook = 'TEXT_FACEBOOK',
  TextTwitter = 'TEXT_TWITTER',
  TextWhatsapp = 'TEXT_WHATSAPP',
  VideoMemo = 'VIDEO_MEMO',
}

export type Colors = {
  __typename?: 'Colors';
  error: Scalars['String']['output'];
  info: Scalars['String']['output'];
  primary: Scalars['String']['output'];
  primaryDarkShade: Scalars['String']['output'];
  primaryLightShade: Scalars['String']['output'];
  secondary: Scalars['String']['output'];
  secondaryDarkShade: Scalars['String']['output'];
  secondaryLightShade: Scalars['String']['output'];
  success: Scalars['String']['output'];
  warning: Scalars['String']['output'];
};

export type CompanyResultModel = {
  __typename?: 'CompanyResultModel';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  profileName: Scalars['String']['output'];
};

export type Content = {
  __typename?: 'Content';
  language: Language;
  value: Scalars['String']['output'];
};

export type Conversation = {
  archived: Scalars['Boolean']['output'];
  assignedToUsers?: Maybe<Array<AssignedUser>>;
  channelType: ChannelType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  events: Array<EventModel>;
  flagged: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  participants: Array<ConversationParticipant>;
  priority: Scalars['Float']['output'];
  read: Scalars['Boolean']['output'];
  related: Array<Conversation>;
  status: ConversationStatus;
};

export type ConversationArchivedEvent = EventModel & {
  __typename?: 'ConversationArchivedEvent';
  eventTime: Scalars['DateTime']['output'];
  type: EventTypes;
};

export type ConversationClosedEvent = EventModel & {
  __typename?: 'ConversationClosedEvent';
  eventTime: Scalars['DateTime']['output'];
  type: EventTypes;
};

export type ConversationCreatedEvent = EventModel & {
  __typename?: 'ConversationCreatedEvent';
  eventTime: Scalars['DateTime']['output'];
  source?: Maybe<Scalars['String']['output']>;
  type: EventTypes;
};

export type ConversationFlaggedEvent = EventModel & {
  __typename?: 'ConversationFlaggedEvent';
  eventTime: Scalars['DateTime']['output'];
  type: EventTypes;
};

export type ConversationForwardedEvent = EventModel & {
  __typename?: 'ConversationForwardedEvent';
  eventTime: Scalars['DateTime']['output'];
  type: EventTypes;
};

export type ConversationParticipant = {
  __typename?: 'ConversationParticipant';
  channel: ChannelType;
  channelId: Scalars['ID']['output'];
  destination: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type ConversationPriorityChangedEvent = EventModel & {
  __typename?: 'ConversationPriorityChangedEvent';
  eventTime: Scalars['DateTime']['output'];
  newPriority: Scalars['Float']['output'];
  type: EventTypes;
};

export type ConversationReadedEvent = EventModel & {
  __typename?: 'ConversationReadedEvent';
  eventTime: Scalars['DateTime']['output'];
  type: EventTypes;
};

/** The different conversation statusses */
export enum ConversationStatus {
  Callback = 'CALLBACK',
  CallbackHimself = 'CALLBACK_HIMSELF',
  Cancellation = 'CANCELLATION',
  EmailBack = 'EMAIL_BACK',
  Finished = 'FINISHED',
  High = 'HIGH',
  Important = 'IMPORTANT',
  Info = 'INFO',
  Open = 'OPEN',
  Question = 'QUESTION',
  Urgent = 'URGENT',
}

export type ConversationStatusChangedEvent = EventModel & {
  __typename?: 'ConversationStatusChangedEvent';
  eventTime: Scalars['DateTime']['output'];
  newStatus: ConversationStatus;
  type: EventTypes;
};

export type ConversationStructuredType = {
  __typename?: 'ConversationStructuredType';
  fields: Array<ConversationStructuredTypeField>;
  name: Scalars['String']['output'];
};

export type ConversationStructuredTypeField = {
  __typename?: 'ConversationStructuredTypeField';
  defaultValue?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  fieldType: ConversationStructuredTypeFieldType;
  isEditableByCustomer: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  readonly: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
  sequence: Scalars['Float']['output'];
};

export type ConversationStructuredTypeFieldType = {
  __typename?: 'ConversationStructuredTypeFieldType';
  errorMessage?: Maybe<Scalars['String']['output']>;
  mask?: Maybe<Scalars['String']['output']>;
  maxLength: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  regExForValidChars?: Maybe<Scalars['String']['output']>;
  regExForValidation?: Maybe<Scalars['String']['output']>;
};

export type ConversationStructuredTypeValueFieldValueInput = {
  sequence: Scalars['Float']['input'];
  value: Scalars['String']['input'];
};

export type ConversationStructuredTypesResult = {
  __typename?: 'ConversationStructuredTypesResult';
  count: Scalars['Int']['output'];
  items: Array<ConversationStructuredType>;
};

export type ConversationUnflaggedEvent = EventModel & {
  __typename?: 'ConversationUnflaggedEvent';
  eventTime: Scalars['DateTime']['output'];
  type: EventTypes;
};

export type ConversationUpdatedEvent = EventModel & {
  __typename?: 'ConversationUpdatedEvent';
  eventTime: Scalars['DateTime']['output'];
  source?: Maybe<Scalars['String']['output']>;
  type: EventTypes;
};

export type CountriesResult = {
  __typename?: 'CountriesResult';
  count: Scalars['Int']['output'];
  items: Array<Country>;
};

export type Country = {
  __typename?: 'Country';
  iso: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CountryFilter = {
  iso: Array<Scalars['String']['input']>;
};

export type CreateContactRequestInput = {
  customerId: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type CreateCustomerAttachmentInput = {
  attachment: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  validFrom: Scalars['DateTime']['input'];
  validTill: Scalars['DateTime']['input'];
};

export type CreateCustomerCrmContactInput = {
  addresses?: InputMaybe<Array<CustomerCrmContactAddressInput>>;
  communications?: InputMaybe<Array<CustomerCrmContactCommunicationInput>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  functionName?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<CustomerCrmContactGroupRelationInput>>;
  lastName: Scalars['String']['input'];
  sex?: InputMaybe<CustomerCrmContactSexes>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerTemporaryInstructionInput = {
  content: Scalars['String']['input'];
  name: Scalars['String']['input'];
  validFrom: Scalars['DateTime']['input'];
  validUntil: Scalars['DateTime']['input'];
};

export type CreateMeccaConversationInputModel = {
  answer?: InputMaybe<Scalars['Boolean']['input']>;
  attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  channelType: ChannelType;
  content?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  phones?: InputMaybe<Array<Scalars['String']['input']>>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  status: ConversationStatus;
  structuredType?: InputMaybe<MeccaConversationStructuredTypeValueInput>;
};

export type CreateRoleInput = {
  name: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']>;
};

export type CreateStandbyInput = {
  crmContactIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  from: StandbyHoursInput;
  notifyChannels?: InputMaybe<Array<StandbyNotifyChannels>>;
  to: StandbyHoursInput;
};

export type CreateUserInput = {
  customers: Array<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role: UserRole;
  username: Scalars['String']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  appointmentContractYn?: Maybe<Scalars['Boolean']['output']>;
  groupId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  info?: Maybe<CustomerInfo>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  platformId?: Maybe<Scalars['ID']['output']>;
};

export type CustomerAttachment = {
  __typename?: 'CustomerAttachment';
  active: Scalars['Boolean']['output'];
  attachment: Attachment;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  validFrom: Scalars['DateTime']['output'];
  validTill: Scalars['DateTime']['output'];
  version: Scalars['Float']['output'];
};

export type CustomerAttachmentFilter = {
  ids: Array<Scalars['Int']['input']>;
};

export type CustomerAttachmentVersion = {
  __typename?: 'CustomerAttachmentVersion';
  active: Scalars['Boolean']['output'];
  attachment: Attachment;
  id: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  validFrom: Scalars['DateTime']['output'];
  validTill: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

export type CustomerAttachmentWithVersions = {
  __typename?: 'CustomerAttachmentWithVersions';
  active: Scalars['Boolean']['output'];
  attachment: Attachment;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  validFrom: Scalars['DateTime']['output'];
  validTill: Scalars['DateTime']['output'];
  version: Scalars['Float']['output'];
  versions: Array<CustomerAttachmentVersion>;
};

export type CustomerAttachmentsResult = {
  __typename?: 'CustomerAttachmentsResult';
  count: Scalars['Int']['output'];
  items: Array<CustomerAttachmentWithVersions>;
};

export type CustomerChatData = {
  __typename?: 'CustomerChatData';
  customerId: Scalars['ID']['output'];
  extension: Scalars['Float']['output'];
  guid: Scalars['String']['output'];
  mainFicheId: Scalars['ID']['output'];
  serviceGroup: Scalars['String']['output'];
  userEmail: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

export type CustomerContactInformation = {
  __typename?: 'CustomerContactInformation';
  address?: Maybe<Address>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  mobilePhoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumber1?: Maybe<Scalars['String']['output']>;
  phoneNumber2?: Maybe<Scalars['String']['output']>;
  type: CustomerContactInformationTypes;
  website?: Maybe<Scalars['String']['output']>;
};

export type CustomerContactInformationInput = {
  address?: InputMaybe<AddressInput>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  mobilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber1?: InputMaybe<Scalars['String']['input']>;
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  type: CustomerContactInformationTypes;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** The different types of customer contact information */
export enum CustomerContactInformationTypes {
  Business_1 = 'BUSINESS_1',
  Business_2 = 'BUSINESS_2',
  Private_1 = 'PRIVATE_1',
  Private_2 = 'PRIVATE_2',
}

export type CustomerCrmContact = {
  __typename?: 'CustomerCrmContact';
  addresses?: Maybe<Array<CustomerCrmContactAddress>>;
  communications?: Maybe<Array<CustomerCrmContactCommunication>>;
  firstName?: Maybe<Scalars['String']['output']>;
  functionName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<CustomerCrmContactGroupRelation>>;
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  sex?: Maybe<CustomerCrmContactSexes>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CustomerCrmContactAddress = {
  __typename?: 'CustomerCrmContactAddress';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
};

export type CustomerCrmContactAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerCrmContactCommunication = {
  __typename?: 'CustomerCrmContactCommunication';
  description?: Maybe<Scalars['String']['output']>;
  forwardCondition?: Maybe<Scalars['String']['output']>;
  forwardStatus: CustomerCrmContactCommunicationStatusses;
  passThroughCondition?: Maybe<Scalars['String']['output']>;
  passThroughStatus: CustomerCrmContactCommunicationStatusses;
  sequence?: Maybe<Scalars['Int']['output']>;
  type: CustomerCrmContactCommunicationType;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomerCrmContactCommunicationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  forwardCondition?: InputMaybe<Scalars['String']['input']>;
  forwardStatus?: InputMaybe<CustomerCrmContactCommunicationStatusses>;
  passThroughCondition?: InputMaybe<Scalars['String']['input']>;
  passThroughStatus?: InputMaybe<CustomerCrmContactCommunicationStatusses>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  typeId: Scalars['Int']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/** The different types of customer crm contact communication statusses */
export enum CustomerCrmContactCommunicationStatusses {
  Always = 'ALWAYS',
  Never = 'NEVER',
  UnderConditions = 'UNDER_CONDITIONS',
}

export type CustomerCrmContactCommunicationType = {
  __typename?: 'CustomerCrmContactCommunicationType';
  category: CustomerCrmContactCommunicationTypeCategories;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** The different types of customer crm contact communication categories */
export enum CustomerCrmContactCommunicationTypeCategories {
  Email = 'EMAIL',
  Fax = 'FAX',
  Landline = 'LANDLINE',
  Mobile = 'MOBILE',
  None = 'NONE',
}

export type CustomerCrmContactCommunicationTypeFilter = {
  ids: Array<Scalars['Int']['input']>;
};

export type CustomerCrmContactCommunicationTypesResult = {
  __typename?: 'CustomerCrmContactCommunicationTypesResult';
  count: Scalars['Int']['output'];
  items: Array<CustomerCrmContactCommunicationType>;
};

export type CustomerCrmContactFilter = {
  communicationValueSearch?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CustomerCrmContactGroup = {
  __typename?: 'CustomerCrmContactGroup';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  subGroups?: Maybe<Array<CustomerCrmContactSubGroup>>;
};

export type CustomerCrmContactGroupFilter = {
  ids: Array<Scalars['Int']['input']>;
};

export type CustomerCrmContactGroupRelation = {
  __typename?: 'CustomerCrmContactGroupRelation';
  group: CustomerCrmContactGroup;
  groupId: Scalars['Int']['output'];
  subGroup: CustomerCrmContactSubGroup;
  subGroupId: Scalars['Int']['output'];
};

export type CustomerCrmContactGroupRelationInput = {
  groupId: Scalars['Int']['input'];
  subGroupId: Scalars['Int']['input'];
};

export type CustomerCrmContactGroupsResult = {
  __typename?: 'CustomerCrmContactGroupsResult';
  count: Scalars['Int']['output'];
  items: Array<CustomerCrmContactGroup>;
};

/** The different types of customer crm contact genders */
export enum CustomerCrmContactSexes {
  Female = 'FEMALE',
  Male = 'MALE',
}

export type CustomerCrmContactSubGroup = {
  __typename?: 'CustomerCrmContactSubGroup';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CustomerCrmContactsResult = {
  __typename?: 'CustomerCrmContactsResult';
  count: Scalars['Int']['output'];
  items: Array<CustomerCrmContact>;
};

export type CustomerFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CustomerFixedInstruction = {
  __typename?: 'CustomerFixedInstruction';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerFixedInstructionFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CustomerFixedInstructionsResult = {
  __typename?: 'CustomerFixedInstructionsResult';
  count: Scalars['Int']['output'];
  items: Array<CustomerFixedInstruction>;
};

export type CustomerInfo = {
  __typename?: 'CustomerInfo';
  contactInformationList: Array<CustomerContactInformation>;
  welcomeMessage?: Maybe<Scalars['String']['output']>;
};

export type CustomerInfoInput = {
  contactInformationList: Array<CustomerContactInformationInput>;
};

export type CustomerLocation = {
  __typename?: 'CustomerLocation';
  agentSideRotation?: Maybe<Scalars['Float']['output']>;
  clientSideRotation?: Maybe<Scalars['Float']['output']>;
  clientSideRotationInputStream?: Maybe<Scalars['Float']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type CustomerLocationInput = {
  agentSideRotation?: InputMaybe<Scalars['Float']['input']>;
  clientSideRotation?: InputMaybe<Scalars['Float']['input']>;
  clientSideRotationInputStream?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerScreenColors = {
  __typename?: 'CustomerScreenColors';
  background: Scalars['String']['output'];
  buttonsBackground: Scalars['String']['output'];
  buttonsText: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type CustomerScreenColorsInput = {
  background?: InputMaybe<Scalars['String']['input']>;
  buttonsBackground?: InputMaybe<Scalars['String']['input']>;
  buttonsText?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerScreenLocale = {
  __typename?: 'CustomerScreenLocale';
  content: Array<TextByLanguage>;
  type: Scalars['String']['output'];
};

export type CustomerScreenLocaleInput = {
  content?: InputMaybe<Array<TextByLanguageInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerTemporaryInstruction = {
  __typename?: 'CustomerTemporaryInstruction';
  active: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  createdInMeCCA: Scalars['Boolean']['output'];
  deleted: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  validFrom: Scalars['DateTime']['output'];
  validUntil: Scalars['DateTime']['output'];
};

export type CustomerTemporaryInstructionFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  type: InstructionTypes;
};

export type CustomerTemporaryInstructionsResult = {
  __typename?: 'CustomerTemporaryInstructionsResult';
  count: Scalars['Int']['output'];
  items: Array<CustomerTemporaryInstruction>;
};

export type CustomersResult = {
  __typename?: 'CustomersResult';
  count: Scalars['Int']['output'];
  items: Array<Customer>;
};

export type Dashboard = {
  __typename?: 'Dashboard';
  invoices: DashboardInvoice;
  meccaConversations: DashboardConversation;
  notifications: NotificationsResult;
  socialConversations: DashboardConversation;
};

export type DashboardNotificationsArgs = {
  filter?: InputMaybe<NotificationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type DashboardConversation = {
  __typename?: 'DashboardConversation';
  countsByStatus: Array<DashboardConversationStatus>;
  total: Scalars['Int']['output'];
};

export type DashboardConversationStatus = {
  __typename?: 'DashboardConversationStatus';
  status: ConversationStatus;
  total: Scalars['Int']['output'];
};

export type DashboardInvoice = {
  __typename?: 'DashboardInvoice';
  current?: Maybe<Scalars['Float']['output']>;
  open: Scalars['Int']['output'];
};

/** The different types of day/night calls */
export enum DayNightCallTypes {
  Day = 'DAY',
  Night = 'NIGHT',
}

export type DefaultLocale = {
  __typename?: 'DefaultLocale';
  content: Array<Content>;
  type: TextLocation;
};

export type DownloadResult = {
  __typename?: 'DownloadResult';
  content: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type DurationTimeReporting = CallBaseReporting & {
  __typename?: 'DurationTimeReporting';
  averageDuration: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  totalNrOfCalls: Scalars['Int']['output'];
  xAxisTitle: Scalars['String']['output'];
  xAxisValues: Array<Scalars['String']['output']>;
  yAxisTitle: Scalars['String']['output'];
  yAxisValues: Array<Scalars['Float']['output']>;
};

export type EditMeccaConversationInputModel = {
  content?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  messageId: Scalars['ID']['input'];
  phones?: InputMaybe<Array<Scalars['String']['input']>>;
  structuredType?: InputMaybe<MeccaConversationStructuredTypeValueInput>;
};

export type EventModel = {
  eventTime: Scalars['DateTime']['output'];
  type: EventTypes;
};

/** The different types of events */
export enum EventTypes {
  ConversationArchived = 'ConversationArchived',
  ConversationClosed = 'ConversationClosed',
  ConversationCreated = 'ConversationCreated',
  ConversationFlagged = 'ConversationFlagged',
  ConversationForwarded = 'ConversationForwarded',
  ConversationPriorityChanged = 'ConversationPriorityChanged',
  ConversationReaded = 'ConversationReaded',
  ConversationStatusChanged = 'ConversationStatusChanged',
  ConversationUnflagged = 'ConversationUnflagged',
  ConversationUpdated = 'ConversationUpdated',
}

export type FilterInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterMeccaConversationInputModel = {
  channelType?: InputMaybe<Array<ChannelType>>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  idAssignedTo?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  inboxType?: InputMaybe<Scalars['String']['input']>;
  priorityFrom?: InputMaybe<Scalars['Int']['input']>;
  priorityTill?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  statusses?: InputMaybe<Array<ConversationStatus>>;
  till?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ForwardConversationAgentMessage = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  phones?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Image = {
  __typename?: 'Image';
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** The different types of invoices */
export enum InstructionTypes {
  Active = 'ACTIVE',
  Future = 'FUTURE',
  Inactive = 'INACTIVE',
}

export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['Float']['output'];
  attachment?: Maybe<Attachment>;
  date: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  invoiceNr: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  paid: Scalars['Boolean']['output'];
  type: InvoiceTypes;
  year: Scalars['Int']['output'];
};

export type InvoiceFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The different types of invoices */
export enum InvoiceTypes {
  CreditNota = 'CREDIT_NOTA',
  Invoice = 'INVOICE',
}

export type InvoicesResult = {
  __typename?: 'InvoicesResult';
  count: Scalars['Int']['output'];
  items: Array<Invoice>;
};

export enum LangEnum {
  De = 'de',
  En = 'en',
  Fr = 'fr',
  Nl = 'nl',
}

export enum Language {
  De = 'DE',
  En = 'EN',
  Fr = 'FR',
  Nl = 'NL',
}

export type Location = {
  __typename?: 'Location';
  address?: Maybe<LocationAddress>;
  agentSideRotation?: Maybe<Scalars['Float']['output']>;
  clientSideRotation?: Maybe<Scalars['Float']['output']>;
  clientSideRotationInputStream?: Maybe<Scalars['Float']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LocationAddress = {
  __typename?: 'LocationAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
};

export type MeccaBlankConversationModel = MeccaConversationModel & {
  __typename?: 'MeccaBlankConversationModel';
  assignedToUsers?: Maybe<Array<AssignedUser>>;
  attachments?: Maybe<Array<MessageAttachmentModel>>;
  channel?: Maybe<PairedChannel>;
  channelType: ChannelType;
  channelsActive: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  events: Array<EventModel>;
  flagged?: Maybe<Scalars['Boolean']['output']>;
  htmlBodyText?: Maybe<Scalars['String']['output']>;
  htmlMessage?: Maybe<Scalars['String']['output']>;
  htmlStructuredMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastMessageTime: Scalars['DateTime']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  participants: Array<MeccaConversationParticipant>;
  priority: Scalars['Float']['output'];
  read: Scalars['Boolean']['output'];
  related: Array<MeccaConversationModel>;
  status: ConversationStatus;
  unformattedBodyText?: Maybe<Scalars['String']['output']>;
  unformattedText?: Maybe<Scalars['String']['output']>;
};

export type MeccaConversationModel = {
  assignedToUsers?: Maybe<Array<AssignedUser>>;
  attachments?: Maybe<Array<MessageAttachmentModel>>;
  channelType: ChannelType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  events: Array<EventModel>;
  flagged?: Maybe<Scalars['Boolean']['output']>;
  htmlBodyText?: Maybe<Scalars['String']['output']>;
  htmlMessage?: Maybe<Scalars['String']['output']>;
  htmlStructuredMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastMessageTime: Scalars['DateTime']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  participants: Array<MeccaConversationParticipant>;
  priority: Scalars['Float']['output'];
  read: Scalars['Boolean']['output'];
  related: Array<MeccaConversationModel>;
  status: ConversationStatus;
  unformattedBodyText?: Maybe<Scalars['String']['output']>;
  unformattedText?: Maybe<Scalars['String']['output']>;
};

export type MeccaConversationParticipant = {
  __typename?: 'MeccaConversationParticipant';
  channel: ChannelType;
  channelId: Scalars['ID']['output'];
  destination: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type MeccaConversationResultModel = {
  __typename?: 'MeccaConversationResultModel';
  count: Scalars['Int']['output'];
  items: Array<MeccaConversationModel>;
};

export type MeccaConversationStructuredTypeValueFieldValueInput = {
  label: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MeccaConversationStructuredTypeValueInput = {
  fieldValues: Array<MeccaConversationStructuredTypeValueFieldValueInput>;
  name: Scalars['String']['input'];
};

export type MeccaTextConversationModel = MeccaConversationModel & {
  __typename?: 'MeccaTextConversationModel';
  agentMessages: Array<AgentMessageResult>;
  assignedToUsers?: Maybe<Array<AssignedUser>>;
  attachments?: Maybe<Array<MessageAttachmentModel>>;
  canSendResponse?: Maybe<Scalars['Boolean']['output']>;
  channel?: Maybe<PairedChannel>;
  channelType: ChannelType;
  channelsActive: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  events: Array<EventModel>;
  flagged?: Maybe<Scalars['Boolean']['output']>;
  htmlBodyText?: Maybe<Scalars['String']['output']>;
  htmlMessage?: Maybe<Scalars['String']['output']>;
  htmlStructuredMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastMessageTime: Scalars['DateTime']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  messages: Array<Message>;
  multipleResponsesTill?: Maybe<Scalars['DateTime']['output']>;
  participants: Array<MeccaConversationParticipant>;
  preview?: Maybe<MeccaTextConversationPreviewModel>;
  priority: Scalars['Float']['output'];
  read: Scalars['Boolean']['output'];
  related: Array<MeccaConversationModel>;
  status: ConversationStatus;
  unformattedBodyText?: Maybe<Scalars['String']['output']>;
  unformattedText?: Maybe<Scalars['String']['output']>;
};

export type MeccaTextConversationPreviewModel = {
  type: TextConversationPreviewTypes;
};

export type MeccaTextConversationPreviewModelTextAndAttachments =
  MeccaTextConversationPreviewModel & {
    __typename?: 'MeccaTextConversationPreviewModelTextAndAttachments';
    attachments?: Maybe<Array<Attachment>>;
    content?: Maybe<Scalars['String']['output']>;
    messageTime: Scalars['DateTime']['output'];
    type: TextConversationPreviewTypes;
  };

export type MeccaTextConversationPreviewModelTextAndAttachmentsWithStructuredMessage =
  MeccaTextConversationPreviewModel & {
    __typename?: 'MeccaTextConversationPreviewModelTextAndAttachmentsWithStructuredMessage';
    attachments?: Maybe<Array<Attachment>>;
    content?: Maybe<Scalars['String']['output']>;
    messageTime: Scalars['DateTime']['output'];
    structuredMessage?: Maybe<AgentMessageStructuredMessage>;
    type: TextConversationPreviewTypes;
  };

export type MeccaVideoConversationModel = MeccaConversationModel & {
  __typename?: 'MeccaVideoConversationModel';
  assignedToUsers?: Maybe<Array<AssignedUser>>;
  attachments?: Maybe<Array<MessageAttachmentModel>>;
  callId: Scalars['String']['output'];
  channelType: ChannelType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  events: Array<EventModel>;
  flagged?: Maybe<Scalars['Boolean']['output']>;
  htmlBodyText?: Maybe<Scalars['String']['output']>;
  htmlMessage?: Maybe<Scalars['String']['output']>;
  htmlStructuredMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastMessageTime: Scalars['DateTime']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  participants: Array<MeccaConversationParticipant>;
  priority: Scalars['Float']['output'];
  read: Scalars['Boolean']['output'];
  redirected: Scalars['Boolean']['output'];
  related: Array<MeccaConversationModel>;
  status: ConversationStatus;
  unformattedBodyText?: Maybe<Scalars['String']['output']>;
  unformattedText?: Maybe<Scalars['String']['output']>;
  videoUrl: Scalars['String']['output'];
};

export type Message = {
  __typename?: 'Message';
  attachments?: Maybe<Array<Attachment>>;
  channelType: ChannelType;
  content?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['ID']['output'];
  destination: Scalars['String']['output'];
  eventTime: Scalars['DateTime']['output'];
  external?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  messageTime: Scalars['DateTime']['output'];
  sender: User;
  serviceId: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type MessageAttachmentModel = {
  __typename?: 'MessageAttachmentModel';
  dateTimeAdded?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileTypeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MissedCallsReporting = CallBaseReporting & {
  __typename?: 'MissedCallsReporting';
  averageWaitingTime: Scalars['Float']['output'];
  canBeDisplayed?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  totalNrOfCalls: Scalars['Int']['output'];
  xAxisTitle: Scalars['String']['output'];
  xAxisValues: Array<Scalars['String']['output']>;
  yAxisTitle: Scalars['String']['output'];
  yAxisValues: Array<Scalars['Float']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateChannel: MutationResult;
  addMeccaConversationAgentMessage: MutationResult;
  addMeccaMessageAttachment: Scalars['Boolean']['output'];
  answerVideoCall: VideoCallInfo;
  assignMeccaMessage: Scalars['Boolean']['output'];
  assignSocialConversation: Scalars['Boolean']['output'];
  bulkUpdateMeccaConversations: Array<MeccaConversationModel>;
  bulkUpdateSocialConversations: Array<SocialConversationModel>;
  createCustomerAttachment: CustomerAttachment;
  createCustomerCrmContact: CustomerCrmContact;
  createCustomerTemporaryInstruction: CustomerTemporaryInstruction;
  createMeccaConversation: MeccaConversationModel;
  createRole: Role;
  createStandby: Standby;
  createUser: User;
  createVideoCallSettings: VideoCallSettings;
  deactivateChannel: MutationResult;
  deleteCustomerAttachment: MutationResult;
  deleteCustomerCrmContact: MutationResult;
  deleteCustomerTemporaryInstruction: MutationResult;
  deleteRole: Role;
  deleteStandby: MutationResult;
  deleteUser: MutationResult;
  editMeccaConversation: MeccaConversationModel;
  endVideoCall: MutationResult;
  forwardMeccaConversationAgentMessage: MutationResult;
  forwardMeccaConversationsAgent: MutationResult;
  initiateVideoCall: VideoCallInfoTask;
  pairChannel: PairedChannel;
  payInvoice: PayInvoiceResult;
  registerWebpush: MutationResult;
  removeMeccaMessageAttachment: Scalars['Boolean']['output'];
  removeScheduledVideoCall: MutationResult;
  removeSocialConversationAttachment: Scalars['Boolean']['output'];
  restoreChannel: MutationResult;
  sendContactRequest: MutationResult;
  sendSocialConversationText: MutationResult;
  unpairChannel: MutationResult;
  updateChannel: PairedChannel;
  updateCurrentUserLocale: Scalars['Boolean']['output'];
  updateCustomer: Customer;
  updateCustomerAttachment: CustomerAttachment;
  updateCustomerCrmContact: CustomerCrmContact;
  updateCustomerTemporaryInstruction: CustomerTemporaryInstruction;
  updateMeccaConversation: MeccaConversationModel;
  updateRole: Role;
  updateSocialConversation: SocialConversationModel;
  updateStandby: Standby;
  updateUser: User;
  updateUserStatus: UserStatus;
  updateVideoCallSettings: VideoCallSettings;
  updateVideoCallSettingsLocation: VideoCallSettings;
  withdrawMeccaMessage: Scalars['Boolean']['output'];
  withdrawSocialConversation: Scalars['Boolean']['output'];
};

export type MutationActivateChannelArgs = {
  id: Scalars['ID']['input'];
};

export type MutationAddMeccaConversationAgentMessageArgs = {
  agentMessageId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  input: AddConversationAgentMessage;
};

export type MutationAddMeccaMessageAttachmentArgs = {
  input: AddMeccaMessageAttachmentInputModel;
};

export type MutationAnswerVideoCallArgs = {
  callId: Scalars['ID']['input'];
};

export type MutationAssignMeccaMessageArgs = {
  input: AssignMeccaMessageInputModel;
};

export type MutationAssignSocialConversationArgs = {
  input: AssignSocialConversationInputModel;
};

export type MutationBulkUpdateMeccaConversationsArgs = {
  ids: Array<Scalars['ID']['input']>;
  input: UpdateMeccaConversationInputModel;
};

export type MutationBulkUpdateSocialConversationsArgs = {
  ids: Array<Scalars['ID']['input']>;
  input: UpdateSocialConversationInputModel;
};

export type MutationCreateCustomerAttachmentArgs = {
  input: CreateCustomerAttachmentInput;
};

export type MutationCreateCustomerCrmContactArgs = {
  input: CreateCustomerCrmContactInput;
};

export type MutationCreateCustomerTemporaryInstructionArgs = {
  input: CreateCustomerTemporaryInstructionInput;
};

export type MutationCreateMeccaConversationArgs = {
  input: CreateMeccaConversationInputModel;
};

export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};

export type MutationCreateStandbyArgs = {
  input: CreateStandbyInput;
};

export type MutationCreateUserArgs = {
  input: CreateUserInput;
};

export type MutationCreateVideoCallSettingsArgs = {
  input: VideoCallSettingsInput;
};

export type MutationDeactivateChannelArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCustomerAttachmentArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteCustomerCrmContactArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteCustomerTemporaryInstructionArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteRoleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteStandbyArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationEditMeccaConversationArgs = {
  input: EditMeccaConversationInputModel;
};

export type MutationEndVideoCallArgs = {
  callId: Scalars['ID']['input'];
  customerId?: InputMaybe<Scalars['ID']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  taskSid?: InputMaybe<Scalars['String']['input']>;
};

export type MutationForwardMeccaConversationAgentMessageArgs = {
  agentMessageId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  input: ForwardConversationAgentMessage;
};

export type MutationForwardMeccaConversationsAgentArgs = {
  input: ForwardConversationAgentMessage;
  messagesIds: Array<Scalars['ID']['input']>;
};

export type MutationInitiateVideoCallArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationPairChannelArgs = {
  input: PairChannelInput;
};

export type MutationPayInvoiceArgs = {
  id: Scalars['Int']['input'];
};

export type MutationRegisterWebpushArgs = {
  input: RegisterWebPushInput;
};

export type MutationRemoveMeccaMessageAttachmentArgs = {
  input: RemoveMeccaMessageAttachmentInputModel;
};

export type MutationRemoveScheduledVideoCallArgs = {
  callId: Scalars['ID']['input'];
  customerId?: InputMaybe<Scalars['ID']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationRemoveSocialConversationAttachmentArgs = {
  input: RemoveSocialMessageAttachmentInputModel;
};

export type MutationRestoreChannelArgs = {
  id: Scalars['ID']['input'];
};

export type MutationSendContactRequestArgs = {
  input: CreateContactRequestInput;
};

export type MutationSendSocialConversationTextArgs = {
  id: Scalars['ID']['input'];
  input: SendConversationTextInput;
};

export type MutationUnpairChannelArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUpdateChannelArgs = {
  id: Scalars['ID']['input'];
  input: PairedChannelUpdateInput;
};

export type MutationUpdateCurrentUserLocaleArgs = {
  locale: Scalars['String']['input'];
};

export type MutationUpdateCustomerArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCustomerInput;
};

export type MutationUpdateCustomerAttachmentArgs = {
  id: Scalars['Int']['input'];
  input: UpdateCustomerAttachmentInput;
};

export type MutationUpdateCustomerCrmContactArgs = {
  id: Scalars['Int']['input'];
  input: UpdateCustomerCrmContactInput;
};

export type MutationUpdateCustomerTemporaryInstructionArgs = {
  id: Scalars['Int']['input'];
  input: UpdateCustomerTemporaryInstructionInput;
};

export type MutationUpdateMeccaConversationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMeccaConversationInputModel;
};

export type MutationUpdateRoleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRoleInput;
};

export type MutationUpdateSocialConversationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSocialConversationInputModel;
};

export type MutationUpdateStandbyArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStandbyInput;
};

export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
};

export type MutationUpdateUserStatusArgs = {
  input: UpdateUserStatusInput;
};

export type MutationUpdateVideoCallSettingsArgs = {
  input: VideoCallSettingsInput;
};

export type MutationUpdateVideoCallSettingsLocationArgs = {
  input: UpdateVideoCallSettingsLocationInput;
};

export type MutationWithdrawMeccaMessageArgs = {
  input: WithdrawMeccaMessageInputModel;
};

export type MutationWithdrawSocialConversationArgs = {
  input: WithdrawSocialConversationInputModel;
};

export type MutationResult = {
  __typename?: 'MutationResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Notification = {
  date: Scalars['DateTime']['output'];
  type: NotificationTypes;
};

export type NotificationConversation = Notification & {
  __typename?: 'NotificationConversation';
  conversation: SocialConversationModel;
  conversationId: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  status: ConversationStatus;
  type: NotificationTypes;
};

export type NotificationFilter = {
  types: Array<NotificationTypes>;
};

export type NotificationInvoice = Notification & {
  __typename?: 'NotificationInvoice';
  amount: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  invoice: Invoice;
  type: NotificationTypes;
};

/** The different types of notifications */
export enum NotificationTypes {
  Conversation = 'CONVERSATION',
  Invoice = 'INVOICE',
}

export type NotificationsResult = {
  __typename?: 'NotificationsResult';
  count: Scalars['Int']['output'];
  items: Array<Notification>;
};

export type NrOfCallsPerHourReporting = CallBaseReporting & {
  __typename?: 'NrOfCallsPerHourReporting';
  title: Scalars['String']['output'];
  totalNrOfCalls: Scalars['Int']['output'];
  xAxisTitle: Scalars['String']['output'];
  xAxisValues: Array<Scalars['String']['output']>;
  yAxisTitle: Scalars['String']['output'];
  yAxisValues: Array<Scalars['Float']['output']>;
};

export type PairChannelFacebookInput = {
  accessToken: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};

export type PairChannelInput = {
  channelIdentifier: Scalars['String']['input'];
  facebook?: InputMaybe<PairChannelFacebookInput>;
  twitter?: InputMaybe<PairChannelTwitterInput>;
  type: ChannelType;
  whatsapp?: InputMaybe<PairChannelWhatsappInput>;
};

export type PairChannelTwitterInput = {
  forUserId: Scalars['String']['input'];
};

export type PairChannelWhatsappInput = {
  number: Scalars['String']['input'];
};

export type PairedChannel = {
  account: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  channelIdentifier?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  redirect?: Maybe<Scalars['Boolean']['output']>;
  redirectDelay?: Maybe<Scalars['Int']['output']>;
  type: ChannelType;
};

export type PairedChannelBlank = PairedChannel & {
  __typename?: 'PairedChannelBlank';
  account: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  channelIdentifier?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  redirect?: Maybe<Scalars['Boolean']['output']>;
  redirectDelay?: Maybe<Scalars['Int']['output']>;
  type: ChannelType;
};

export type PairedChannelFacebook = PairedChannel & {
  __typename?: 'PairedChannelFacebook';
  account: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  channelIdentifier?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  pageId: Scalars['String']['output'];
  redirect?: Maybe<Scalars['Boolean']['output']>;
  redirectDelay?: Maybe<Scalars['Int']['output']>;
  type: ChannelType;
};

export type PairedChannelFilterInput = {
  account?: InputMaybe<Scalars['ID']['input']>;
  channelIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type PairedChannelTwitter = PairedChannel & {
  __typename?: 'PairedChannelTwitter';
  account: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  channelIdentifier?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  forUserId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  redirect?: Maybe<Scalars['Boolean']['output']>;
  redirectDelay?: Maybe<Scalars['Int']['output']>;
  type: ChannelType;
};

export type PairedChannelUpdateInput = {
  channelIdentifier?: InputMaybe<Scalars['String']['input']>;
  redirect?: InputMaybe<Scalars['Boolean']['input']>;
  redirectDelay?: InputMaybe<Scalars['Int']['input']>;
};

export type PairedChannelVideo = PairedChannel & {
  __typename?: 'PairedChannelVideo';
  account: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  channelIdentifier?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  redirect?: Maybe<Scalars['Boolean']['output']>;
  redirectDelay?: Maybe<Scalars['Int']['output']>;
  type: ChannelType;
};

export type PairedChannelWhatsapp = PairedChannel & {
  __typename?: 'PairedChannelWhatsapp';
  account: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  channelIdentifier?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  redirect?: Maybe<Scalars['Boolean']['output']>;
  redirectDelay?: Maybe<Scalars['Int']['output']>;
  type: ChannelType;
};

export type PairedChannelsResult = {
  __typename?: 'PairedChannelsResult';
  count: Scalars['Int']['output'];
  items: Array<PairedChannel>;
};

export type PayInvoiceResult = {
  __typename?: 'PayInvoiceResult';
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type PropertySearch = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  search: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  agentsStatus: AgentsStatusResponse;
  callReporting?: Maybe<CallReportingResult>;
  checkConversationLocked: Scalars['Boolean']['output'];
  conversationStructuredTypes: ConversationStructuredTypesResult;
  countries: CountriesResult;
  customer: Customer;
  customerAttachments: CustomerAttachmentsResult;
  customerChatData: CustomerChatData;
  customerCrmContactCommunicationTypes: CustomerCrmContactCommunicationTypesResult;
  customerCrmContactGroups: CustomerCrmContactGroupsResult;
  customerCrmContacts: CustomerCrmContactsResult;
  customerFixedInstructions: CustomerFixedInstructionsResult;
  customerTemporaryInstructions: CustomerTemporaryInstructionsResult;
  customers: CustomersResult;
  dashboard: Dashboard;
  defaultLocale: Array<DefaultLocale>;
  downloadIncomingCallReporting: DownloadResult;
  downloadOutgoingCallReporting: DownloadResult;
  downloadVideoCallReporting: DownloadResult;
  getCurrentCommunicationCompany: CompanyResultModel;
  getCurrentCompany: CompanyResultModel;
  getCurrentUser: User;
  incomingCalls: Array<CallResult>;
  invoices: InvoicesResult;
  logout: Scalars['Boolean']['output'];
  meccaConversation: MeccaConversationModel;
  meccaConversations: MeccaConversationResultModel;
  meccaConversationsByFilter: Array<MeccaConversationModel>;
  outgoingCalls: Array<CallResult>;
  pairedChannels: PairedChannelsResult;
  roles: RolesResult;
  search: SearchResult;
  sessionCustomer: Customer;
  socialConversation: SocialConversationModel;
  socialConversations: SocialConversationsResultModel;
  standby: StandbysResult;
  theme: Theme;
  user: User;
  userStatus: UserStatus;
  users: UsersResult;
  videoCall: VideoCall;
  videoCallReporting: VideoCallReportingResult;
  videoCallSettings?: Maybe<VideoCallSettings>;
  videoCalls: VideoCallResult;
};

export type QueryAgentsStatusArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCallReportingArgs = {
  filter?: InputMaybe<FilterInput>;
};

export type QueryCheckConversationLockedArgs = {
  agentMessageId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
};

export type QueryConversationStructuredTypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryCountriesArgs = {
  filter?: InputMaybe<CountryFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryCustomerArgs = {
  filter?: InputMaybe<CustomerFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<PropertySearch>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryCustomerAttachmentsArgs = {
  filter?: InputMaybe<CustomerAttachmentFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryCustomerCrmContactCommunicationTypesArgs = {
  filter?: InputMaybe<CustomerCrmContactCommunicationTypeFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryCustomerCrmContactGroupsArgs = {
  filter?: InputMaybe<CustomerCrmContactGroupFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryCustomerCrmContactsArgs = {
  filter?: InputMaybe<CustomerCrmContactFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryCustomerFixedInstructionsArgs = {
  filter?: InputMaybe<CustomerFixedInstructionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryCustomerTemporaryInstructionsArgs = {
  filter?: InputMaybe<CustomerTemporaryInstructionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryCustomersArgs = {
  filter?: InputMaybe<CustomerFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<PropertySearch>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryDownloadIncomingCallReportingArgs = {
  filter?: InputMaybe<FilterInput>;
  lang?: InputMaybe<LangEnum>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryDownloadOutgoingCallReportingArgs = {
  filter?: InputMaybe<FilterInput>;
  lang?: InputMaybe<LangEnum>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryDownloadVideoCallReportingArgs = {
  filter?: InputMaybe<FilterInput>;
  lang?: InputMaybe<LangEnum>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryIncomingCallsArgs = {
  filter?: InputMaybe<CallFilterInput>;
  ignoreLimitOffset?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryInvoicesArgs = {
  filter?: InputMaybe<InvoiceFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryMeccaConversationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryMeccaConversationsArgs = {
  filter?: InputMaybe<FilterMeccaConversationInputModel>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortOrder>;
};

export type QueryMeccaConversationsByFilterArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  till?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryOutgoingCallsArgs = {
  filter?: InputMaybe<CallFilterInput>;
  ignoreLimitOffset?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryPairedChannelsArgs = {
  filter?: InputMaybe<PairedChannelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryRolesArgs = {
  filter?: InputMaybe<RolesFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QuerySearchArgs = {
  filter?: InputMaybe<SearchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QuerySocialConversationArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySocialConversationsArgs = {
  filter?: InputMaybe<SocialConversationFilterModel>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortOrder>;
};

export type QueryStandbyArgs = {
  filter?: InputMaybe<StandbyFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};

export type QueryUsersArgs = {
  filter?: InputMaybe<UsersFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryVideoCallArgs = {
  callId: Scalars['ID']['input'];
};

export type QueryVideoCallReportingArgs = {
  filter?: InputMaybe<FilterInput>;
};

export type QueryVideoCallSettingsArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryVideoCallsArgs = {
  filter?: InputMaybe<VideoCallFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type RegisterWebPushInput = {
  endpoint: Scalars['String']['input'];
  keys: WebPushKeysInput;
};

export type RemoveMeccaMessageAttachmentInputModel = {
  attachmentId: Scalars['Float']['input'];
  messageId: Scalars['Float']['input'];
};

export type RemoveSocialMessageAttachmentInputModel = {
  attachmentUrl: Scalars['String']['input'];
  conversationId: Scalars['String']['input'];
};

export type Role = {
  __typename?: 'Role';
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
};

export type RolesFilterInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type RolesResult = {
  __typename?: 'RolesResult';
  count: Scalars['Int']['output'];
  items: Array<Role>;
};

export type Search = {
  type: SearchTypes;
};

export type SearchAgentMessage = Search & {
  __typename?: 'SearchAgentMessage';
  agentMessage?: Maybe<AgentMessage>;
  type: SearchTypes;
};

export type SearchAttachment = Search & {
  __typename?: 'SearchAttachment';
  attachment?: Maybe<Attachment>;
  type: SearchTypes;
};

export type SearchCustomerCrmContact = Search & {
  __typename?: 'SearchCustomerCrmContact';
  customerCrmContact?: Maybe<CustomerCrmContact>;
  type: SearchTypes;
};

export type SearchCustomerFixedInstruction = Search & {
  __typename?: 'SearchCustomerFixedInstruction';
  customerFixedInstruction?: Maybe<CustomerFixedInstruction>;
  type: SearchTypes;
};

export type SearchCustomerTemporaryInstruction = Search & {
  __typename?: 'SearchCustomerTemporaryInstruction';
  customerTemporaryInstruction?: Maybe<CustomerTemporaryInstruction>;
  type: SearchTypes;
};

export type SearchFilterInput = {
  types?: InputMaybe<Array<SearchTypes>>;
};

export type SearchMessage = Search & {
  __typename?: 'SearchMessage';
  message?: Maybe<Message>;
  type: SearchTypes;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  count: Scalars['Int']['output'];
  countByType: Array<SearchTypeCount>;
  items: Array<Search>;
};

export type SearchTypeCount = {
  __typename?: 'SearchTypeCount';
  count: Scalars['Int']['output'];
  type: SearchTypes;
};

/** The different types of search */
export enum SearchTypes {
  Agentmessage = 'AGENTMESSAGE',
  Attachment = 'ATTACHMENT',
  CustomerCrmContact = 'CUSTOMER_CRM_CONTACT',
  CustomerFixedInstruction = 'CUSTOMER_FIXED_INSTRUCTION',
  CustomerTemporaryInstruction = 'CUSTOMER_TEMPORARY_INSTRUCTION',
  Message = 'MESSAGE',
}

export type SendConversationTextInput = {
  attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  messageTime: Scalars['DateTime']['input'];
};

export type SocialConversationFilterModel = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  channelType?: InputMaybe<Array<ChannelType>>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  idAssignedTo?: InputMaybe<Scalars['String']['input']>;
  priorityFrom?: InputMaybe<Scalars['Int']['input']>;
  priorityTill?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  statusses?: InputMaybe<Array<ConversationStatus>>;
  till?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SocialConversationModel = {
  __typename?: 'SocialConversationModel';
  archived: Scalars['Boolean']['output'];
  assignedToUsers?: Maybe<Array<Assignment>>;
  canSendResponse?: Maybe<Scalars['Boolean']['output']>;
  channel?: Maybe<PairedChannel>;
  channelType?: Maybe<ChannelType>;
  channelsActive: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  events?: Maybe<Array<EventModel>>;
  flagged: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  messages: Array<Message>;
  multipleResponsesTill?: Maybe<Scalars['DateTime']['output']>;
  participants?: Maybe<Array<SocialConversationParticipantModel>>;
  preview?: Maybe<SocialTextConversationPreviewModel>;
  priority: Scalars['Int']['output'];
  read: Scalars['Boolean']['output'];
  related?: Maybe<Array<SocialConversationModel>>;
  status?: Maybe<ConversationStatus>;
};

export type SocialConversationParticipantModel = {
  __typename?: 'SocialConversationParticipantModel';
  channel: ChannelType;
  channelId: Scalars['ID']['output'];
  destination: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type SocialConversationsResultModel = {
  __typename?: 'SocialConversationsResultModel';
  count: Scalars['Int']['output'];
  items: Array<SocialConversationModel>;
};

export type SocialTextConversationPreviewModel = {
  __typename?: 'SocialTextConversationPreviewModel';
  attachments?: Maybe<Array<Attachment>>;
  content?: Maybe<Scalars['String']['output']>;
  messageTime: Scalars['DateTime']['output'];
  type: TextConversationPreviewTypes;
};

export type SortInput = {
  field: Scalars['String']['input'];
  order: SortOrder;
};

/** ASC or DESC */
export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Standby = {
  __typename?: 'Standby';
  crmContacts?: Maybe<Array<CustomerCrmContact>>;
  from: StandbyHours;
  id: Scalars['ID']['output'];
  notifyChannels?: Maybe<Array<StandbyNotifyChannels>>;
  to: StandbyHours;
};

export type StandbyFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type StandbyHours = {
  __typename?: 'StandbyHours';
  hours: Scalars['Int']['output'];
  minutes: Scalars['Int']['output'];
};

export type StandbyHoursInput = {
  hours: Scalars['Int']['input'];
  minutes: Scalars['Int']['input'];
};

/** The different notify channels of standby */
export enum StandbyNotifyChannels {
  Email = 'EMAIL',
  Sms = 'SMS',
}

export type StandbysResult = {
  __typename?: 'StandbysResult';
  count: Scalars['Int']['output'];
  items: Array<Standby>;
};

export type Subscription = {
  __typename?: 'Subscription';
  SocialConversationBulkUpdated: Array<SocialConversationModel>;
  SocialConversationUpdated: SocialConversationModel;
  SocialNewReceivedMessage: Message;
  callNotification: VideoCallNotification;
  meccaConversationBulkUpdated: Array<MeccaTextConversationModel>;
  meccaConversationCreated: MeccaTextConversationModel;
  meccaConversationTextAdded: Message;
  meccaConversationUpdated: MeccaTextConversationModel;
  settingsUpdated: UpdateVideoCallSettingsNotification;
  socialConversationCreated: SocialConversationModel;
  userStatusUpdated: UserStatus;
};

export type SubscriptionSettingsUpdatedArgs = {
  customerId: Scalars['String']['input'];
  platformId: Scalars['String']['input'];
};

export type TextByLanguage = {
  __typename?: 'TextByLanguage';
  language: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TextByLanguageInput = {
  language?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TextConversation = Conversation & {
  __typename?: 'TextConversation';
  archived: Scalars['Boolean']['output'];
  assignedToUsers?: Maybe<Array<AssignedUser>>;
  canSendResponse?: Maybe<Scalars['Boolean']['output']>;
  channelType: ChannelType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  events: Array<EventModel>;
  flagged: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  multipleResponsesTill?: Maybe<Scalars['DateTime']['output']>;
  participants: Array<ConversationParticipant>;
  preview?: Maybe<TextConversationPreview>;
  priority: Scalars['Float']['output'];
  read: Scalars['Boolean']['output'];
  related: Array<Conversation>;
  status: ConversationStatus;
};

export type TextConversationPreview = {
  type: TextConversationPreviewTypes;
};

export type TextConversationPreviewTextAndAttachments = TextConversationPreview & {
  __typename?: 'TextConversationPreviewTextAndAttachments';
  attachments?: Maybe<Array<Attachment>>;
  content?: Maybe<Scalars['String']['output']>;
  messageTime: Scalars['DateTime']['output'];
  type: TextConversationPreviewTypes;
};

export type TextConversationPreviewTextAndAttachmentsWithStructuredMessage =
  TextConversationPreview & {
    __typename?: 'TextConversationPreviewTextAndAttachmentsWithStructuredMessage';
    attachments?: Maybe<Array<Attachment>>;
    content?: Maybe<Scalars['String']['output']>;
    messageTime: Scalars['DateTime']['output'];
    structuredMessage?: Maybe<AgentMessageStructuredMessage>;
    type: TextConversationPreviewTypes;
  };

/** The different types of preview */
export enum TextConversationPreviewTypes {
  TextAndAttachment = 'TextAndAttachment',
  TextAndAttachmentWithStructuredMessage = 'TextAndAttachmentWithStructuredMessage',
}

/** Translatable strings in the application */
export enum TextLocation {
  Closed = 'closed',
  InitiateCall = 'initiateCall',
  Intro = 'intro',
  Unavailable = 'unavailable',
  Welcome = 'welcome',
}

export type Theme = {
  __typename?: 'Theme';
  colors: Colors;
  images: Array<Image>;
};

export type UpdateCustomerAttachmentInput = {
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTill?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateCustomerCrmContactInput = {
  addresses?: InputMaybe<Array<CustomerCrmContactAddressInput>>;
  communications?: InputMaybe<Array<CustomerCrmContactCommunicationInput>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  functionName?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<CustomerCrmContactGroupRelationInput>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<CustomerCrmContactSexes>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerInput = {
  info: CustomerInfoInput;
};

export type UpdateCustomerTemporaryInstructionInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateMeccaConversationInputModel = {
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Boolean']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ConversationStatus>;
};

export type UpdateRoleInput = {
  name: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']>;
};

export type UpdateSocialConversationInputModel = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Boolean']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ConversationStatus>;
};

export type UpdateStandbyInput = {
  crmContactIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  from?: InputMaybe<StandbyHoursInput>;
  notifyChannels?: InputMaybe<Array<StandbyNotifyChannels>>;
  to?: InputMaybe<StandbyHoursInput>;
};

export type UpdateUserInput = {
  customers: Array<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role: UserRole;
};

export type UpdateUserStatusInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateVideoCallSettingsLocationInput = {
  agentSideRotation?: InputMaybe<Scalars['Float']['input']>;
  clientSideRotation?: InputMaybe<Scalars['Float']['input']>;
  clientSideRotationInputStream?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVideoCallSettingsNotification = {
  __typename?: 'UpdateVideoCallSettingsNotification';
  customerId: Scalars['String']['output'];
  locations: Array<CustomerLocation>;
  platformId: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  customers?: Maybe<Array<Scalars['String']['output']>>;
  displayName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UserRole>;
};

/** User role */
export enum UserRole {
  Admin = 'admin',
  Agent = 'agent',
  Superadmin = 'superadmin',
}

export type UserStatus = {
  __typename?: 'UserStatus';
  active: Scalars['Boolean']['output'];
};

export type UsersFilterInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UsersResult = {
  __typename?: 'UsersResult';
  count: Scalars['Int']['output'];
  items: Array<User>;
};

export type VideoCall = {
  __typename?: 'VideoCall';
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  callAgent?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  customerId: Scalars['String']['output'];
  /**
   * Returns duration in seconds. Returns 0 if
   *                       conversation is not answered or finished yet.
   */
  duration: Scalars['Int']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inProgress: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  roomId?: Maybe<Scalars['String']['output']>;
};

export type VideoCallFilterInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VideoCallInfo = {
  __typename?: 'VideoCallInfo';
  callId: Scalars['ID']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  token: Scalars['String']['output'];
};

export type VideoCallInfoTask = {
  __typename?: 'VideoCallInfoTask';
  callId: Scalars['ID']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  taskSid: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type VideoCallNotification = {
  __typename?: 'VideoCallNotification';
  callId: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  removeCall?: Maybe<Scalars['Boolean']['output']>;
};

export type VideoCallReportingResult = {
  __typename?: 'VideoCallReportingResult';
  totalDuration: Scalars['Int']['output'];
};

export type VideoCallResult = {
  __typename?: 'VideoCallResult';
  count: Scalars['Int']['output'];
  items: Array<VideoCall>;
};

export type VideoCallSettings = {
  __typename?: 'VideoCallSettings';
  backgroundImage?: Maybe<Scalars['String']['output']>;
  colors: CustomerScreenColors;
  defaultLanguage: Scalars['String']['output'];
  languages: Array<Scalars['String']['output']>;
  locale: Array<CustomerScreenLocale>;
  locations: Array<CustomerLocation>;
  logoImage: Scalars['String']['output'];
  name: Scalars['String']['output'];
  redirect: Scalars['Boolean']['output'];
  redirectDelay: Scalars['Int']['output'];
  template: Scalars['String']['output'];
  timeoutDelay: Scalars['Int']['output'];
};

export type VideoCallSettingsInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  colors?: InputMaybe<CustomerScreenColorsInput>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  locale?: InputMaybe<Array<CustomerScreenLocaleInput>>;
  locations?: InputMaybe<Array<CustomerLocationInput>>;
  logoImage?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  redirect: Scalars['Boolean']['input'];
  redirectDelay: Scalars['Int']['input'];
  template?: InputMaybe<Scalars['String']['input']>;
  timeoutDelay?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoConversation = Conversation & {
  __typename?: 'VideoConversation';
  archived: Scalars['Boolean']['output'];
  assignedToUsers?: Maybe<Array<AssignedUser>>;
  callId: Scalars['String']['output'];
  channelType: ChannelType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  events: Array<EventModel>;
  flagged: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  participants: Array<ConversationParticipant>;
  priority: Scalars['Float']['output'];
  read: Scalars['Boolean']['output'];
  redirected: Scalars['Boolean']['output'];
  related: Array<Conversation>;
  status: ConversationStatus;
  videoUrl: Scalars['String']['output'];
};

export type WaitingTimeReporting = CallBaseReporting & {
  __typename?: 'WaitingTimeReporting';
  averageWaitingTime: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  totalNrOfCalls: Scalars['Int']['output'];
  xAxisTitle: Scalars['String']['output'];
  xAxisValues: Array<Scalars['String']['output']>;
  yAxisTitle: Scalars['String']['output'];
  yAxisValues: Array<Scalars['Float']['output']>;
};

export type WebPushKeysInput = {
  auth: Scalars['String']['input'];
  p256dh: Scalars['String']['input'];
};

export type WithdrawMeccaMessageInputModel = {
  messageIds: Array<Scalars['Float']['input']>;
  userId: Scalars['String']['input'];
};

export type WithdrawSocialConversationInputModel = {
  messageIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type CreateCustomerAttachmentMutationVariables = Exact<{
  input: CreateCustomerAttachmentInput;
}>;

export type CreateCustomerAttachmentMutation = {
  __typename?: 'Mutation';
  createCustomerAttachment: {
    __typename?: 'CustomerAttachment';
    id: number;
    name: string;
    validFrom: string;
    validTill: string;
    active: boolean;
    attachment: { __typename?: 'Attachment'; fileName?: string | null; url: string };
  };
};

export type DeleteCustomerAttachmentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DeleteCustomerAttachmentMutation = {
  __typename?: 'Mutation';
  deleteCustomerAttachment: { __typename?: 'MutationResult'; success: boolean };
};

export type GetCustomerAttachmentsQueryVariables = Exact<{
  filter?: InputMaybe<CustomerAttachmentFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type GetCustomerAttachmentsQuery = {
  __typename?: 'Query';
  customerAttachments: {
    __typename?: 'CustomerAttachmentsResult';
    count: number;
    items: Array<{
      __typename?: 'CustomerAttachmentWithVersions';
      id: number;
      name: string;
      validFrom: string;
      validTill: string;
      active: boolean;
      type: string;
      attachment: { __typename?: 'Attachment'; fileName?: string | null; url: string };
      versions: Array<{
        __typename?: 'CustomerAttachmentVersion';
        id: number;
        validFrom: string;
        validTill: string;
        type: string;
        active: boolean;
        version: number;
        attachment: { __typename?: 'Attachment'; url: string };
      }>;
    }>;
  };
};

export type UpdateCustomerAttachmentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateCustomerAttachmentInput;
}>;

export type UpdateCustomerAttachmentMutation = {
  __typename?: 'Mutation';
  updateCustomerAttachment: {
    __typename?: 'CustomerAttachment';
    id: number;
    name: string;
    validFrom: string;
    validTill: string;
    active: boolean;
    attachment: { __typename?: 'Attachment'; fileName?: string | null; url: string };
  };
};

export type GetCurrentCommunicationCompanyQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentCommunicationCompanyQuery = {
  __typename?: 'Query';
  getCurrentCommunicationCompany: {
    __typename: 'CompanyResultModel';
    id: number;
    name?: string | null;
    profileName: string;
    address1?: string | null;
    address2?: string | null;
  };
};

export type GetCurrentCompanyQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentCompanyQuery = {
  __typename?: 'Query';
  getCurrentCompany: {
    __typename: 'CompanyResultModel';
    id: number;
    name?: string | null;
    profileName: string;
    address1?: string | null;
    address2?: string | null;
  };
};

export type SendContactRequestMutationVariables = Exact<{
  input: CreateContactRequestInput;
}>;

export type SendContactRequestMutation = {
  __typename?: 'Mutation';
  sendContactRequest: { __typename?: 'MutationResult'; success: boolean };
};

export type AddMeccaConversationAgentMessageMutationVariables = Exact<{
  agentMessageId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  input: AddConversationAgentMessage;
}>;

export type AddMeccaConversationAgentMessageMutation = {
  __typename?: 'Mutation';
  addMeccaConversationAgentMessage: { __typename?: 'MutationResult'; success: boolean };
};

export type AddMeccaConversationAttachmentMutationVariables = Exact<{
  input: AddMeccaMessageAttachmentInputModel;
}>;

export type AddMeccaConversationAttachmentMutation = {
  __typename?: 'Mutation';
  addMeccaMessageAttachment: boolean;
};

export type AssignMeccaConversationMutationVariables = Exact<{
  input: AssignMeccaMessageInputModel;
}>;

export type AssignMeccaConversationMutation = {
  __typename?: 'Mutation';
  assignMeccaMessage: boolean;
};

export type BulkUpdateMeccaConversationsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: UpdateMeccaConversationInputModel;
}>;

export type BulkUpdateMeccaConversationsMutation = {
  __typename?: 'Mutation';
  bulkUpdateMeccaConversations: Array<
    | { __typename?: 'MeccaBlankConversationModel'; id: string }
    | { __typename?: 'MeccaTextConversationModel'; id: string }
    | { __typename?: 'MeccaVideoConversationModel'; id: string }
  >;
};

export type CheckConversationLockedQueryVariables = Exact<{
  agentMessageId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
}>;

export type CheckConversationLockedQuery = {
  __typename?: 'Query';
  checkConversationLocked: boolean;
};

export type MeccaConversationBulkUpdatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type MeccaConversationBulkUpdatedSubscription = {
  __typename?: 'Subscription';
  meccaConversationBulkUpdated: Array<{
    __typename: 'MeccaTextConversationModel';
    channelType: ChannelType;
    createdAt: string;
    read: boolean;
    flagged?: boolean | null;
    status: ConversationStatus;
    unformattedBodyText?: string | null;
    unformattedText?: string | null;
    htmlStructuredMessage?: string | null;
    htmlMessage?: string | null;
    id: string;
    events: Array<
      | { __typename: 'ConversationArchivedEvent'; eventTime: string }
      | { __typename: 'ConversationClosedEvent'; eventTime: string }
      | { __typename: 'ConversationCreatedEvent'; eventTime: string }
      | { __typename: 'ConversationFlaggedEvent'; eventTime: string }
      | { __typename: 'ConversationForwardedEvent'; eventTime: string }
      | { __typename: 'ConversationPriorityChangedEvent'; eventTime: string }
      | { __typename: 'ConversationReadedEvent'; eventTime: string }
      | { __typename: 'ConversationStatusChangedEvent'; eventTime: string }
      | { __typename: 'ConversationUnflaggedEvent'; eventTime: string }
      | { __typename: 'ConversationUpdatedEvent'; eventTime: string }
    >;
    related: Array<
      | { __typename: 'MeccaBlankConversationModel'; id: string }
      | { __typename: 'MeccaTextConversationModel'; id: string }
      | { __typename: 'MeccaVideoConversationModel'; id: string }
    >;
    channel?:
      | { __typename: 'PairedChannelBlank'; channelIdentifier?: string | null; type: ChannelType }
      | {
          __typename: 'PairedChannelFacebook';
          channelIdentifier?: string | null;
          type: ChannelType;
        }
      | { __typename: 'PairedChannelTwitter'; channelIdentifier?: string | null; type: ChannelType }
      | { __typename: 'PairedChannelVideo'; channelIdentifier?: string | null; type: ChannelType }
      | {
          __typename: 'PairedChannelWhatsapp';
          channelIdentifier?: string | null;
          type: ChannelType;
        }
      | null;
    createdBy: { __typename: 'User'; id?: string | null; displayName?: string | null };
    messages: Array<{ __typename: 'Message' }>;
    agentMessages: Array<{
      __typename: 'AgentMessageResult';
      id: string;
      messages: Array<{
        __typename: 'AgentMessage';
        content?: string | null;
        messageTime: string;
        sender: { __typename: 'User'; displayName?: string | null };
      }>;
      attachments: Array<{
        __typename: 'Attachment';
        id: string;
        fileName?: string | null;
        url: string;
      }>;
      structuredMessage?: {
        __typename: 'AgentMessageStructuredMessage';
        name: string;
        fields: Array<{
          __typename: 'ConversationStructuredTypeField';
          sequence: number;
          label: string;
          description: string;
          required: boolean;
          readonly: boolean;
          defaultValue?: string | null;
          options?: Array<string> | null;
          fieldType: {
            __typename: 'ConversationStructuredTypeFieldType';
            name: string;
            regExForValidation?: string | null;
            regExForValidChars?: string | null;
            mask?: string | null;
            maxLength: number;
            errorMessage?: string | null;
          };
        }>;
        values: Array<{
          __typename: 'AgentMessageStructuredMessageValue';
          sequence: number;
          value?: string | null;
        }>;
      } | null;
    }>;
    attachments?: Array<{
      __typename?: 'MessageAttachmentModel';
      id?: string | null;
      fileName?: string | null;
      name?: string | null;
      fileTypeId?: number | null;
      dateTimeAdded?: string | null;
      url?: string | null;
    }> | null;
    assignedToUsers?: Array<{
      __typename?: 'AssignedUser';
      id: string;
      name: string;
      email: string;
    }> | null;
  }>;
};

type MeccaConversationDetails_MeccaBlankConversationModel_Fragment = {
  __typename?: 'MeccaBlankConversationModel';
  id: string;
};

type MeccaConversationDetails_MeccaTextConversationModel_Fragment = {
  __typename: 'MeccaTextConversationModel';
  channelType: ChannelType;
  createdAt: string;
  read: boolean;
  flagged?: boolean | null;
  status: ConversationStatus;
  unformattedBodyText?: string | null;
  unformattedText?: string | null;
  htmlStructuredMessage?: string | null;
  htmlMessage?: string | null;
  id: string;
  events: Array<
    | { __typename: 'ConversationArchivedEvent'; eventTime: string }
    | { __typename: 'ConversationClosedEvent'; eventTime: string }
    | { __typename: 'ConversationCreatedEvent'; eventTime: string }
    | { __typename: 'ConversationFlaggedEvent'; eventTime: string }
    | { __typename: 'ConversationForwardedEvent'; eventTime: string }
    | { __typename: 'ConversationPriorityChangedEvent'; eventTime: string }
    | { __typename: 'ConversationReadedEvent'; eventTime: string }
    | { __typename: 'ConversationStatusChangedEvent'; eventTime: string }
    | { __typename: 'ConversationUnflaggedEvent'; eventTime: string }
    | { __typename: 'ConversationUpdatedEvent'; eventTime: string }
  >;
  related: Array<
    | { __typename: 'MeccaBlankConversationModel'; id: string }
    | { __typename: 'MeccaTextConversationModel'; id: string }
    | { __typename: 'MeccaVideoConversationModel'; id: string }
  >;
  channel?:
    | { __typename: 'PairedChannelBlank'; channelIdentifier?: string | null; type: ChannelType }
    | { __typename: 'PairedChannelFacebook'; channelIdentifier?: string | null; type: ChannelType }
    | { __typename: 'PairedChannelTwitter'; channelIdentifier?: string | null; type: ChannelType }
    | { __typename: 'PairedChannelVideo'; channelIdentifier?: string | null; type: ChannelType }
    | { __typename: 'PairedChannelWhatsapp'; channelIdentifier?: string | null; type: ChannelType }
    | null;
  createdBy: { __typename: 'User'; id?: string | null; displayName?: string | null };
  messages: Array<{ __typename: 'Message' }>;
  agentMessages: Array<{
    __typename: 'AgentMessageResult';
    id: string;
    messages: Array<{
      __typename: 'AgentMessage';
      content?: string | null;
      messageTime: string;
      sender: { __typename: 'User'; displayName?: string | null };
    }>;
    attachments: Array<{
      __typename: 'Attachment';
      id: string;
      fileName?: string | null;
      url: string;
    }>;
    structuredMessage?: {
      __typename: 'AgentMessageStructuredMessage';
      name: string;
      fields: Array<{
        __typename: 'ConversationStructuredTypeField';
        sequence: number;
        label: string;
        description: string;
        required: boolean;
        readonly: boolean;
        defaultValue?: string | null;
        options?: Array<string> | null;
        fieldType: {
          __typename: 'ConversationStructuredTypeFieldType';
          name: string;
          regExForValidation?: string | null;
          regExForValidChars?: string | null;
          mask?: string | null;
          maxLength: number;
          errorMessage?: string | null;
        };
      }>;
      values: Array<{
        __typename: 'AgentMessageStructuredMessageValue';
        sequence: number;
        value?: string | null;
      }>;
    } | null;
  }>;
  attachments?: Array<{
    __typename?: 'MessageAttachmentModel';
    id?: string | null;
    fileName?: string | null;
    name?: string | null;
    fileTypeId?: number | null;
    dateTimeAdded?: string | null;
    url?: string | null;
  }> | null;
  assignedToUsers?: Array<{
    __typename?: 'AssignedUser';
    id: string;
    name: string;
    email: string;
  }> | null;
};

type MeccaConversationDetails_MeccaVideoConversationModel_Fragment = {
  __typename?: 'MeccaVideoConversationModel';
  id: string;
};

export type MeccaConversationDetailsFragment =
  | MeccaConversationDetails_MeccaBlankConversationModel_Fragment
  | MeccaConversationDetails_MeccaTextConversationModel_Fragment
  | MeccaConversationDetails_MeccaVideoConversationModel_Fragment;

type MeccaConversationPreview_MeccaBlankConversationModel_Fragment = {
  __typename?: 'MeccaBlankConversationModel';
  id: string;
  assignedToUsers?: Array<{
    __typename?: 'AssignedUser';
    id: string;
    name: string;
    email: string;
  }> | null;
};

type MeccaConversationPreview_MeccaTextConversationModel_Fragment = {
  __typename: 'MeccaTextConversationModel';
  channelType: ChannelType;
  createdAt: string;
  read: boolean;
  flagged?: boolean | null;
  status: ConversationStatus;
  unformattedBodyText?: string | null;
  unformattedText?: string | null;
  htmlStructuredMessage?: string | null;
  htmlMessage?: string | null;
  id: string;
  channel?:
    | { __typename: 'PairedChannelBlank'; channelIdentifier?: string | null; type: ChannelType }
    | { __typename: 'PairedChannelFacebook'; channelIdentifier?: string | null; type: ChannelType }
    | { __typename: 'PairedChannelTwitter'; channelIdentifier?: string | null; type: ChannelType }
    | { __typename: 'PairedChannelVideo'; channelIdentifier?: string | null; type: ChannelType }
    | { __typename: 'PairedChannelWhatsapp'; channelIdentifier?: string | null; type: ChannelType }
    | null;
  createdBy: { __typename: 'User'; id?: string | null; displayName?: string | null };
  attachments?: Array<{
    __typename: 'MessageAttachmentModel';
    id?: string | null;
    fileName?: string | null;
    url?: string | null;
  }> | null;
  assignedToUsers?: Array<{
    __typename?: 'AssignedUser';
    id: string;
    name: string;
    email: string;
  }> | null;
};

type MeccaConversationPreview_MeccaVideoConversationModel_Fragment = {
  __typename?: 'MeccaVideoConversationModel';
  id: string;
  assignedToUsers?: Array<{
    __typename?: 'AssignedUser';
    id: string;
    name: string;
    email: string;
  }> | null;
};

export type MeccaConversationPreviewFragment =
  | MeccaConversationPreview_MeccaBlankConversationModel_Fragment
  | MeccaConversationPreview_MeccaTextConversationModel_Fragment
  | MeccaConversationPreview_MeccaVideoConversationModel_Fragment;

export type MeccaConversationUpdatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type MeccaConversationUpdatedSubscription = {
  __typename?: 'Subscription';
  meccaConversationUpdated: {
    __typename: 'MeccaTextConversationModel';
    channelType: ChannelType;
    createdAt: string;
    read: boolean;
    flagged?: boolean | null;
    status: ConversationStatus;
    unformattedBodyText?: string | null;
    unformattedText?: string | null;
    htmlStructuredMessage?: string | null;
    htmlMessage?: string | null;
    id: string;
    events: Array<
      | { __typename: 'ConversationArchivedEvent'; eventTime: string }
      | { __typename: 'ConversationClosedEvent'; eventTime: string }
      | { __typename: 'ConversationCreatedEvent'; eventTime: string }
      | { __typename: 'ConversationFlaggedEvent'; eventTime: string }
      | { __typename: 'ConversationForwardedEvent'; eventTime: string }
      | { __typename: 'ConversationPriorityChangedEvent'; eventTime: string }
      | { __typename: 'ConversationReadedEvent'; eventTime: string }
      | { __typename: 'ConversationStatusChangedEvent'; eventTime: string }
      | { __typename: 'ConversationUnflaggedEvent'; eventTime: string }
      | { __typename: 'ConversationUpdatedEvent'; eventTime: string }
    >;
    related: Array<
      | { __typename: 'MeccaBlankConversationModel'; id: string }
      | { __typename: 'MeccaTextConversationModel'; id: string }
      | { __typename: 'MeccaVideoConversationModel'; id: string }
    >;
    channel?:
      | { __typename: 'PairedChannelBlank'; channelIdentifier?: string | null; type: ChannelType }
      | {
          __typename: 'PairedChannelFacebook';
          channelIdentifier?: string | null;
          type: ChannelType;
        }
      | { __typename: 'PairedChannelTwitter'; channelIdentifier?: string | null; type: ChannelType }
      | { __typename: 'PairedChannelVideo'; channelIdentifier?: string | null; type: ChannelType }
      | {
          __typename: 'PairedChannelWhatsapp';
          channelIdentifier?: string | null;
          type: ChannelType;
        }
      | null;
    createdBy: { __typename: 'User'; id?: string | null; displayName?: string | null };
    messages: Array<{ __typename: 'Message' }>;
    agentMessages: Array<{
      __typename: 'AgentMessageResult';
      id: string;
      messages: Array<{
        __typename: 'AgentMessage';
        content?: string | null;
        messageTime: string;
        sender: { __typename: 'User'; displayName?: string | null };
      }>;
      attachments: Array<{
        __typename: 'Attachment';
        id: string;
        fileName?: string | null;
        url: string;
      }>;
      structuredMessage?: {
        __typename: 'AgentMessageStructuredMessage';
        name: string;
        fields: Array<{
          __typename: 'ConversationStructuredTypeField';
          sequence: number;
          label: string;
          description: string;
          required: boolean;
          readonly: boolean;
          defaultValue?: string | null;
          options?: Array<string> | null;
          fieldType: {
            __typename: 'ConversationStructuredTypeFieldType';
            name: string;
            regExForValidation?: string | null;
            regExForValidChars?: string | null;
            mask?: string | null;
            maxLength: number;
            errorMessage?: string | null;
          };
        }>;
        values: Array<{
          __typename: 'AgentMessageStructuredMessageValue';
          sequence: number;
          value?: string | null;
        }>;
      } | null;
    }>;
    attachments?: Array<{
      __typename?: 'MessageAttachmentModel';
      id?: string | null;
      fileName?: string | null;
      name?: string | null;
      fileTypeId?: number | null;
      dateTimeAdded?: string | null;
      url?: string | null;
    }> | null;
    assignedToUsers?: Array<{
      __typename?: 'AssignedUser';
      id: string;
      name: string;
      email: string;
    }> | null;
  };
};

export type CreateMeccaConversationMutationVariables = Exact<{
  input: CreateMeccaConversationInputModel;
}>;

export type CreateMeccaConversationMutation = {
  __typename?: 'Mutation';
  createMeccaConversation:
    | {
        __typename?: 'MeccaBlankConversationModel';
        id: string;
        assignedToUsers?: Array<{
          __typename?: 'AssignedUser';
          id: string;
          name: string;
          email: string;
        }> | null;
      }
    | {
        __typename: 'MeccaTextConversationModel';
        channelType: ChannelType;
        createdAt: string;
        read: boolean;
        flagged?: boolean | null;
        status: ConversationStatus;
        unformattedBodyText?: string | null;
        unformattedText?: string | null;
        htmlStructuredMessage?: string | null;
        htmlMessage?: string | null;
        id: string;
        channel?:
          | {
              __typename: 'PairedChannelBlank';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelFacebook';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelTwitter';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelVideo';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelWhatsapp';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | null;
        createdBy: { __typename: 'User'; id?: string | null; displayName?: string | null };
        attachments?: Array<{
          __typename: 'MessageAttachmentModel';
          id?: string | null;
          fileName?: string | null;
          url?: string | null;
        }> | null;
        assignedToUsers?: Array<{
          __typename?: 'AssignedUser';
          id: string;
          name: string;
          email: string;
        }> | null;
      }
    | {
        __typename?: 'MeccaVideoConversationModel';
        id: string;
        assignedToUsers?: Array<{
          __typename?: 'AssignedUser';
          id: string;
          name: string;
          email: string;
        }> | null;
      };
};

export type EditMeccaConversationMutationVariables = Exact<{
  input: EditMeccaConversationInputModel;
}>;

export type EditMeccaConversationMutation = {
  __typename?: 'Mutation';
  editMeccaConversation:
    | {
        __typename?: 'MeccaBlankConversationModel';
        id: string;
        assignedToUsers?: Array<{
          __typename?: 'AssignedUser';
          id: string;
          name: string;
          email: string;
        }> | null;
      }
    | {
        __typename: 'MeccaTextConversationModel';
        channelType: ChannelType;
        createdAt: string;
        read: boolean;
        flagged?: boolean | null;
        status: ConversationStatus;
        unformattedBodyText?: string | null;
        unformattedText?: string | null;
        htmlStructuredMessage?: string | null;
        htmlMessage?: string | null;
        id: string;
        channel?:
          | {
              __typename: 'PairedChannelBlank';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelFacebook';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelTwitter';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelVideo';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelWhatsapp';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | null;
        createdBy: { __typename: 'User'; id?: string | null; displayName?: string | null };
        attachments?: Array<{
          __typename: 'MessageAttachmentModel';
          id?: string | null;
          fileName?: string | null;
          url?: string | null;
        }> | null;
        assignedToUsers?: Array<{
          __typename?: 'AssignedUser';
          id: string;
          name: string;
          email: string;
        }> | null;
      }
    | {
        __typename?: 'MeccaVideoConversationModel';
        id: string;
        assignedToUsers?: Array<{
          __typename?: 'AssignedUser';
          id: string;
          name: string;
          email: string;
        }> | null;
      };
};

export type ForwardMeccaConversationsAgentMutationVariables = Exact<{
  messagesIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: ForwardConversationAgentMessage;
}>;

export type ForwardMeccaConversationsAgentMutation = {
  __typename?: 'Mutation';
  forwardMeccaConversationsAgent: { __typename?: 'MutationResult'; success: boolean };
};

export type GetMeccaConversationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetMeccaConversationQuery = {
  __typename?: 'Query';
  meccaConversation:
    | { __typename?: 'MeccaBlankConversationModel'; id: string }
    | {
        __typename: 'MeccaTextConversationModel';
        channelType: ChannelType;
        createdAt: string;
        read: boolean;
        flagged?: boolean | null;
        status: ConversationStatus;
        unformattedBodyText?: string | null;
        unformattedText?: string | null;
        htmlStructuredMessage?: string | null;
        htmlMessage?: string | null;
        id: string;
        events: Array<
          | { __typename: 'ConversationArchivedEvent'; eventTime: string }
          | { __typename: 'ConversationClosedEvent'; eventTime: string }
          | { __typename: 'ConversationCreatedEvent'; eventTime: string }
          | { __typename: 'ConversationFlaggedEvent'; eventTime: string }
          | { __typename: 'ConversationForwardedEvent'; eventTime: string }
          | { __typename: 'ConversationPriorityChangedEvent'; eventTime: string }
          | { __typename: 'ConversationReadedEvent'; eventTime: string }
          | { __typename: 'ConversationStatusChangedEvent'; eventTime: string }
          | { __typename: 'ConversationUnflaggedEvent'; eventTime: string }
          | { __typename: 'ConversationUpdatedEvent'; eventTime: string }
        >;
        related: Array<
          | { __typename: 'MeccaBlankConversationModel'; id: string }
          | { __typename: 'MeccaTextConversationModel'; id: string }
          | { __typename: 'MeccaVideoConversationModel'; id: string }
        >;
        channel?:
          | {
              __typename: 'PairedChannelBlank';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelFacebook';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelTwitter';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelVideo';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelWhatsapp';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | null;
        createdBy: { __typename: 'User'; id?: string | null; displayName?: string | null };
        messages: Array<{ __typename: 'Message' }>;
        agentMessages: Array<{
          __typename: 'AgentMessageResult';
          id: string;
          messages: Array<{
            __typename: 'AgentMessage';
            content?: string | null;
            messageTime: string;
            sender: { __typename: 'User'; displayName?: string | null };
          }>;
          attachments: Array<{
            __typename: 'Attachment';
            id: string;
            fileName?: string | null;
            url: string;
          }>;
          structuredMessage?: {
            __typename: 'AgentMessageStructuredMessage';
            name: string;
            fields: Array<{
              __typename: 'ConversationStructuredTypeField';
              sequence: number;
              label: string;
              description: string;
              required: boolean;
              readonly: boolean;
              defaultValue?: string | null;
              options?: Array<string> | null;
              fieldType: {
                __typename: 'ConversationStructuredTypeFieldType';
                name: string;
                regExForValidation?: string | null;
                regExForValidChars?: string | null;
                mask?: string | null;
                maxLength: number;
                errorMessage?: string | null;
              };
            }>;
            values: Array<{
              __typename: 'AgentMessageStructuredMessageValue';
              sequence: number;
              value?: string | null;
            }>;
          } | null;
        }>;
        attachments?: Array<{
          __typename?: 'MessageAttachmentModel';
          id?: string | null;
          fileName?: string | null;
          name?: string | null;
          fileTypeId?: number | null;
          dateTimeAdded?: string | null;
          url?: string | null;
        }> | null;
        assignedToUsers?: Array<{
          __typename?: 'AssignedUser';
          id: string;
          name: string;
          email: string;
        }> | null;
      }
    | { __typename?: 'MeccaVideoConversationModel'; id: string };
};

export type GetMeccaConversationsPreviewQueryVariables = Exact<{
  filter?: InputMaybe<FilterMeccaConversationInputModel>;
  sort?: InputMaybe<SortOrder>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetMeccaConversationsPreviewQuery = {
  __typename?: 'Query';
  meccaConversations: {
    __typename?: 'MeccaConversationResultModel';
    count: number;
    items: Array<
      | {
          __typename?: 'MeccaBlankConversationModel';
          id: string;
          assignedToUsers?: Array<{
            __typename?: 'AssignedUser';
            id: string;
            name: string;
            email: string;
          }> | null;
        }
      | {
          __typename: 'MeccaTextConversationModel';
          channelType: ChannelType;
          createdAt: string;
          read: boolean;
          flagged?: boolean | null;
          status: ConversationStatus;
          unformattedBodyText?: string | null;
          unformattedText?: string | null;
          htmlStructuredMessage?: string | null;
          htmlMessage?: string | null;
          id: string;
          channel?:
            | {
                __typename: 'PairedChannelBlank';
                channelIdentifier?: string | null;
                type: ChannelType;
              }
            | {
                __typename: 'PairedChannelFacebook';
                channelIdentifier?: string | null;
                type: ChannelType;
              }
            | {
                __typename: 'PairedChannelTwitter';
                channelIdentifier?: string | null;
                type: ChannelType;
              }
            | {
                __typename: 'PairedChannelVideo';
                channelIdentifier?: string | null;
                type: ChannelType;
              }
            | {
                __typename: 'PairedChannelWhatsapp';
                channelIdentifier?: string | null;
                type: ChannelType;
              }
            | null;
          createdBy: { __typename: 'User'; id?: string | null; displayName?: string | null };
          attachments?: Array<{
            __typename: 'MessageAttachmentModel';
            id?: string | null;
            fileName?: string | null;
            url?: string | null;
          }> | null;
          assignedToUsers?: Array<{
            __typename?: 'AssignedUser';
            id: string;
            name: string;
            email: string;
          }> | null;
        }
      | {
          __typename?: 'MeccaVideoConversationModel';
          id: string;
          assignedToUsers?: Array<{
            __typename?: 'AssignedUser';
            id: string;
            name: string;
            email: string;
          }> | null;
        }
    >;
  };
};

export type MeccaConversationsByFilterQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  till?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type MeccaConversationsByFilterQuery = {
  __typename?: 'Query';
  meccaConversationsByFilter: Array<
    | { __typename?: 'MeccaBlankConversationModel'; id: string }
    | {
        __typename: 'MeccaTextConversationModel';
        channelType: ChannelType;
        createdAt: string;
        read: boolean;
        flagged?: boolean | null;
        status: ConversationStatus;
        unformattedBodyText?: string | null;
        unformattedText?: string | null;
        htmlStructuredMessage?: string | null;
        htmlMessage?: string | null;
        id: string;
        events: Array<
          | { __typename: 'ConversationArchivedEvent'; eventTime: string }
          | { __typename: 'ConversationClosedEvent'; eventTime: string }
          | { __typename: 'ConversationCreatedEvent'; eventTime: string }
          | { __typename: 'ConversationFlaggedEvent'; eventTime: string }
          | { __typename: 'ConversationForwardedEvent'; eventTime: string }
          | { __typename: 'ConversationPriorityChangedEvent'; eventTime: string }
          | { __typename: 'ConversationReadedEvent'; eventTime: string }
          | { __typename: 'ConversationStatusChangedEvent'; eventTime: string }
          | { __typename: 'ConversationUnflaggedEvent'; eventTime: string }
          | { __typename: 'ConversationUpdatedEvent'; eventTime: string }
        >;
        related: Array<
          | { __typename: 'MeccaBlankConversationModel'; id: string }
          | { __typename: 'MeccaTextConversationModel'; id: string }
          | { __typename: 'MeccaVideoConversationModel'; id: string }
        >;
        channel?:
          | {
              __typename: 'PairedChannelBlank';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelFacebook';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelTwitter';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelVideo';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelWhatsapp';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | null;
        createdBy: { __typename: 'User'; id?: string | null; displayName?: string | null };
        messages: Array<{ __typename: 'Message' }>;
        agentMessages: Array<{
          __typename: 'AgentMessageResult';
          id: string;
          messages: Array<{
            __typename: 'AgentMessage';
            content?: string | null;
            messageTime: string;
            sender: { __typename: 'User'; displayName?: string | null };
          }>;
          attachments: Array<{
            __typename: 'Attachment';
            id: string;
            fileName?: string | null;
            url: string;
          }>;
          structuredMessage?: {
            __typename: 'AgentMessageStructuredMessage';
            name: string;
            fields: Array<{
              __typename: 'ConversationStructuredTypeField';
              sequence: number;
              label: string;
              description: string;
              required: boolean;
              readonly: boolean;
              defaultValue?: string | null;
              options?: Array<string> | null;
              fieldType: {
                __typename: 'ConversationStructuredTypeFieldType';
                name: string;
                regExForValidation?: string | null;
                regExForValidChars?: string | null;
                mask?: string | null;
                maxLength: number;
                errorMessage?: string | null;
              };
            }>;
            values: Array<{
              __typename: 'AgentMessageStructuredMessageValue';
              sequence: number;
              value?: string | null;
            }>;
          } | null;
        }>;
        attachments?: Array<{
          __typename?: 'MessageAttachmentModel';
          id?: string | null;
          fileName?: string | null;
          name?: string | null;
          fileTypeId?: number | null;
          dateTimeAdded?: string | null;
          url?: string | null;
        }> | null;
        assignedToUsers?: Array<{
          __typename?: 'AssignedUser';
          id: string;
          name: string;
          email: string;
        }> | null;
      }
    | { __typename?: 'MeccaVideoConversationModel'; id: string }
  >;
};

export type RemoveMeccaConversationAttachementMutationVariables = Exact<{
  input: RemoveMeccaMessageAttachmentInputModel;
}>;

export type RemoveMeccaConversationAttachementMutation = {
  __typename?: 'Mutation';
  removeMeccaMessageAttachment: boolean;
};

export type UpdateMeccaConversationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateMeccaConversationInputModel;
}>;

export type UpdateMeccaConversationMutation = {
  __typename?: 'Mutation';
  updateMeccaConversation:
    | {
        __typename?: 'MeccaBlankConversationModel';
        id: string;
        assignedToUsers?: Array<{
          __typename?: 'AssignedUser';
          id: string;
          name: string;
          email: string;
        }> | null;
      }
    | {
        __typename: 'MeccaTextConversationModel';
        channelType: ChannelType;
        createdAt: string;
        read: boolean;
        flagged?: boolean | null;
        status: ConversationStatus;
        unformattedBodyText?: string | null;
        unformattedText?: string | null;
        htmlStructuredMessage?: string | null;
        htmlMessage?: string | null;
        id: string;
        channel?:
          | {
              __typename: 'PairedChannelBlank';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelFacebook';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelTwitter';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelVideo';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | {
              __typename: 'PairedChannelWhatsapp';
              channelIdentifier?: string | null;
              type: ChannelType;
            }
          | null;
        createdBy: { __typename: 'User'; id?: string | null; displayName?: string | null };
        attachments?: Array<{
          __typename: 'MessageAttachmentModel';
          id?: string | null;
          fileName?: string | null;
          url?: string | null;
        }> | null;
        assignedToUsers?: Array<{
          __typename?: 'AssignedUser';
          id: string;
          name: string;
          email: string;
        }> | null;
      }
    | {
        __typename?: 'MeccaVideoConversationModel';
        id: string;
        assignedToUsers?: Array<{
          __typename?: 'AssignedUser';
          id: string;
          name: string;
          email: string;
        }> | null;
      };
};

export type WithdrawMeccaConversationMutationVariables = Exact<{
  input: WithdrawMeccaMessageInputModel;
}>;

export type WithdrawMeccaConversationMutation = {
  __typename?: 'Mutation';
  withdrawMeccaMessage: boolean;
};

type ConversationDetail_BlankConversation_Fragment = {
  __typename: 'BlankConversation';
  id: string;
  read: boolean;
  archived: boolean;
  createdBy: { __typename?: 'User'; displayName?: string | null };
  events: Array<
    | { __typename: 'ConversationArchivedEvent'; eventTime: string }
    | { __typename: 'ConversationClosedEvent'; eventTime: string }
    | { __typename: 'ConversationCreatedEvent'; eventTime: string }
    | { __typename: 'ConversationFlaggedEvent'; eventTime: string }
    | { __typename: 'ConversationForwardedEvent'; eventTime: string }
    | { __typename: 'ConversationPriorityChangedEvent'; eventTime: string }
    | { __typename: 'ConversationReadedEvent'; eventTime: string }
    | { __typename: 'ConversationStatusChangedEvent'; eventTime: string }
    | { __typename: 'ConversationUnflaggedEvent'; eventTime: string }
    | { __typename: 'ConversationUpdatedEvent'; eventTime: string }
  >;
  participants: Array<{
    __typename?: 'ConversationParticipant';
    channel: ChannelType;
    channelId: string;
  }>;
  related: Array<
    | { __typename?: 'BlankConversation'; id: string }
    | { __typename?: 'TextConversation'; id: string }
    | { __typename?: 'VideoConversation'; id: string }
  >;
};

type ConversationDetail_TextConversation_Fragment = {
  __typename: 'TextConversation';
  id: string;
  read: boolean;
  archived: boolean;
  createdBy: { __typename?: 'User'; displayName?: string | null };
  events: Array<
    | { __typename: 'ConversationArchivedEvent'; eventTime: string }
    | { __typename: 'ConversationClosedEvent'; eventTime: string }
    | { __typename: 'ConversationCreatedEvent'; eventTime: string }
    | { __typename: 'ConversationFlaggedEvent'; eventTime: string }
    | { __typename: 'ConversationForwardedEvent'; eventTime: string }
    | { __typename: 'ConversationPriorityChangedEvent'; eventTime: string }
    | { __typename: 'ConversationReadedEvent'; eventTime: string }
    | { __typename: 'ConversationStatusChangedEvent'; eventTime: string }
    | { __typename: 'ConversationUnflaggedEvent'; eventTime: string }
    | { __typename: 'ConversationUpdatedEvent'; eventTime: string }
  >;
  participants: Array<{
    __typename?: 'ConversationParticipant';
    channel: ChannelType;
    channelId: string;
  }>;
  related: Array<
    | { __typename?: 'BlankConversation'; id: string }
    | { __typename?: 'TextConversation'; id: string }
    | { __typename?: 'VideoConversation'; id: string }
  >;
};

type ConversationDetail_VideoConversation_Fragment = {
  __typename: 'VideoConversation';
  id: string;
  read: boolean;
  archived: boolean;
  createdBy: { __typename?: 'User'; displayName?: string | null };
  events: Array<
    | { __typename: 'ConversationArchivedEvent'; eventTime: string }
    | { __typename: 'ConversationClosedEvent'; eventTime: string }
    | { __typename: 'ConversationCreatedEvent'; eventTime: string }
    | { __typename: 'ConversationFlaggedEvent'; eventTime: string }
    | { __typename: 'ConversationForwardedEvent'; eventTime: string }
    | { __typename: 'ConversationPriorityChangedEvent'; eventTime: string }
    | { __typename: 'ConversationReadedEvent'; eventTime: string }
    | { __typename: 'ConversationStatusChangedEvent'; eventTime: string }
    | { __typename: 'ConversationUnflaggedEvent'; eventTime: string }
    | { __typename: 'ConversationUpdatedEvent'; eventTime: string }
  >;
  participants: Array<{
    __typename?: 'ConversationParticipant';
    channel: ChannelType;
    channelId: string;
  }>;
  related: Array<
    | { __typename?: 'BlankConversation'; id: string }
    | { __typename?: 'TextConversation'; id: string }
    | { __typename?: 'VideoConversation'; id: string }
  >;
};

export type ConversationDetailFragment =
  | ConversationDetail_BlankConversation_Fragment
  | ConversationDetail_TextConversation_Fragment
  | ConversationDetail_VideoConversation_Fragment;

type ConversationPreview_BlankConversation_Fragment = {
  __typename: 'BlankConversation';
  id: string;
  channelType: ChannelType;
  createdAt: string;
  flagged: boolean;
  archived: boolean;
  read: boolean;
  createdBy: { __typename?: 'User'; displayName?: string | null };
  assignedToUsers?: Array<{
    __typename?: 'AssignedUser';
    id: string;
    name: string;
    email: string;
  }> | null;
};

type ConversationPreview_TextConversation_Fragment = {
  __typename: 'TextConversation';
  id: string;
  channelType: ChannelType;
  createdAt: string;
  flagged: boolean;
  archived: boolean;
  read: boolean;
  createdBy: { __typename?: 'User'; displayName?: string | null };
  assignedToUsers?: Array<{
    __typename?: 'AssignedUser';
    id: string;
    name: string;
    email: string;
  }> | null;
};

type ConversationPreview_VideoConversation_Fragment = {
  __typename: 'VideoConversation';
  id: string;
  channelType: ChannelType;
  createdAt: string;
  flagged: boolean;
  archived: boolean;
  read: boolean;
  createdBy: { __typename?: 'User'; displayName?: string | null };
  assignedToUsers?: Array<{
    __typename?: 'AssignedUser';
    id: string;
    name: string;
    email: string;
  }> | null;
};

export type ConversationPreviewFragment =
  | ConversationPreview_BlankConversation_Fragment
  | ConversationPreview_TextConversation_Fragment
  | ConversationPreview_VideoConversation_Fragment;

export type ConversationStructuredTypesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type ConversationStructuredTypesQuery = {
  __typename?: 'Query';
  conversationStructuredTypes: {
    __typename?: 'ConversationStructuredTypesResult';
    count: number;
    items: Array<{
      __typename?: 'ConversationStructuredType';
      name: string;
      fields: Array<{
        __typename?: 'ConversationStructuredTypeField';
        sequence: number;
        isEditableByCustomer: boolean;
        label: string;
        description: string;
        required: boolean;
        readonly: boolean;
        defaultValue?: string | null;
        options?: Array<string> | null;
        fieldType: {
          __typename?: 'ConversationStructuredTypeFieldType';
          name: string;
          regExForValidation?: string | null;
          regExForValidChars?: string | null;
          mask?: string | null;
          maxLength: number;
          errorMessage?: string | null;
        };
      }>;
    }>;
  };
};

export type GetUnreadConversationsCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetUnreadConversationsCountQuery = {
  __typename?: 'Query';
  socialConversations: { __typename?: 'SocialConversationsResultModel'; count: number };
};

export type AssignSocialConversationMutationVariables = Exact<{
  input: AssignSocialConversationInputModel;
}>;

export type AssignSocialConversationMutation = {
  __typename?: 'Mutation';
  assignSocialConversation: boolean;
};

export type BulkUpdateSocialConversationsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: UpdateSocialConversationInputModel;
}>;

export type BulkUpdateSocialConversationsMutation = {
  __typename?: 'Mutation';
  bulkUpdateSocialConversations: Array<{ __typename?: 'SocialConversationModel'; id: string }>;
};

export type SocialConversationBulkUpdatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type SocialConversationBulkUpdatedSubscription = {
  __typename?: 'Subscription';
  SocialConversationBulkUpdated: Array<{
    __typename: 'SocialConversationModel';
    id: string;
    channelType?: ChannelType | null;
    createdAt?: string | null;
    read: boolean;
    archived: boolean;
    flagged: boolean;
    status?: ConversationStatus | null;
    multipleResponsesTill?: string | null;
    canSendResponse?: boolean | null;
    createdBy?: { __typename?: 'User'; id?: string | null; displayName?: string | null } | null;
    assignedToUsers?: Array<{
      __typename?: 'Assignment';
      id: string;
      name: string;
      email: string;
    }> | null;
    channel?:
      | { __typename?: 'PairedChannelBlank'; type: ChannelType; channelIdentifier?: string | null }
      | {
          __typename?: 'PairedChannelFacebook';
          type: ChannelType;
          channelIdentifier?: string | null;
        }
      | {
          __typename?: 'PairedChannelTwitter';
          type: ChannelType;
          channelIdentifier?: string | null;
        }
      | { __typename?: 'PairedChannelVideo'; type: ChannelType; channelIdentifier?: string | null }
      | {
          __typename?: 'PairedChannelWhatsapp';
          type: ChannelType;
          channelIdentifier?: string | null;
        }
      | null;
    preview?: {
      __typename?: 'SocialTextConversationPreviewModel';
      type: TextConversationPreviewTypes;
      messageTime: string;
      content?: string | null;
      attachments?: Array<{
        __typename?: 'Attachment';
        fileName?: string | null;
        url: string;
      }> | null;
    } | null;
    events?: Array<
      | { __typename: 'ConversationArchivedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationClosedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationCreatedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationFlaggedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationForwardedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationPriorityChangedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationReadedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationStatusChangedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationUnflaggedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationUpdatedEvent'; eventTime: string; type: EventTypes }
    > | null;
    participants?: Array<{
      __typename?: 'SocialConversationParticipantModel';
      channel: ChannelType;
      channelId: string;
    }> | null;
    related?: Array<{ __typename?: 'SocialConversationModel'; id: string }> | null;
    messages: Array<{
      __typename?: 'Message';
      id: string;
      channelType: ChannelType;
      external?: boolean | null;
      content?: string | null;
      messageTime: string;
      source: string;
      destination: string;
      conversationId: string;
      attachments?: Array<{
        __typename?: 'Attachment';
        fileName?: string | null;
        url: string;
      }> | null;
      sender: { __typename: 'User'; id?: string | null; displayName?: string | null };
    }>;
  }>;
};

export type SocialConversationDetailsFragment = {
  __typename: 'SocialConversationModel';
  id: string;
  channelType?: ChannelType | null;
  createdAt?: string | null;
  read: boolean;
  archived: boolean;
  flagged: boolean;
  status?: ConversationStatus | null;
  multipleResponsesTill?: string | null;
  canSendResponse?: boolean | null;
  createdBy?: { __typename?: 'User'; id?: string | null; displayName?: string | null } | null;
  assignedToUsers?: Array<{
    __typename?: 'Assignment';
    id: string;
    name: string;
    email: string;
  }> | null;
  channel?:
    | { __typename?: 'PairedChannelBlank'; type: ChannelType; channelIdentifier?: string | null }
    | { __typename?: 'PairedChannelFacebook'; type: ChannelType; channelIdentifier?: string | null }
    | { __typename?: 'PairedChannelTwitter'; type: ChannelType; channelIdentifier?: string | null }
    | { __typename?: 'PairedChannelVideo'; type: ChannelType; channelIdentifier?: string | null }
    | { __typename?: 'PairedChannelWhatsapp'; type: ChannelType; channelIdentifier?: string | null }
    | null;
  preview?: {
    __typename?: 'SocialTextConversationPreviewModel';
    type: TextConversationPreviewTypes;
    messageTime: string;
    content?: string | null;
    attachments?: Array<{
      __typename?: 'Attachment';
      fileName?: string | null;
      url: string;
    }> | null;
  } | null;
  events?: Array<
    | { __typename: 'ConversationArchivedEvent'; eventTime: string; type: EventTypes }
    | { __typename: 'ConversationClosedEvent'; eventTime: string; type: EventTypes }
    | { __typename: 'ConversationCreatedEvent'; eventTime: string; type: EventTypes }
    | { __typename: 'ConversationFlaggedEvent'; eventTime: string; type: EventTypes }
    | { __typename: 'ConversationForwardedEvent'; eventTime: string; type: EventTypes }
    | { __typename: 'ConversationPriorityChangedEvent'; eventTime: string; type: EventTypes }
    | { __typename: 'ConversationReadedEvent'; eventTime: string; type: EventTypes }
    | { __typename: 'ConversationStatusChangedEvent'; eventTime: string; type: EventTypes }
    | { __typename: 'ConversationUnflaggedEvent'; eventTime: string; type: EventTypes }
    | { __typename: 'ConversationUpdatedEvent'; eventTime: string; type: EventTypes }
  > | null;
  participants?: Array<{
    __typename?: 'SocialConversationParticipantModel';
    channel: ChannelType;
    channelId: string;
  }> | null;
  related?: Array<{ __typename?: 'SocialConversationModel'; id: string }> | null;
  messages: Array<{
    __typename?: 'Message';
    id: string;
    channelType: ChannelType;
    external?: boolean | null;
    content?: string | null;
    messageTime: string;
    source: string;
    destination: string;
    conversationId: string;
    attachments?: Array<{
      __typename?: 'Attachment';
      fileName?: string | null;
      url: string;
    }> | null;
    sender: { __typename: 'User'; id?: string | null; displayName?: string | null };
  }>;
};

export type SocialConversationPreviewFragment = {
  __typename: 'SocialConversationModel';
  id: string;
  channelType?: ChannelType | null;
  createdAt?: string | null;
  read: boolean;
  archived: boolean;
  flagged: boolean;
  status?: ConversationStatus | null;
  createdBy?: { __typename?: 'User'; id?: string | null; displayName?: string | null } | null;
  assignedToUsers?: Array<{
    __typename?: 'Assignment';
    id: string;
    name: string;
    email: string;
  }> | null;
  channel?:
    | { __typename?: 'PairedChannelBlank'; type: ChannelType; channelIdentifier?: string | null }
    | { __typename?: 'PairedChannelFacebook'; type: ChannelType; channelIdentifier?: string | null }
    | { __typename?: 'PairedChannelTwitter'; type: ChannelType; channelIdentifier?: string | null }
    | { __typename?: 'PairedChannelVideo'; type: ChannelType; channelIdentifier?: string | null }
    | { __typename?: 'PairedChannelWhatsapp'; type: ChannelType; channelIdentifier?: string | null }
    | null;
  preview?: {
    __typename?: 'SocialTextConversationPreviewModel';
    type: TextConversationPreviewTypes;
    messageTime: string;
    content?: string | null;
    attachments?: Array<{
      __typename?: 'Attachment';
      fileName?: string | null;
      url: string;
    }> | null;
  } | null;
};

export type SocialNewReceivedMessageSubscriptionVariables = Exact<{ [key: string]: never }>;

export type SocialNewReceivedMessageSubscription = {
  __typename?: 'Subscription';
  SocialNewReceivedMessage: {
    __typename?: 'Message';
    channelType: ChannelType;
    content?: string | null;
    external?: boolean | null;
    conversationId: string;
    destination: string;
    messageTime: string;
    source: string;
    attachments?: Array<{
      __typename?: 'Attachment';
      fileName?: string | null;
      url: string;
    }> | null;
    sender: { __typename: 'User'; id?: string | null; displayName?: string | null };
  };
};

export type SocialConversationUpdatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type SocialConversationUpdatedSubscription = {
  __typename?: 'Subscription';
  SocialConversationUpdated: {
    __typename: 'SocialConversationModel';
    id: string;
    channelType?: ChannelType | null;
    createdAt?: string | null;
    read: boolean;
    archived: boolean;
    flagged: boolean;
    status?: ConversationStatus | null;
    multipleResponsesTill?: string | null;
    canSendResponse?: boolean | null;
    createdBy?: { __typename?: 'User'; id?: string | null; displayName?: string | null } | null;
    assignedToUsers?: Array<{
      __typename?: 'Assignment';
      id: string;
      name: string;
      email: string;
    }> | null;
    channel?:
      | { __typename?: 'PairedChannelBlank'; type: ChannelType; channelIdentifier?: string | null }
      | {
          __typename?: 'PairedChannelFacebook';
          type: ChannelType;
          channelIdentifier?: string | null;
        }
      | {
          __typename?: 'PairedChannelTwitter';
          type: ChannelType;
          channelIdentifier?: string | null;
        }
      | { __typename?: 'PairedChannelVideo'; type: ChannelType; channelIdentifier?: string | null }
      | {
          __typename?: 'PairedChannelWhatsapp';
          type: ChannelType;
          channelIdentifier?: string | null;
        }
      | null;
    preview?: {
      __typename?: 'SocialTextConversationPreviewModel';
      type: TextConversationPreviewTypes;
      messageTime: string;
      content?: string | null;
      attachments?: Array<{
        __typename?: 'Attachment';
        fileName?: string | null;
        url: string;
      }> | null;
    } | null;
    events?: Array<
      | { __typename: 'ConversationArchivedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationClosedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationCreatedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationFlaggedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationForwardedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationPriorityChangedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationReadedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationStatusChangedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationUnflaggedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationUpdatedEvent'; eventTime: string; type: EventTypes }
    > | null;
    participants?: Array<{
      __typename?: 'SocialConversationParticipantModel';
      channel: ChannelType;
      channelId: string;
    }> | null;
    related?: Array<{ __typename?: 'SocialConversationModel'; id: string }> | null;
    messages: Array<{
      __typename?: 'Message';
      id: string;
      channelType: ChannelType;
      external?: boolean | null;
      content?: string | null;
      messageTime: string;
      source: string;
      destination: string;
      conversationId: string;
      attachments?: Array<{
        __typename?: 'Attachment';
        fileName?: string | null;
        url: string;
      }> | null;
      sender: { __typename: 'User'; id?: string | null; displayName?: string | null };
    }>;
  };
};

export type GetSocialConversationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetSocialConversationQuery = {
  __typename?: 'Query';
  socialConversation: {
    __typename: 'SocialConversationModel';
    id: string;
    channelType?: ChannelType | null;
    createdAt?: string | null;
    read: boolean;
    archived: boolean;
    flagged: boolean;
    status?: ConversationStatus | null;
    multipleResponsesTill?: string | null;
    canSendResponse?: boolean | null;
    createdBy?: { __typename?: 'User'; id?: string | null; displayName?: string | null } | null;
    assignedToUsers?: Array<{
      __typename?: 'Assignment';
      id: string;
      name: string;
      email: string;
    }> | null;
    channel?:
      | { __typename?: 'PairedChannelBlank'; type: ChannelType; channelIdentifier?: string | null }
      | {
          __typename?: 'PairedChannelFacebook';
          type: ChannelType;
          channelIdentifier?: string | null;
        }
      | {
          __typename?: 'PairedChannelTwitter';
          type: ChannelType;
          channelIdentifier?: string | null;
        }
      | { __typename?: 'PairedChannelVideo'; type: ChannelType; channelIdentifier?: string | null }
      | {
          __typename?: 'PairedChannelWhatsapp';
          type: ChannelType;
          channelIdentifier?: string | null;
        }
      | null;
    preview?: {
      __typename?: 'SocialTextConversationPreviewModel';
      type: TextConversationPreviewTypes;
      messageTime: string;
      content?: string | null;
      attachments?: Array<{
        __typename?: 'Attachment';
        fileName?: string | null;
        url: string;
      }> | null;
    } | null;
    events?: Array<
      | { __typename: 'ConversationArchivedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationClosedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationCreatedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationFlaggedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationForwardedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationPriorityChangedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationReadedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationStatusChangedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationUnflaggedEvent'; eventTime: string; type: EventTypes }
      | { __typename: 'ConversationUpdatedEvent'; eventTime: string; type: EventTypes }
    > | null;
    participants?: Array<{
      __typename?: 'SocialConversationParticipantModel';
      channel: ChannelType;
      channelId: string;
    }> | null;
    related?: Array<{ __typename?: 'SocialConversationModel'; id: string }> | null;
    messages: Array<{
      __typename?: 'Message';
      id: string;
      channelType: ChannelType;
      external?: boolean | null;
      content?: string | null;
      messageTime: string;
      source: string;
      destination: string;
      conversationId: string;
      attachments?: Array<{
        __typename?: 'Attachment';
        fileName?: string | null;
        url: string;
      }> | null;
      sender: { __typename: 'User'; id?: string | null; displayName?: string | null };
    }>;
  };
};

export type GetSocialConversationsPreviewQueryVariables = Exact<{
  filter?: InputMaybe<SocialConversationFilterModel>;
  sort?: InputMaybe<SortOrder>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetSocialConversationsPreviewQuery = {
  __typename?: 'Query';
  socialConversations: {
    __typename?: 'SocialConversationsResultModel';
    count: number;
    items: Array<{
      __typename: 'SocialConversationModel';
      id: string;
      channelType?: ChannelType | null;
      createdAt?: string | null;
      read: boolean;
      archived: boolean;
      flagged: boolean;
      status?: ConversationStatus | null;
      createdBy?: { __typename?: 'User'; id?: string | null; displayName?: string | null } | null;
      assignedToUsers?: Array<{
        __typename?: 'Assignment';
        id: string;
        name: string;
        email: string;
      }> | null;
      channel?:
        | {
            __typename?: 'PairedChannelBlank';
            type: ChannelType;
            channelIdentifier?: string | null;
          }
        | {
            __typename?: 'PairedChannelFacebook';
            type: ChannelType;
            channelIdentifier?: string | null;
          }
        | {
            __typename?: 'PairedChannelTwitter';
            type: ChannelType;
            channelIdentifier?: string | null;
          }
        | {
            __typename?: 'PairedChannelVideo';
            type: ChannelType;
            channelIdentifier?: string | null;
          }
        | {
            __typename?: 'PairedChannelWhatsapp';
            type: ChannelType;
            channelIdentifier?: string | null;
          }
        | null;
      preview?: {
        __typename?: 'SocialTextConversationPreviewModel';
        type: TextConversationPreviewTypes;
        messageTime: string;
        content?: string | null;
        attachments?: Array<{
          __typename?: 'Attachment';
          fileName?: string | null;
          url: string;
        }> | null;
      } | null;
    }>;
  };
};

export type GetSocialRelatedConversationsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetSocialRelatedConversationsQuery = {
  __typename?: 'Query';
  socialConversation: {
    __typename?: 'SocialConversationModel';
    id: string;
    related?: Array<{
      __typename: 'SocialConversationModel';
      id: string;
      channelType?: ChannelType | null;
      createdAt?: string | null;
      read: boolean;
      archived: boolean;
      flagged: boolean;
      status?: ConversationStatus | null;
      createdBy?: { __typename?: 'User'; id?: string | null; displayName?: string | null } | null;
      assignedToUsers?: Array<{
        __typename?: 'Assignment';
        id: string;
        name: string;
        email: string;
      }> | null;
      channel?:
        | {
            __typename?: 'PairedChannelBlank';
            type: ChannelType;
            channelIdentifier?: string | null;
          }
        | {
            __typename?: 'PairedChannelFacebook';
            type: ChannelType;
            channelIdentifier?: string | null;
          }
        | {
            __typename?: 'PairedChannelTwitter';
            type: ChannelType;
            channelIdentifier?: string | null;
          }
        | {
            __typename?: 'PairedChannelVideo';
            type: ChannelType;
            channelIdentifier?: string | null;
          }
        | {
            __typename?: 'PairedChannelWhatsapp';
            type: ChannelType;
            channelIdentifier?: string | null;
          }
        | null;
      preview?: {
        __typename?: 'SocialTextConversationPreviewModel';
        type: TextConversationPreviewTypes;
        messageTime: string;
        content?: string | null;
        attachments?: Array<{
          __typename?: 'Attachment';
          fileName?: string | null;
          url: string;
        }> | null;
      } | null;
    }> | null;
  };
};

export type RemoveSocialConversationAttachementMutationVariables = Exact<{
  input: RemoveSocialMessageAttachmentInputModel;
}>;

export type RemoveSocialConversationAttachementMutation = {
  __typename?: 'Mutation';
  removeSocialConversationAttachment: boolean;
};

export type SendSocialConversationTextMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SendConversationTextInput;
}>;

export type SendSocialConversationTextMutation = {
  __typename?: 'Mutation';
  sendSocialConversationText: {
    __typename?: 'MutationResult';
    success: boolean;
    message?: string | null;
  };
};

export type UpdateSocialConversationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSocialConversationInputModel;
}>;

export type UpdateSocialConversationMutation = {
  __typename?: 'Mutation';
  updateSocialConversation: {
    __typename: 'SocialConversationModel';
    id: string;
    channelType?: ChannelType | null;
    createdAt?: string | null;
    read: boolean;
    archived: boolean;
    flagged: boolean;
    status?: ConversationStatus | null;
    createdBy?: { __typename?: 'User'; id?: string | null; displayName?: string | null } | null;
    assignedToUsers?: Array<{
      __typename?: 'Assignment';
      id: string;
      name: string;
      email: string;
    }> | null;
    channel?:
      | { __typename?: 'PairedChannelBlank'; type: ChannelType; channelIdentifier?: string | null }
      | {
          __typename?: 'PairedChannelFacebook';
          type: ChannelType;
          channelIdentifier?: string | null;
        }
      | {
          __typename?: 'PairedChannelTwitter';
          type: ChannelType;
          channelIdentifier?: string | null;
        }
      | { __typename?: 'PairedChannelVideo'; type: ChannelType; channelIdentifier?: string | null }
      | {
          __typename?: 'PairedChannelWhatsapp';
          type: ChannelType;
          channelIdentifier?: string | null;
        }
      | null;
    preview?: {
      __typename?: 'SocialTextConversationPreviewModel';
      type: TextConversationPreviewTypes;
      messageTime: string;
      content?: string | null;
      attachments?: Array<{
        __typename?: 'Attachment';
        fileName?: string | null;
        url: string;
      }> | null;
    } | null;
  };
};

export type WithdrawSocialConversationMutationVariables = Exact<{
  input: WithdrawSocialConversationInputModel;
}>;

export type WithdrawSocialConversationMutation = {
  __typename?: 'Mutation';
  withdrawSocialConversation: boolean;
};

export type CreateCustomerCrmContactMutationVariables = Exact<{
  input: CreateCustomerCrmContactInput;
}>;

export type CreateCustomerCrmContactMutation = {
  __typename?: 'Mutation';
  createCustomerCrmContact: {
    __typename?: 'CustomerCrmContact';
    id: number;
    title?: string | null;
    firstName?: string | null;
    lastName: string;
    sex?: CustomerCrmContactSexes | null;
    functionName?: string | null;
    addresses?: Array<{
      __typename?: 'CustomerCrmContactAddress';
      id: number;
      city?: string | null;
      country?: string | null;
      postalCode?: string | null;
      address?: string | null;
      description: string;
    }> | null;
    communications?: Array<{
      __typename?: 'CustomerCrmContactCommunication';
      sequence?: number | null;
      value?: string | null;
      description?: string | null;
      forwardStatus: CustomerCrmContactCommunicationStatusses;
      forwardCondition?: string | null;
      passThroughStatus: CustomerCrmContactCommunicationStatusses;
      passThroughCondition?: string | null;
      type: {
        __typename?: 'CustomerCrmContactCommunicationType';
        id: number;
        name?: string | null;
        category: CustomerCrmContactCommunicationTypeCategories;
      };
    }> | null;
    groups?: Array<{
      __typename?: 'CustomerCrmContactGroupRelation';
      groupId: number;
      subGroupId: number;
      group: {
        __typename?: 'CustomerCrmContactGroup';
        id: number;
        name?: string | null;
        subGroups?: Array<{
          __typename?: 'CustomerCrmContactSubGroup';
          id: number;
          name?: string | null;
        }> | null;
      };
      subGroup: { __typename?: 'CustomerCrmContactSubGroup'; id: number; name?: string | null };
    }> | null;
  };
};

export type DeleteCustomerCrmContactMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DeleteCustomerCrmContactMutation = {
  __typename?: 'Mutation';
  deleteCustomerCrmContact: { __typename?: 'MutationResult'; success: boolean };
};

export type GetCustomerCrmContactCommunicationTypesQueryVariables = Exact<{
  filter?: InputMaybe<CustomerCrmContactCommunicationTypeFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type GetCustomerCrmContactCommunicationTypesQuery = {
  __typename?: 'Query';
  customerCrmContactCommunicationTypes: {
    __typename?: 'CustomerCrmContactCommunicationTypesResult';
    count: number;
    items: Array<{
      __typename?: 'CustomerCrmContactCommunicationType';
      id: number;
      name?: string | null;
      category: CustomerCrmContactCommunicationTypeCategories;
    }>;
  };
};

export type GetCustomerCrmContactGroupsQueryVariables = Exact<{
  filter?: InputMaybe<CustomerCrmContactGroupFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type GetCustomerCrmContactGroupsQuery = {
  __typename?: 'Query';
  customerCrmContactGroups: {
    __typename?: 'CustomerCrmContactGroupsResult';
    count: number;
    items: Array<{
      __typename?: 'CustomerCrmContactGroup';
      id: number;
      name?: string | null;
      subGroups?: Array<{
        __typename?: 'CustomerCrmContactSubGroup';
        id: number;
        name?: string | null;
      }> | null;
    }>;
  };
};

export type GetCustomerCrmContactsQueryVariables = Exact<{
  filter?: InputMaybe<CustomerCrmContactFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type GetCustomerCrmContactsQuery = {
  __typename?: 'Query';
  customerCrmContacts: {
    __typename?: 'CustomerCrmContactsResult';
    count: number;
    items: Array<{
      __typename?: 'CustomerCrmContact';
      id: number;
      title?: string | null;
      firstName?: string | null;
      lastName: string;
      sex?: CustomerCrmContactSexes | null;
      functionName?: string | null;
      addresses?: Array<{
        __typename?: 'CustomerCrmContactAddress';
        id: number;
        city?: string | null;
        country?: string | null;
        postalCode?: string | null;
        address?: string | null;
        description: string;
      }> | null;
      communications?: Array<{
        __typename?: 'CustomerCrmContactCommunication';
        sequence?: number | null;
        value?: string | null;
        description?: string | null;
        forwardStatus: CustomerCrmContactCommunicationStatusses;
        forwardCondition?: string | null;
        passThroughStatus: CustomerCrmContactCommunicationStatusses;
        passThroughCondition?: string | null;
        type: {
          __typename?: 'CustomerCrmContactCommunicationType';
          id: number;
          name?: string | null;
          category: CustomerCrmContactCommunicationTypeCategories;
        };
      }> | null;
      groups?: Array<{
        __typename?: 'CustomerCrmContactGroupRelation';
        groupId: number;
        subGroupId: number;
        group: {
          __typename?: 'CustomerCrmContactGroup';
          id: number;
          name?: string | null;
          subGroups?: Array<{
            __typename?: 'CustomerCrmContactSubGroup';
            id: number;
            name?: string | null;
          }> | null;
        };
        subGroup: { __typename?: 'CustomerCrmContactSubGroup'; id: number; name?: string | null };
      }> | null;
    }>;
  };
};

export type UpdateCustomerCrmContactMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateCustomerCrmContactInput;
}>;

export type UpdateCustomerCrmContactMutation = {
  __typename?: 'Mutation';
  updateCustomerCrmContact: {
    __typename?: 'CustomerCrmContact';
    id: number;
    title?: string | null;
    firstName?: string | null;
    lastName: string;
    sex?: CustomerCrmContactSexes | null;
    functionName?: string | null;
    addresses?: Array<{
      __typename?: 'CustomerCrmContactAddress';
      id: number;
      city?: string | null;
      country?: string | null;
      postalCode?: string | null;
      address?: string | null;
      description: string;
    }> | null;
    communications?: Array<{
      __typename?: 'CustomerCrmContactCommunication';
      sequence?: number | null;
      value?: string | null;
      description?: string | null;
      forwardStatus: CustomerCrmContactCommunicationStatusses;
      forwardCondition?: string | null;
      passThroughStatus: CustomerCrmContactCommunicationStatusses;
      passThroughCondition?: string | null;
      type: {
        __typename?: 'CustomerCrmContactCommunicationType';
        id: number;
        name?: string | null;
        category: CustomerCrmContactCommunicationTypeCategories;
      };
    }> | null;
    groups?: Array<{
      __typename?: 'CustomerCrmContactGroupRelation';
      groupId: number;
      subGroupId: number;
      group: {
        __typename?: 'CustomerCrmContactGroup';
        id: number;
        name?: string | null;
        subGroups?: Array<{
          __typename?: 'CustomerCrmContactSubGroup';
          id: number;
          name?: string | null;
        }> | null;
      };
      subGroup: { __typename?: 'CustomerCrmContactSubGroup'; id: number; name?: string | null };
    }> | null;
  };
};

export type GetDashboardQueryVariables = Exact<{ [key: string]: never }>;

export type GetDashboardQuery = {
  __typename?: 'Query';
  dashboard: {
    __typename?: 'Dashboard';
    socialConversations: {
      __typename?: 'DashboardConversation';
      total: number;
      countsByStatus: Array<{
        __typename?: 'DashboardConversationStatus';
        status: ConversationStatus;
        total: number;
      }>;
    };
    meccaConversations: {
      __typename?: 'DashboardConversation';
      total: number;
      countsByStatus: Array<{
        __typename?: 'DashboardConversationStatus';
        status: ConversationStatus;
        total: number;
      }>;
    };
    invoices: { __typename?: 'DashboardInvoice'; current?: number | null; open: number };
  };
};

export type GetDashboardNotificationsQueryVariables = Exact<{
  filter?: InputMaybe<NotificationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type GetDashboardNotificationsQuery = {
  __typename?: 'Query';
  dashboard: {
    __typename?: 'Dashboard';
    notifications: {
      __typename?: 'NotificationsResult';
      count: number;
      items: Array<
        | {
            __typename?: 'NotificationConversation';
            status: ConversationStatus;
            conversationId: string;
            date: string;
            type: NotificationTypes;
            conversation: {
              __typename?: 'SocialConversationModel';
              createdBy?: {
                __typename?: 'User';
                displayName?: string | null;
                firstName?: string | null;
                lastName?: string | null;
              } | null;
            };
          }
        | {
            __typename?: 'NotificationInvoice';
            amount: number;
            date: string;
            type: NotificationTypes;
            invoice: { __typename?: 'Invoice'; id: number };
          }
      >;
    };
  };
};

export type CreateCustomerTemporaryInstructionMutationVariables = Exact<{
  input: CreateCustomerTemporaryInstructionInput;
}>;

export type CreateCustomerTemporaryInstructionMutation = {
  __typename?: 'Mutation';
  createCustomerTemporaryInstruction: {
    __typename?: 'CustomerTemporaryInstruction';
    id: number;
    updatedAt: string;
    name: string;
    content: string;
    validFrom: string;
    validUntil: string;
    active: boolean;
  };
};

export type DeleteCustomerTemporaryInstructionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DeleteCustomerTemporaryInstructionMutation = {
  __typename?: 'Mutation';
  deleteCustomerTemporaryInstruction: { __typename?: 'MutationResult'; success: boolean };
};

export type GetCustomerFixedInstructionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<CustomerFixedInstructionFilterInput>;
}>;

export type GetCustomerFixedInstructionsQuery = {
  __typename?: 'Query';
  customerFixedInstructions: {
    __typename?: 'CustomerFixedInstructionsResult';
    count: number;
    items: Array<{
      __typename?: 'CustomerFixedInstruction';
      id: number;
      updatedAt: string;
      name: string;
      content: string;
    }>;
  };
};

export type GetCustomerTemporaryInstructionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<CustomerTemporaryInstructionFilterInput>;
}>;

export type GetCustomerTemporaryInstructionsQuery = {
  __typename?: 'Query';
  customerTemporaryInstructions: {
    __typename?: 'CustomerTemporaryInstructionsResult';
    count: number;
    items: Array<{
      __typename?: 'CustomerTemporaryInstruction';
      id: number;
      updatedAt: string;
      name: string;
      content: string;
      validFrom: string;
      validUntil: string;
      active: boolean;
      deleted: boolean;
      createdInMeCCA: boolean;
    }>;
  };
};

export type UpdateCustomerTemporaryInstructionMutationVariables = Exact<{
  input: UpdateCustomerTemporaryInstructionInput;
  id: Scalars['Int']['input'];
}>;

export type UpdateCustomerTemporaryInstructionMutation = {
  __typename?: 'Mutation';
  updateCustomerTemporaryInstruction: { __typename?: 'CustomerTemporaryInstruction'; id: number };
};

export type GetInvoicesQueryVariables = Exact<{
  filter?: InputMaybe<InvoiceFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  year?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetInvoicesQuery = {
  __typename?: 'Query';
  invoices: {
    __typename?: 'InvoicesResult';
    count: number;
    items: Array<{
      __typename?: 'Invoice';
      id: number;
      amount: number;
      date: string;
      dueDate?: string | null;
      year: number;
      month: number;
      invoiceNr: number;
      paid: boolean;
      type: InvoiceTypes;
      attachment?: { __typename?: 'Attachment'; fileName?: string | null; url: string } | null;
    }>;
  };
};

export type PayInvoiceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type PayInvoiceMutation = {
  __typename?: 'Mutation';
  payInvoice: { __typename?: 'PayInvoiceResult'; redirectUrl?: string | null };
};

export type ActivateChannelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ActivateChannelMutation = {
  __typename?: 'Mutation';
  activateChannel: { __typename?: 'MutationResult'; success: boolean };
};

export type DeactivateChannelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeactivateChannelMutation = {
  __typename?: 'Mutation';
  deactivateChannel: { __typename?: 'MutationResult'; success: boolean };
};

export type GetPairedChannelsQueryVariables = Exact<{
  filter?: InputMaybe<PairedChannelFilterInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetPairedChannelsQuery = {
  __typename?: 'Query';
  pairedChannels: {
    __typename?: 'PairedChannelsResult';
    count: number;
    items: Array<
      | {
          __typename?: 'PairedChannelBlank';
          id: string;
          type: ChannelType;
          account: string;
          active: boolean;
          channelIdentifier?: string | null;
          redirect?: boolean | null;
          redirectDelay?: number | null;
        }
      | {
          __typename?: 'PairedChannelFacebook';
          id: string;
          type: ChannelType;
          account: string;
          active: boolean;
          channelIdentifier?: string | null;
          redirect?: boolean | null;
          redirectDelay?: number | null;
        }
      | {
          __typename?: 'PairedChannelTwitter';
          id: string;
          type: ChannelType;
          account: string;
          active: boolean;
          channelIdentifier?: string | null;
          redirect?: boolean | null;
          redirectDelay?: number | null;
        }
      | {
          __typename?: 'PairedChannelVideo';
          id: string;
          type: ChannelType;
          account: string;
          active: boolean;
          channelIdentifier?: string | null;
          redirect?: boolean | null;
          redirectDelay?: number | null;
        }
      | {
          __typename?: 'PairedChannelWhatsapp';
          id: string;
          type: ChannelType;
          account: string;
          active: boolean;
          channelIdentifier?: string | null;
          redirect?: boolean | null;
          redirectDelay?: number | null;
        }
    >;
  };
};

export type PairChannelMutationVariables = Exact<{
  input: PairChannelInput;
}>;

export type PairChannelMutation = {
  __typename?: 'Mutation';
  pairChannel:
    | {
        __typename?: 'PairedChannelBlank';
        id: string;
        type: ChannelType;
        account: string;
        active: boolean;
      }
    | {
        __typename?: 'PairedChannelFacebook';
        id: string;
        type: ChannelType;
        account: string;
        active: boolean;
      }
    | {
        __typename?: 'PairedChannelTwitter';
        id: string;
        type: ChannelType;
        account: string;
        active: boolean;
      }
    | {
        __typename?: 'PairedChannelVideo';
        id: string;
        type: ChannelType;
        account: string;
        active: boolean;
      }
    | {
        __typename?: 'PairedChannelWhatsapp';
        id: string;
        type: ChannelType;
        account: string;
        active: boolean;
      };
};

export type UnpairChannelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type UnpairChannelMutation = {
  __typename?: 'Mutation';
  unpairChannel: { __typename?: 'MutationResult'; success: boolean };
};

export type UpdateChannelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: PairedChannelUpdateInput;
}>;

export type UpdateChannelMutation = {
  __typename?: 'Mutation';
  updateChannel:
    | { __typename?: 'PairedChannelBlank'; id: string }
    | { __typename?: 'PairedChannelFacebook'; id: string }
    | { __typename?: 'PairedChannelTwitter'; id: string }
    | { __typename?: 'PairedChannelVideo'; id: string }
    | { __typename?: 'PairedChannelWhatsapp'; id: string };
};

type BaseCallReporting_DurationTimeReporting_Fragment = {
  __typename?: 'DurationTimeReporting';
  totalNrOfCalls: number;
  title: string;
  yAxisTitle: string;
  xAxisTitle: string;
  yAxisValues: Array<number>;
  xAxisValues: Array<string>;
};

type BaseCallReporting_MissedCallsReporting_Fragment = {
  __typename?: 'MissedCallsReporting';
  totalNrOfCalls: number;
  title: string;
  yAxisTitle: string;
  xAxisTitle: string;
  yAxisValues: Array<number>;
  xAxisValues: Array<string>;
};

type BaseCallReporting_NrOfCallsPerHourReporting_Fragment = {
  __typename?: 'NrOfCallsPerHourReporting';
  totalNrOfCalls: number;
  title: string;
  yAxisTitle: string;
  xAxisTitle: string;
  yAxisValues: Array<number>;
  xAxisValues: Array<string>;
};

type BaseCallReporting_WaitingTimeReporting_Fragment = {
  __typename?: 'WaitingTimeReporting';
  totalNrOfCalls: number;
  title: string;
  yAxisTitle: string;
  xAxisTitle: string;
  yAxisValues: Array<number>;
  xAxisValues: Array<string>;
};

export type BaseCallReportingFragment =
  | BaseCallReporting_DurationTimeReporting_Fragment
  | BaseCallReporting_MissedCallsReporting_Fragment
  | BaseCallReporting_NrOfCallsPerHourReporting_Fragment
  | BaseCallReporting_WaitingTimeReporting_Fragment;

export type CallDetailFragment = {
  __typename?: 'CallResult';
  phoneNumber: string;
  callStats: {
    __typename?: 'CallStats';
    nrOfCallsDay: number;
    nrOfCallsNight: number;
    totalDurationDay: number;
    totalDurationNight: number;
  };
  callList: Array<{
    __typename?: 'CallModel';
    dayNight: DayNightCallTypes;
    callDateTime: string;
    callDuration: number;
    caller?: string | null;
  }>;
};

export type CallReportingQueryVariables = Exact<{
  filter?: InputMaybe<FilterInput>;
}>;

export type CallReportingQuery = {
  __typename?: 'Query';
  callReporting?: {
    __typename?: 'CallReportingResult';
    waitingTimeStatistics: {
      __typename?: 'WaitingTimeReporting';
      averageWaitingTime: number;
      totalNrOfCalls: number;
      title: string;
      yAxisTitle: string;
      xAxisTitle: string;
      yAxisValues: Array<number>;
      xAxisValues: Array<string>;
    };
    durationTimeStatistics: {
      __typename?: 'DurationTimeReporting';
      averageDuration: number;
      totalNrOfCalls: number;
      title: string;
      yAxisTitle: string;
      xAxisTitle: string;
      yAxisValues: Array<number>;
      xAxisValues: Array<string>;
    };
    missedCallStatistics: {
      __typename?: 'MissedCallsReporting';
      canBeDisplayed?: boolean | null;
      averageWaitingTime: number;
      totalNrOfCalls: number;
      title: string;
      yAxisTitle: string;
      xAxisTitle: string;
      yAxisValues: Array<number>;
      xAxisValues: Array<string>;
    };
    nrOfCallsPerHourStatistics: {
      __typename?: 'NrOfCallsPerHourReporting';
      totalNrOfCalls: number;
      title: string;
      yAxisTitle: string;
      xAxisTitle: string;
      yAxisValues: Array<number>;
      xAxisValues: Array<string>;
    };
  } | null;
};

export type DownloadIncomingCallReportingQueryVariables = Exact<{
  filter?: InputMaybe<FilterInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<LangEnum>;
}>;

export type DownloadIncomingCallReportingQuery = {
  __typename?: 'Query';
  downloadIncomingCallReporting: {
    __typename?: 'DownloadResult';
    content: string;
    contentType: string;
    fileName: string;
  };
};

export type DownloadOutgoingCallReportingQueryVariables = Exact<{
  filter?: InputMaybe<FilterInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<LangEnum>;
}>;

export type DownloadOutgoingCallReportingQuery = {
  __typename?: 'Query';
  downloadOutgoingCallReporting: {
    __typename?: 'DownloadResult';
    content: string;
    contentType: string;
    fileName: string;
  };
};

export type IncomingCallsQueryVariables = Exact<{
  filter?: InputMaybe<CallFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type IncomingCallsQuery = {
  __typename?: 'Query';
  incomingCalls: Array<{
    __typename?: 'CallResult';
    phoneNumber: string;
    callStats: {
      __typename?: 'CallStats';
      nrOfCallsDay: number;
      nrOfCallsNight: number;
      totalDurationDay: number;
      totalDurationNight: number;
    };
    callList: Array<{
      __typename?: 'CallModel';
      dayNight: DayNightCallTypes;
      callDateTime: string;
      callDuration: number;
      caller?: string | null;
    }>;
  }>;
};

export type OutgoingCallsQueryVariables = Exact<{
  filter?: InputMaybe<CallFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  ignoreLimitOffset?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type OutgoingCallsQuery = {
  __typename?: 'Query';
  outgoingCalls: Array<{
    __typename?: 'CallResult';
    phoneNumber: string;
    callStats: {
      __typename?: 'CallStats';
      nrOfCallsDay: number;
      nrOfCallsNight: number;
      totalDurationDay: number;
      totalDurationNight: number;
    };
    callList: Array<{
      __typename?: 'CallModel';
      dayNight: DayNightCallTypes;
      callDateTime: string;
      callDuration: number;
      caller?: string | null;
    }>;
  }>;
};

export type SearchQueryVariables = Exact<{
  filter?: InputMaybe<SearchFilterInput>;
  search: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type SearchQuery = {
  __typename?: 'Query';
  search: {
    __typename?: 'SearchResult';
    count: number;
    countByType: Array<{ __typename?: 'SearchTypeCount'; count: number; type: SearchTypes }>;
    items: Array<
      | {
          __typename?: 'SearchAgentMessage';
          type: SearchTypes;
          agentMessage?: {
            __typename?: 'AgentMessage';
            id: string;
            channelType: ChannelType;
            content?: string | null;
            conversationId: string;
            messageTime: string;
            sender: {
              __typename?: 'User';
              id?: string | null;
              firstName?: string | null;
              lastName?: string | null;
            };
          } | null;
        }
      | {
          __typename?: 'SearchAttachment';
          type: SearchTypes;
          attachment?: { __typename?: 'Attachment'; fileName?: string | null; url: string } | null;
        }
      | {
          __typename?: 'SearchCustomerCrmContact';
          type: SearchTypes;
          customerCrmContact?: {
            __typename?: 'CustomerCrmContact';
            id: number;
            title?: string | null;
            firstName?: string | null;
            lastName: string;
            sex?: CustomerCrmContactSexes | null;
            functionName?: string | null;
            addresses?: Array<{
              __typename?: 'CustomerCrmContactAddress';
              id: number;
              city?: string | null;
              country?: string | null;
              postalCode?: string | null;
              address?: string | null;
              description: string;
            }> | null;
            communications?: Array<{
              __typename?: 'CustomerCrmContactCommunication';
              sequence?: number | null;
              value?: string | null;
              description?: string | null;
              forwardStatus: CustomerCrmContactCommunicationStatusses;
              forwardCondition?: string | null;
              passThroughStatus: CustomerCrmContactCommunicationStatusses;
              passThroughCondition?: string | null;
              type: {
                __typename?: 'CustomerCrmContactCommunicationType';
                id: number;
                name?: string | null;
                category: CustomerCrmContactCommunicationTypeCategories;
              };
            }> | null;
            groups?: Array<{
              __typename?: 'CustomerCrmContactGroupRelation';
              groupId: number;
              subGroupId: number;
              group: {
                __typename?: 'CustomerCrmContactGroup';
                id: number;
                name?: string | null;
                subGroups?: Array<{
                  __typename?: 'CustomerCrmContactSubGroup';
                  id: number;
                  name?: string | null;
                }> | null;
              };
              subGroup: {
                __typename?: 'CustomerCrmContactSubGroup';
                id: number;
                name?: string | null;
              };
            }> | null;
          } | null;
        }
      | {
          __typename?: 'SearchCustomerFixedInstruction';
          type: SearchTypes;
          customerFixedInstruction?: {
            __typename?: 'CustomerFixedInstruction';
            id: number;
            updatedAt: string;
            name: string;
            content: string;
          } | null;
        }
      | {
          __typename?: 'SearchCustomerTemporaryInstruction';
          type: SearchTypes;
          customerTemporaryInstruction?: {
            __typename?: 'CustomerTemporaryInstruction';
            id: number;
            updatedAt: string;
            name: string;
            content: string;
            validFrom: string;
            validUntil: string;
            active: boolean;
          } | null;
        }
      | {
          __typename?: 'SearchMessage';
          type: SearchTypes;
          message?: {
            __typename?: 'Message';
            id: string;
            channelType: ChannelType;
            content?: string | null;
            conversationId: string;
            messageTime: string;
            sender: {
              __typename?: 'User';
              id?: string | null;
              firstName?: string | null;
              lastName?: string | null;
            };
          } | null;
        }
    >;
  };
};

export type GetThemeQueryVariables = Exact<{ [key: string]: never }>;

export type GetThemeQuery = {
  __typename?: 'Query';
  theme: {
    __typename?: 'Theme';
    colors: {
      __typename?: 'Colors';
      error: string;
      info: string;
      primary: string;
      primaryDarkShade: string;
      primaryLightShade: string;
      secondary: string;
      secondaryDarkShade: string;
      secondaryLightShade: string;
      success: string;
      warning: string;
    };
    images: Array<{ __typename?: 'Image'; type: string; url: string }>;
  };
};

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;

export type CreateUserMutation = {
  __typename?: 'Mutation';
  createUser: { __typename?: 'User'; id?: string | null };
};

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteUserMutation = {
  __typename?: 'Mutation';
  deleteUser: { __typename?: 'MutationResult'; success: boolean };
};

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentUserQuery = {
  __typename?: 'Query';
  getCurrentUser: {
    __typename?: 'User';
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    customers?: Array<string> | null;
    emailAddress?: string | null;
    role?: UserRole | null;
    phoneNumber?: string | null;
    locale?: string | null;
  };
};

export type GetCountriesQueryVariables = Exact<{
  filter?: InputMaybe<CountryFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type GetCountriesQuery = {
  __typename?: 'Query';
  countries: {
    __typename?: 'CountriesResult';
    count: number;
    items: Array<{ __typename?: 'Country'; iso: string; name: string }>;
  };
};

export type GetCustomerQueryVariables = Exact<{
  filter?: InputMaybe<CustomerFilterInput>;
}>;

export type GetCustomerQuery = {
  __typename?: 'Query';
  customer: {
    __typename?: 'Customer';
    id: string;
    name: string;
    platformId?: string | null;
    parentId?: string | null;
    groupId?: string | null;
    appointmentContractYn?: boolean | null;
  };
};

export type GetCustomerChatDataQueryVariables = Exact<{ [key: string]: never }>;

export type GetCustomerChatDataQuery = {
  __typename?: 'Query';
  customerChatData: {
    __typename?: 'CustomerChatData';
    guid: string;
    username: string;
    extension: number;
    mainFicheId: string;
    customerId: string;
    userEmail: string;
    serviceGroup: string;
  };
};

export type GetCustomersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<CustomerFilterInput>;
}>;

export type GetCustomersQuery = {
  __typename?: 'Query';
  customers: {
    __typename?: 'CustomersResult';
    count: number;
    items: Array<{
      __typename?: 'Customer';
      id: string;
      platformId?: string | null;
      parentId?: string | null;
      name: string;
      groupId?: string | null;
      appointmentContractYn?: boolean | null;
    }>;
  };
};

export type GetCustomersWithInfoQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<CustomerFilterInput>;
}>;

export type GetCustomersWithInfoQuery = {
  __typename?: 'Query';
  customers: {
    __typename?: 'CustomersResult';
    count: number;
    items: Array<{
      __typename?: 'Customer';
      id: string;
      platformId?: string | null;
      parentId?: string | null;
      name: string;
      info?: {
        __typename?: 'CustomerInfo';
        welcomeMessage?: string | null;
        contactInformationList: Array<{
          __typename?: 'CustomerContactInformation';
          type: CustomerContactInformationTypes;
          emailAddress?: string | null;
          faxNumber?: string | null;
          mobilePhoneNumber?: string | null;
          phoneNumber1?: string | null;
          phoneNumber2?: string | null;
          website?: string | null;
          address?: {
            __typename?: 'Address';
            city?: string | null;
            country?: string | null;
            postalCode?: string | null;
            street?: string | null;
            streetNumber?: string | null;
            box?: string | null;
          } | null;
        }>;
      } | null;
    }>;
  };
};

export type GetDefaultLocaleQueryVariables = Exact<{ [key: string]: never }>;

export type GetDefaultLocaleQuery = {
  __typename?: 'Query';
  defaultLocale: Array<{
    __typename?: 'DefaultLocale';
    type: TextLocation;
    content: Array<{ __typename?: 'Content'; language: Language; value: string }>;
  }>;
};

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetUserQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    customers?: Array<string> | null;
    emailAddress?: string | null;
    role?: UserRole | null;
    phoneNumber?: string | null;
    locale?: string | null;
  };
};

export type GetUserStatusQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserStatusQuery = {
  __typename?: 'Query';
  userStatus: { __typename?: 'UserStatus'; active: boolean };
};

export type GetUsersQueryVariables = Exact<{
  filter?: InputMaybe<UsersFilterInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetUsersQuery = {
  __typename?: 'Query';
  users: {
    __typename?: 'UsersResult';
    count: number;
    items: Array<{
      __typename?: 'User';
      id?: string | null;
      emailAddress?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber?: string | null;
      role?: UserRole | null;
    }>;
  };
};

export type LogoutQueryVariables = Exact<{ [key: string]: never }>;

export type LogoutQuery = { __typename?: 'Query'; logout: boolean };

export type UpdateCurrentUserLocaleMutationVariables = Exact<{
  locale: Scalars['String']['input'];
}>;

export type UpdateCurrentUserLocaleMutation = {
  __typename?: 'Mutation';
  updateCurrentUserLocale: boolean;
};

export type UpdateCustomerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateCustomerInput;
}>;

export type UpdateCustomerMutation = {
  __typename?: 'Mutation';
  updateCustomer: {
    __typename?: 'Customer';
    id: string;
    name: string;
    info?: {
      __typename?: 'CustomerInfo';
      contactInformationList: Array<{
        __typename?: 'CustomerContactInformation';
        type: CustomerContactInformationTypes;
        emailAddress?: string | null;
        faxNumber?: string | null;
        mobilePhoneNumber?: string | null;
        phoneNumber1?: string | null;
        phoneNumber2?: string | null;
        website?: string | null;
        address?: {
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          postalCode?: string | null;
          street?: string | null;
          streetNumber?: string | null;
          box?: string | null;
        } | null;
      }>;
    } | null;
  };
};

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser: { __typename?: 'User'; id?: string | null };
};

export type UpdateUserStatusMutationVariables = Exact<{
  input: UpdateUserStatusInput;
}>;

export type UpdateUserStatusMutation = {
  __typename?: 'Mutation';
  updateUserStatus: { __typename?: 'UserStatus'; active: boolean };
};

export type UserStatusUpdatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type UserStatusUpdatedSubscription = {
  __typename?: 'Subscription';
  userStatusUpdated: { __typename?: 'UserStatus'; active: boolean };
};

export type RegisterWebpushMutationVariables = Exact<{
  input: RegisterWebPushInput;
}>;

export type RegisterWebpushMutation = {
  __typename?: 'Mutation';
  registerWebpush: { __typename?: 'MutationResult'; success: boolean };
};

export const MeccaConversationDetailsFragmentDoc = gql`
  fragment meccaConversationDetails on MeccaConversationModel {
    id
    ... on MeccaTextConversationModel {
      channelType
      createdAt
      __typename
      events {
        eventTime
        __typename
      }
      related {
        id
        __typename
      }
      channel {
        channelIdentifier
        type
        __typename
      }
      createdBy {
        id
        displayName
        __typename
      }
      messages {
        __typename
      }
      agentMessages {
        id
        messages {
          content
          messageTime
          sender {
            displayName
            __typename
          }
          __typename
        }
        attachments {
          id
          fileName
          url
          __typename
        }
        structuredMessage {
          name
          fields {
            sequence
            fieldType {
              name
              regExForValidation
              regExForValidChars
              mask
              maxLength
              errorMessage
              __typename
            }
            label
            description
            required
            readonly
            defaultValue
            options
            __typename
          }
          values {
            sequence
            value
            __typename
          }
          __typename
        }
        __typename
      }
      attachments {
        id
        fileName
        name
        fileTypeId
        dateTimeAdded
        url
      }
      read
      flagged
      status
      unformattedBodyText
      unformattedText
      htmlStructuredMessage
      htmlMessage
      assignedToUsers {
        id
        name
        email
      }
    }
  }
`;
export const MeccaConversationPreviewFragmentDoc = gql`
  fragment meccaConversationPreview on MeccaConversationModel {
    id
    assignedToUsers {
      id
      name
      email
    }
    ... on MeccaTextConversationModel {
      channelType
      createdAt
      __typename
      channel {
        channelIdentifier
        type
        __typename
      }
      createdBy {
        id
        displayName
        __typename
      }
      read
      flagged
      status
      unformattedBodyText
      unformattedText
      htmlStructuredMessage
      htmlMessage
      attachments {
        id
        fileName
        url
        __typename
      }
    }
  }
`;
export const ConversationDetailFragmentDoc = gql`
  fragment conversationDetail on Conversation {
    id
    createdBy {
      displayName
    }
    events {
      eventTime
      __typename
    }
    participants {
      channel
      channelId
    }
    related {
      id
    }
    read
    archived
    __typename
  }
`;
export const ConversationPreviewFragmentDoc = gql`
  fragment conversationPreview on Conversation {
    id
    channelType
    createdAt
    createdBy {
      displayName
    }
    flagged
    archived
    read
    assignedToUsers {
      id
      name
      email
    }
    __typename
  }
`;
export const SocialConversationDetailsFragmentDoc = gql`
  fragment socialConversationDetails on SocialConversationModel {
    id
    channelType
    createdAt
    __typename
    createdBy {
      id
      displayName
    }
    read
    archived
    flagged
    assignedToUsers {
      id
      name
      email
    }
    channel {
      type
      channelIdentifier
    }
    status
    preview {
      type
      messageTime
      content
      attachments {
        fileName
        url
      }
    }
    events {
      eventTime
      type
      __typename
    }
    participants {
      channel
      channelId
    }
    related {
      id
    }
    multipleResponsesTill
    canSendResponse
    messages {
      id
      channelType
      external
      attachments {
        fileName
        url
      }
      content
      messageTime
      sender {
        id
        displayName
        __typename
      }
      source
      destination
      conversationId
    }
  }
`;
export const SocialConversationPreviewFragmentDoc = gql`
  fragment socialConversationPreview on SocialConversationModel {
    id
    channelType
    createdAt
    __typename
    createdBy {
      id
      displayName
    }
    read
    archived
    flagged
    assignedToUsers {
      id
      name
      email
    }
    channel {
      type
      channelIdentifier
    }
    status
    preview {
      type
      messageTime
      content
      attachments {
        fileName
        url
      }
    }
  }
`;
export const BaseCallReportingFragmentDoc = gql`
  fragment baseCallReporting on CallBaseReporting {
    totalNrOfCalls
    title
    yAxisTitle
    xAxisTitle
    yAxisValues
    xAxisValues
  }
`;
export const CallDetailFragmentDoc = gql`
  fragment callDetail on CallResult {
    phoneNumber
    callStats {
      nrOfCallsDay
      nrOfCallsNight
      totalDurationDay
      totalDurationNight
    }
    callList {
      dayNight
      callDateTime
      callDuration
      caller
    }
  }
`;
export const CreateCustomerAttachmentDocument = gql`
  mutation createCustomerAttachment($input: CreateCustomerAttachmentInput!) {
    createCustomerAttachment(input: $input) {
      id
      name
      validFrom
      validTill
      attachment {
        fileName
        url
      }
      active
    }
  }
`;
export type CreateCustomerAttachmentMutationFn = Apollo.MutationFunction<
  CreateCustomerAttachmentMutation,
  CreateCustomerAttachmentMutationVariables
>;

/**
 * __useCreateCustomerAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateCustomerAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerAttachmentMutation, { data, loading, error }] = useCreateCustomerAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomerAttachmentMutation,
    CreateCustomerAttachmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCustomerAttachmentMutation,
    CreateCustomerAttachmentMutationVariables
  >(CreateCustomerAttachmentDocument, options);
}
export type CreateCustomerAttachmentMutationHookResult = ReturnType<
  typeof useCreateCustomerAttachmentMutation
>;
export type CreateCustomerAttachmentMutationResult =
  Apollo.MutationResult<CreateCustomerAttachmentMutation>;
export type CreateCustomerAttachmentMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomerAttachmentMutation,
  CreateCustomerAttachmentMutationVariables
>;
export const DeleteCustomerAttachmentDocument = gql`
  mutation deleteCustomerAttachment($id: Int!) {
    deleteCustomerAttachment(id: $id) {
      success
    }
  }
`;
export type DeleteCustomerAttachmentMutationFn = Apollo.MutationFunction<
  DeleteCustomerAttachmentMutation,
  DeleteCustomerAttachmentMutationVariables
>;

/**
 * __useDeleteCustomerAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerAttachmentMutation, { data, loading, error }] = useDeleteCustomerAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomerAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomerAttachmentMutation,
    DeleteCustomerAttachmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCustomerAttachmentMutation,
    DeleteCustomerAttachmentMutationVariables
  >(DeleteCustomerAttachmentDocument, options);
}
export type DeleteCustomerAttachmentMutationHookResult = ReturnType<
  typeof useDeleteCustomerAttachmentMutation
>;
export type DeleteCustomerAttachmentMutationResult =
  Apollo.MutationResult<DeleteCustomerAttachmentMutation>;
export type DeleteCustomerAttachmentMutationOptions = Apollo.BaseMutationOptions<
  DeleteCustomerAttachmentMutation,
  DeleteCustomerAttachmentMutationVariables
>;
export const GetCustomerAttachmentsDocument = gql`
  query getCustomerAttachments(
    $filter: CustomerAttachmentFilter
    $limit: Int
    $skip: Int
    $sort: [SortInput!]
  ) {
    customerAttachments(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
      count
      items {
        id
        name
        validFrom
        validTill
        active
        type
        attachment {
          fileName
          url
        }
        versions {
          id
          validFrom
          validTill
          type
          active
          version
          attachment {
            url
          }
        }
      }
    }
  }
`;

/**
 * __useGetCustomerAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetCustomerAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAttachmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCustomerAttachmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerAttachmentsQuery,
    GetCustomerAttachmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomerAttachmentsQuery, GetCustomerAttachmentsQueryVariables>(
    GetCustomerAttachmentsDocument,
    options,
  );
}
export function useGetCustomerAttachmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerAttachmentsQuery,
    GetCustomerAttachmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomerAttachmentsQuery, GetCustomerAttachmentsQueryVariables>(
    GetCustomerAttachmentsDocument,
    options,
  );
}
export function useGetCustomerAttachmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomerAttachmentsQuery,
        GetCustomerAttachmentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCustomerAttachmentsQuery, GetCustomerAttachmentsQueryVariables>(
    GetCustomerAttachmentsDocument,
    options,
  );
}
export type GetCustomerAttachmentsQueryHookResult = ReturnType<
  typeof useGetCustomerAttachmentsQuery
>;
export type GetCustomerAttachmentsLazyQueryHookResult = ReturnType<
  typeof useGetCustomerAttachmentsLazyQuery
>;
export type GetCustomerAttachmentsSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomerAttachmentsSuspenseQuery
>;
export type GetCustomerAttachmentsQueryResult = Apollo.QueryResult<
  GetCustomerAttachmentsQuery,
  GetCustomerAttachmentsQueryVariables
>;
export function refetchGetCustomerAttachmentsQuery(
  variables?: GetCustomerAttachmentsQueryVariables,
) {
  return { query: GetCustomerAttachmentsDocument, variables: variables };
}
export const UpdateCustomerAttachmentDocument = gql`
  mutation updateCustomerAttachment($id: Int!, $input: UpdateCustomerAttachmentInput!) {
    updateCustomerAttachment(id: $id, input: $input) {
      id
      name
      validFrom
      validTill
      attachment {
        fileName
        url
      }
      active
    }
  }
`;
export type UpdateCustomerAttachmentMutationFn = Apollo.MutationFunction<
  UpdateCustomerAttachmentMutation,
  UpdateCustomerAttachmentMutationVariables
>;

/**
 * __useUpdateCustomerAttachmentMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerAttachmentMutation, { data, loading, error }] = useUpdateCustomerAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomerAttachmentMutation,
    UpdateCustomerAttachmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCustomerAttachmentMutation,
    UpdateCustomerAttachmentMutationVariables
  >(UpdateCustomerAttachmentDocument, options);
}
export type UpdateCustomerAttachmentMutationHookResult = ReturnType<
  typeof useUpdateCustomerAttachmentMutation
>;
export type UpdateCustomerAttachmentMutationResult =
  Apollo.MutationResult<UpdateCustomerAttachmentMutation>;
export type UpdateCustomerAttachmentMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomerAttachmentMutation,
  UpdateCustomerAttachmentMutationVariables
>;
export const GetCurrentCommunicationCompanyDocument = gql`
  query getCurrentCommunicationCompany {
    getCurrentCommunicationCompany {
      id
      name
      profileName
      address1
      address2
      __typename
    }
  }
`;

/**
 * __useGetCurrentCommunicationCompanyQuery__
 *
 * To run a query within a React component, call `useGetCurrentCommunicationCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCommunicationCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCommunicationCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentCommunicationCompanyQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCurrentCommunicationCompanyQuery,
    GetCurrentCommunicationCompanyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCurrentCommunicationCompanyQuery,
    GetCurrentCommunicationCompanyQueryVariables
  >(GetCurrentCommunicationCompanyDocument, options);
}
export function useGetCurrentCommunicationCompanyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentCommunicationCompanyQuery,
    GetCurrentCommunicationCompanyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCurrentCommunicationCompanyQuery,
    GetCurrentCommunicationCompanyQueryVariables
  >(GetCurrentCommunicationCompanyDocument, options);
}
export function useGetCurrentCommunicationCompanySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentCommunicationCompanyQuery,
        GetCurrentCommunicationCompanyQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCurrentCommunicationCompanyQuery,
    GetCurrentCommunicationCompanyQueryVariables
  >(GetCurrentCommunicationCompanyDocument, options);
}
export type GetCurrentCommunicationCompanyQueryHookResult = ReturnType<
  typeof useGetCurrentCommunicationCompanyQuery
>;
export type GetCurrentCommunicationCompanyLazyQueryHookResult = ReturnType<
  typeof useGetCurrentCommunicationCompanyLazyQuery
>;
export type GetCurrentCommunicationCompanySuspenseQueryHookResult = ReturnType<
  typeof useGetCurrentCommunicationCompanySuspenseQuery
>;
export type GetCurrentCommunicationCompanyQueryResult = Apollo.QueryResult<
  GetCurrentCommunicationCompanyQuery,
  GetCurrentCommunicationCompanyQueryVariables
>;
export function refetchGetCurrentCommunicationCompanyQuery(
  variables?: GetCurrentCommunicationCompanyQueryVariables,
) {
  return { query: GetCurrentCommunicationCompanyDocument, variables: variables };
}
export const GetCurrentCompanyDocument = gql`
  query getCurrentCompany {
    getCurrentCompany {
      id
      name
      profileName
      address1
      address2
      __typename
    }
  }
`;

/**
 * __useGetCurrentCompanyQuery__
 *
 * To run a query within a React component, call `useGetCurrentCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentCompanyQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCurrentCompanyQuery, GetCurrentCompanyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCurrentCompanyQuery, GetCurrentCompanyQueryVariables>(
    GetCurrentCompanyDocument,
    options,
  );
}
export function useGetCurrentCompanyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentCompanyQuery,
    GetCurrentCompanyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCurrentCompanyQuery, GetCurrentCompanyQueryVariables>(
    GetCurrentCompanyDocument,
    options,
  );
}
export function useGetCurrentCompanySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCurrentCompanyQuery, GetCurrentCompanyQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCurrentCompanyQuery, GetCurrentCompanyQueryVariables>(
    GetCurrentCompanyDocument,
    options,
  );
}
export type GetCurrentCompanyQueryHookResult = ReturnType<typeof useGetCurrentCompanyQuery>;
export type GetCurrentCompanyLazyQueryHookResult = ReturnType<typeof useGetCurrentCompanyLazyQuery>;
export type GetCurrentCompanySuspenseQueryHookResult = ReturnType<
  typeof useGetCurrentCompanySuspenseQuery
>;
export type GetCurrentCompanyQueryResult = Apollo.QueryResult<
  GetCurrentCompanyQuery,
  GetCurrentCompanyQueryVariables
>;
export function refetchGetCurrentCompanyQuery(variables?: GetCurrentCompanyQueryVariables) {
  return { query: GetCurrentCompanyDocument, variables: variables };
}
export const SendContactRequestDocument = gql`
  mutation sendContactRequest($input: CreateContactRequestInput!) {
    sendContactRequest(input: $input) {
      success
    }
  }
`;
export type SendContactRequestMutationFn = Apollo.MutationFunction<
  SendContactRequestMutation,
  SendContactRequestMutationVariables
>;

/**
 * __useSendContactRequestMutation__
 *
 * To run a mutation, you first call `useSendContactRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContactRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContactRequestMutation, { data, loading, error }] = useSendContactRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendContactRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendContactRequestMutation,
    SendContactRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendContactRequestMutation, SendContactRequestMutationVariables>(
    SendContactRequestDocument,
    options,
  );
}
export type SendContactRequestMutationHookResult = ReturnType<typeof useSendContactRequestMutation>;
export type SendContactRequestMutationResult = Apollo.MutationResult<SendContactRequestMutation>;
export type SendContactRequestMutationOptions = Apollo.BaseMutationOptions<
  SendContactRequestMutation,
  SendContactRequestMutationVariables
>;
export const AddMeccaConversationAgentMessageDocument = gql`
  mutation addMeccaConversationAgentMessage(
    $agentMessageId: ID!
    $conversationId: ID!
    $input: AddConversationAgentMessage!
  ) {
    addMeccaConversationAgentMessage(
      agentMessageId: $agentMessageId
      conversationId: $conversationId
      input: $input
    ) {
      success
    }
  }
`;
export type AddMeccaConversationAgentMessageMutationFn = Apollo.MutationFunction<
  AddMeccaConversationAgentMessageMutation,
  AddMeccaConversationAgentMessageMutationVariables
>;

/**
 * __useAddMeccaConversationAgentMessageMutation__
 *
 * To run a mutation, you first call `useAddMeccaConversationAgentMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMeccaConversationAgentMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMeccaConversationAgentMessageMutation, { data, loading, error }] = useAddMeccaConversationAgentMessageMutation({
 *   variables: {
 *      agentMessageId: // value for 'agentMessageId'
 *      conversationId: // value for 'conversationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMeccaConversationAgentMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddMeccaConversationAgentMessageMutation,
    AddMeccaConversationAgentMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddMeccaConversationAgentMessageMutation,
    AddMeccaConversationAgentMessageMutationVariables
  >(AddMeccaConversationAgentMessageDocument, options);
}
export type AddMeccaConversationAgentMessageMutationHookResult = ReturnType<
  typeof useAddMeccaConversationAgentMessageMutation
>;
export type AddMeccaConversationAgentMessageMutationResult =
  Apollo.MutationResult<AddMeccaConversationAgentMessageMutation>;
export type AddMeccaConversationAgentMessageMutationOptions = Apollo.BaseMutationOptions<
  AddMeccaConversationAgentMessageMutation,
  AddMeccaConversationAgentMessageMutationVariables
>;
export const AddMeccaConversationAttachmentDocument = gql`
  mutation addMeccaConversationAttachment($input: AddMeccaMessageAttachmentInputModel!) {
    addMeccaMessageAttachment(input: $input)
  }
`;
export type AddMeccaConversationAttachmentMutationFn = Apollo.MutationFunction<
  AddMeccaConversationAttachmentMutation,
  AddMeccaConversationAttachmentMutationVariables
>;

/**
 * __useAddMeccaConversationAttachmentMutation__
 *
 * To run a mutation, you first call `useAddMeccaConversationAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMeccaConversationAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMeccaConversationAttachmentMutation, { data, loading, error }] = useAddMeccaConversationAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMeccaConversationAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddMeccaConversationAttachmentMutation,
    AddMeccaConversationAttachmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddMeccaConversationAttachmentMutation,
    AddMeccaConversationAttachmentMutationVariables
  >(AddMeccaConversationAttachmentDocument, options);
}
export type AddMeccaConversationAttachmentMutationHookResult = ReturnType<
  typeof useAddMeccaConversationAttachmentMutation
>;
export type AddMeccaConversationAttachmentMutationResult =
  Apollo.MutationResult<AddMeccaConversationAttachmentMutation>;
export type AddMeccaConversationAttachmentMutationOptions = Apollo.BaseMutationOptions<
  AddMeccaConversationAttachmentMutation,
  AddMeccaConversationAttachmentMutationVariables
>;
export const AssignMeccaConversationDocument = gql`
  mutation assignMeccaConversation($input: AssignMeccaMessageInputModel!) {
    assignMeccaMessage(input: $input)
  }
`;
export type AssignMeccaConversationMutationFn = Apollo.MutationFunction<
  AssignMeccaConversationMutation,
  AssignMeccaConversationMutationVariables
>;

/**
 * __useAssignMeccaConversationMutation__
 *
 * To run a mutation, you first call `useAssignMeccaConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignMeccaConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignMeccaConversationMutation, { data, loading, error }] = useAssignMeccaConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignMeccaConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignMeccaConversationMutation,
    AssignMeccaConversationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignMeccaConversationMutation,
    AssignMeccaConversationMutationVariables
  >(AssignMeccaConversationDocument, options);
}
export type AssignMeccaConversationMutationHookResult = ReturnType<
  typeof useAssignMeccaConversationMutation
>;
export type AssignMeccaConversationMutationResult =
  Apollo.MutationResult<AssignMeccaConversationMutation>;
export type AssignMeccaConversationMutationOptions = Apollo.BaseMutationOptions<
  AssignMeccaConversationMutation,
  AssignMeccaConversationMutationVariables
>;
export const BulkUpdateMeccaConversationsDocument = gql`
  mutation bulkUpdateMeccaConversations($ids: [ID!]!, $input: UpdateMeccaConversationInputModel!) {
    bulkUpdateMeccaConversations(ids: $ids, input: $input) {
      id
    }
  }
`;
export type BulkUpdateMeccaConversationsMutationFn = Apollo.MutationFunction<
  BulkUpdateMeccaConversationsMutation,
  BulkUpdateMeccaConversationsMutationVariables
>;

/**
 * __useBulkUpdateMeccaConversationsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateMeccaConversationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateMeccaConversationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateMeccaConversationsMutation, { data, loading, error }] = useBulkUpdateMeccaConversationsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateMeccaConversationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkUpdateMeccaConversationsMutation,
    BulkUpdateMeccaConversationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BulkUpdateMeccaConversationsMutation,
    BulkUpdateMeccaConversationsMutationVariables
  >(BulkUpdateMeccaConversationsDocument, options);
}
export type BulkUpdateMeccaConversationsMutationHookResult = ReturnType<
  typeof useBulkUpdateMeccaConversationsMutation
>;
export type BulkUpdateMeccaConversationsMutationResult =
  Apollo.MutationResult<BulkUpdateMeccaConversationsMutation>;
export type BulkUpdateMeccaConversationsMutationOptions = Apollo.BaseMutationOptions<
  BulkUpdateMeccaConversationsMutation,
  BulkUpdateMeccaConversationsMutationVariables
>;
export const CheckConversationLockedDocument = gql`
  query checkConversationLocked($agentMessageId: ID!, $conversationId: ID!) {
    checkConversationLocked(agentMessageId: $agentMessageId, conversationId: $conversationId)
  }
`;

/**
 * __useCheckConversationLockedQuery__
 *
 * To run a query within a React component, call `useCheckConversationLockedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckConversationLockedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckConversationLockedQuery({
 *   variables: {
 *      agentMessageId: // value for 'agentMessageId'
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useCheckConversationLockedQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckConversationLockedQuery,
    CheckConversationLockedQueryVariables
  > &
    ({ variables: CheckConversationLockedQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckConversationLockedQuery, CheckConversationLockedQueryVariables>(
    CheckConversationLockedDocument,
    options,
  );
}
export function useCheckConversationLockedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckConversationLockedQuery,
    CheckConversationLockedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckConversationLockedQuery, CheckConversationLockedQueryVariables>(
    CheckConversationLockedDocument,
    options,
  );
}
export function useCheckConversationLockedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckConversationLockedQuery,
        CheckConversationLockedQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckConversationLockedQuery,
    CheckConversationLockedQueryVariables
  >(CheckConversationLockedDocument, options);
}
export type CheckConversationLockedQueryHookResult = ReturnType<
  typeof useCheckConversationLockedQuery
>;
export type CheckConversationLockedLazyQueryHookResult = ReturnType<
  typeof useCheckConversationLockedLazyQuery
>;
export type CheckConversationLockedSuspenseQueryHookResult = ReturnType<
  typeof useCheckConversationLockedSuspenseQuery
>;
export type CheckConversationLockedQueryResult = Apollo.QueryResult<
  CheckConversationLockedQuery,
  CheckConversationLockedQueryVariables
>;
export function refetchCheckConversationLockedQuery(
  variables: CheckConversationLockedQueryVariables,
) {
  return { query: CheckConversationLockedDocument, variables: variables };
}
export const MeccaConversationBulkUpdatedDocument = gql`
  subscription meccaConversationBulkUpdated {
    meccaConversationBulkUpdated {
      ...meccaConversationDetails
    }
  }
  ${MeccaConversationDetailsFragmentDoc}
`;

/**
 * __useMeccaConversationBulkUpdatedSubscription__
 *
 * To run a query within a React component, call `useMeccaConversationBulkUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMeccaConversationBulkUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeccaConversationBulkUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMeccaConversationBulkUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    MeccaConversationBulkUpdatedSubscription,
    MeccaConversationBulkUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    MeccaConversationBulkUpdatedSubscription,
    MeccaConversationBulkUpdatedSubscriptionVariables
  >(MeccaConversationBulkUpdatedDocument, options);
}
export type MeccaConversationBulkUpdatedSubscriptionHookResult = ReturnType<
  typeof useMeccaConversationBulkUpdatedSubscription
>;
export type MeccaConversationBulkUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<MeccaConversationBulkUpdatedSubscription>;
export const MeccaConversationUpdatedDocument = gql`
  subscription meccaConversationUpdated {
    meccaConversationUpdated {
      ...meccaConversationDetails
    }
  }
  ${MeccaConversationDetailsFragmentDoc}
`;

/**
 * __useMeccaConversationUpdatedSubscription__
 *
 * To run a query within a React component, call `useMeccaConversationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMeccaConversationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeccaConversationUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMeccaConversationUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    MeccaConversationUpdatedSubscription,
    MeccaConversationUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    MeccaConversationUpdatedSubscription,
    MeccaConversationUpdatedSubscriptionVariables
  >(MeccaConversationUpdatedDocument, options);
}
export type MeccaConversationUpdatedSubscriptionHookResult = ReturnType<
  typeof useMeccaConversationUpdatedSubscription
>;
export type MeccaConversationUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<MeccaConversationUpdatedSubscription>;
export const CreateMeccaConversationDocument = gql`
  mutation createMeccaConversation($input: CreateMeccaConversationInputModel!) {
    createMeccaConversation(input: $input) {
      ...meccaConversationPreview
    }
  }
  ${MeccaConversationPreviewFragmentDoc}
`;
export type CreateMeccaConversationMutationFn = Apollo.MutationFunction<
  CreateMeccaConversationMutation,
  CreateMeccaConversationMutationVariables
>;

/**
 * __useCreateMeccaConversationMutation__
 *
 * To run a mutation, you first call `useCreateMeccaConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeccaConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeccaConversationMutation, { data, loading, error }] = useCreateMeccaConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMeccaConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMeccaConversationMutation,
    CreateMeccaConversationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMeccaConversationMutation,
    CreateMeccaConversationMutationVariables
  >(CreateMeccaConversationDocument, options);
}
export type CreateMeccaConversationMutationHookResult = ReturnType<
  typeof useCreateMeccaConversationMutation
>;
export type CreateMeccaConversationMutationResult =
  Apollo.MutationResult<CreateMeccaConversationMutation>;
export type CreateMeccaConversationMutationOptions = Apollo.BaseMutationOptions<
  CreateMeccaConversationMutation,
  CreateMeccaConversationMutationVariables
>;
export const EditMeccaConversationDocument = gql`
  mutation editMeccaConversation($input: EditMeccaConversationInputModel!) {
    editMeccaConversation(input: $input) {
      ...meccaConversationPreview
    }
  }
  ${MeccaConversationPreviewFragmentDoc}
`;
export type EditMeccaConversationMutationFn = Apollo.MutationFunction<
  EditMeccaConversationMutation,
  EditMeccaConversationMutationVariables
>;

/**
 * __useEditMeccaConversationMutation__
 *
 * To run a mutation, you first call `useEditMeccaConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMeccaConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMeccaConversationMutation, { data, loading, error }] = useEditMeccaConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMeccaConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditMeccaConversationMutation,
    EditMeccaConversationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EditMeccaConversationMutation, EditMeccaConversationMutationVariables>(
    EditMeccaConversationDocument,
    options,
  );
}
export type EditMeccaConversationMutationHookResult = ReturnType<
  typeof useEditMeccaConversationMutation
>;
export type EditMeccaConversationMutationResult =
  Apollo.MutationResult<EditMeccaConversationMutation>;
export type EditMeccaConversationMutationOptions = Apollo.BaseMutationOptions<
  EditMeccaConversationMutation,
  EditMeccaConversationMutationVariables
>;
export const ForwardMeccaConversationsAgentDocument = gql`
  mutation forwardMeccaConversationsAgent(
    $messagesIds: [ID!]!
    $input: ForwardConversationAgentMessage!
  ) {
    forwardMeccaConversationsAgent(messagesIds: $messagesIds, input: $input) {
      success
    }
  }
`;
export type ForwardMeccaConversationsAgentMutationFn = Apollo.MutationFunction<
  ForwardMeccaConversationsAgentMutation,
  ForwardMeccaConversationsAgentMutationVariables
>;

/**
 * __useForwardMeccaConversationsAgentMutation__
 *
 * To run a mutation, you first call `useForwardMeccaConversationsAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForwardMeccaConversationsAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forwardMeccaConversationsAgentMutation, { data, loading, error }] = useForwardMeccaConversationsAgentMutation({
 *   variables: {
 *      messagesIds: // value for 'messagesIds'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForwardMeccaConversationsAgentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ForwardMeccaConversationsAgentMutation,
    ForwardMeccaConversationsAgentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ForwardMeccaConversationsAgentMutation,
    ForwardMeccaConversationsAgentMutationVariables
  >(ForwardMeccaConversationsAgentDocument, options);
}
export type ForwardMeccaConversationsAgentMutationHookResult = ReturnType<
  typeof useForwardMeccaConversationsAgentMutation
>;
export type ForwardMeccaConversationsAgentMutationResult =
  Apollo.MutationResult<ForwardMeccaConversationsAgentMutation>;
export type ForwardMeccaConversationsAgentMutationOptions = Apollo.BaseMutationOptions<
  ForwardMeccaConversationsAgentMutation,
  ForwardMeccaConversationsAgentMutationVariables
>;
export const GetMeccaConversationDocument = gql`
  query getMeccaConversation($id: ID!) {
    meccaConversation(id: $id) {
      ...meccaConversationDetails
    }
  }
  ${MeccaConversationDetailsFragmentDoc}
`;

/**
 * __useGetMeccaConversationQuery__
 *
 * To run a query within a React component, call `useGetMeccaConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeccaConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeccaConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMeccaConversationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMeccaConversationQuery,
    GetMeccaConversationQueryVariables
  > &
    ({ variables: GetMeccaConversationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMeccaConversationQuery, GetMeccaConversationQueryVariables>(
    GetMeccaConversationDocument,
    options,
  );
}
export function useGetMeccaConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMeccaConversationQuery,
    GetMeccaConversationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMeccaConversationQuery, GetMeccaConversationQueryVariables>(
    GetMeccaConversationDocument,
    options,
  );
}
export function useGetMeccaConversationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMeccaConversationQuery,
        GetMeccaConversationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMeccaConversationQuery, GetMeccaConversationQueryVariables>(
    GetMeccaConversationDocument,
    options,
  );
}
export type GetMeccaConversationQueryHookResult = ReturnType<typeof useGetMeccaConversationQuery>;
export type GetMeccaConversationLazyQueryHookResult = ReturnType<
  typeof useGetMeccaConversationLazyQuery
>;
export type GetMeccaConversationSuspenseQueryHookResult = ReturnType<
  typeof useGetMeccaConversationSuspenseQuery
>;
export type GetMeccaConversationQueryResult = Apollo.QueryResult<
  GetMeccaConversationQuery,
  GetMeccaConversationQueryVariables
>;
export function refetchGetMeccaConversationQuery(variables: GetMeccaConversationQueryVariables) {
  return { query: GetMeccaConversationDocument, variables: variables };
}
export const GetMeccaConversationsPreviewDocument = gql`
  query getMeccaConversationsPreview(
    $filter: FilterMeccaConversationInputModel
    $sort: SortOrder
    $skip: Int
    $limit: Int
  ) {
    meccaConversations(filter: $filter, sort: $sort, skip: $skip, limit: $limit) {
      count
      items {
        ...meccaConversationPreview
      }
    }
  }
  ${MeccaConversationPreviewFragmentDoc}
`;

/**
 * __useGetMeccaConversationsPreviewQuery__
 *
 * To run a query within a React component, call `useGetMeccaConversationsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeccaConversationsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeccaConversationsPreviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMeccaConversationsPreviewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMeccaConversationsPreviewQuery,
    GetMeccaConversationsPreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMeccaConversationsPreviewQuery,
    GetMeccaConversationsPreviewQueryVariables
  >(GetMeccaConversationsPreviewDocument, options);
}
export function useGetMeccaConversationsPreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMeccaConversationsPreviewQuery,
    GetMeccaConversationsPreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMeccaConversationsPreviewQuery,
    GetMeccaConversationsPreviewQueryVariables
  >(GetMeccaConversationsPreviewDocument, options);
}
export function useGetMeccaConversationsPreviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMeccaConversationsPreviewQuery,
        GetMeccaConversationsPreviewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMeccaConversationsPreviewQuery,
    GetMeccaConversationsPreviewQueryVariables
  >(GetMeccaConversationsPreviewDocument, options);
}
export type GetMeccaConversationsPreviewQueryHookResult = ReturnType<
  typeof useGetMeccaConversationsPreviewQuery
>;
export type GetMeccaConversationsPreviewLazyQueryHookResult = ReturnType<
  typeof useGetMeccaConversationsPreviewLazyQuery
>;
export type GetMeccaConversationsPreviewSuspenseQueryHookResult = ReturnType<
  typeof useGetMeccaConversationsPreviewSuspenseQuery
>;
export type GetMeccaConversationsPreviewQueryResult = Apollo.QueryResult<
  GetMeccaConversationsPreviewQuery,
  GetMeccaConversationsPreviewQueryVariables
>;
export function refetchGetMeccaConversationsPreviewQuery(
  variables?: GetMeccaConversationsPreviewQueryVariables,
) {
  return { query: GetMeccaConversationsPreviewDocument, variables: variables };
}
export const MeccaConversationsByFilterDocument = gql`
  query meccaConversationsByFilter($ids: [ID!], $from: DateTime, $till: DateTime) {
    meccaConversationsByFilter(ids: $ids, from: $from, till: $till) {
      ...meccaConversationDetails
    }
  }
  ${MeccaConversationDetailsFragmentDoc}
`;

/**
 * __useMeccaConversationsByFilterQuery__
 *
 * To run a query within a React component, call `useMeccaConversationsByFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeccaConversationsByFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeccaConversationsByFilterQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      from: // value for 'from'
 *      till: // value for 'till'
 *   },
 * });
 */
export function useMeccaConversationsByFilterQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MeccaConversationsByFilterQuery,
    MeccaConversationsByFilterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MeccaConversationsByFilterQuery, MeccaConversationsByFilterQueryVariables>(
    MeccaConversationsByFilterDocument,
    options,
  );
}
export function useMeccaConversationsByFilterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MeccaConversationsByFilterQuery,
    MeccaConversationsByFilterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MeccaConversationsByFilterQuery,
    MeccaConversationsByFilterQueryVariables
  >(MeccaConversationsByFilterDocument, options);
}
export function useMeccaConversationsByFilterSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MeccaConversationsByFilterQuery,
        MeccaConversationsByFilterQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MeccaConversationsByFilterQuery,
    MeccaConversationsByFilterQueryVariables
  >(MeccaConversationsByFilterDocument, options);
}
export type MeccaConversationsByFilterQueryHookResult = ReturnType<
  typeof useMeccaConversationsByFilterQuery
>;
export type MeccaConversationsByFilterLazyQueryHookResult = ReturnType<
  typeof useMeccaConversationsByFilterLazyQuery
>;
export type MeccaConversationsByFilterSuspenseQueryHookResult = ReturnType<
  typeof useMeccaConversationsByFilterSuspenseQuery
>;
export type MeccaConversationsByFilterQueryResult = Apollo.QueryResult<
  MeccaConversationsByFilterQuery,
  MeccaConversationsByFilterQueryVariables
>;
export function refetchMeccaConversationsByFilterQuery(
  variables?: MeccaConversationsByFilterQueryVariables,
) {
  return { query: MeccaConversationsByFilterDocument, variables: variables };
}
export const RemoveMeccaConversationAttachementDocument = gql`
  mutation removeMeccaConversationAttachement($input: RemoveMeccaMessageAttachmentInputModel!) {
    removeMeccaMessageAttachment(input: $input)
  }
`;
export type RemoveMeccaConversationAttachementMutationFn = Apollo.MutationFunction<
  RemoveMeccaConversationAttachementMutation,
  RemoveMeccaConversationAttachementMutationVariables
>;

/**
 * __useRemoveMeccaConversationAttachementMutation__
 *
 * To run a mutation, you first call `useRemoveMeccaConversationAttachementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMeccaConversationAttachementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMeccaConversationAttachementMutation, { data, loading, error }] = useRemoveMeccaConversationAttachementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveMeccaConversationAttachementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveMeccaConversationAttachementMutation,
    RemoveMeccaConversationAttachementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveMeccaConversationAttachementMutation,
    RemoveMeccaConversationAttachementMutationVariables
  >(RemoveMeccaConversationAttachementDocument, options);
}
export type RemoveMeccaConversationAttachementMutationHookResult = ReturnType<
  typeof useRemoveMeccaConversationAttachementMutation
>;
export type RemoveMeccaConversationAttachementMutationResult =
  Apollo.MutationResult<RemoveMeccaConversationAttachementMutation>;
export type RemoveMeccaConversationAttachementMutationOptions = Apollo.BaseMutationOptions<
  RemoveMeccaConversationAttachementMutation,
  RemoveMeccaConversationAttachementMutationVariables
>;
export const UpdateMeccaConversationDocument = gql`
  mutation updateMeccaConversation($id: ID!, $input: UpdateMeccaConversationInputModel!) {
    updateMeccaConversation(id: $id, input: $input) {
      ...meccaConversationPreview
    }
  }
  ${MeccaConversationPreviewFragmentDoc}
`;
export type UpdateMeccaConversationMutationFn = Apollo.MutationFunction<
  UpdateMeccaConversationMutation,
  UpdateMeccaConversationMutationVariables
>;

/**
 * __useUpdateMeccaConversationMutation__
 *
 * To run a mutation, you first call `useUpdateMeccaConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeccaConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeccaConversationMutation, { data, loading, error }] = useUpdateMeccaConversationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMeccaConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMeccaConversationMutation,
    UpdateMeccaConversationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMeccaConversationMutation,
    UpdateMeccaConversationMutationVariables
  >(UpdateMeccaConversationDocument, options);
}
export type UpdateMeccaConversationMutationHookResult = ReturnType<
  typeof useUpdateMeccaConversationMutation
>;
export type UpdateMeccaConversationMutationResult =
  Apollo.MutationResult<UpdateMeccaConversationMutation>;
export type UpdateMeccaConversationMutationOptions = Apollo.BaseMutationOptions<
  UpdateMeccaConversationMutation,
  UpdateMeccaConversationMutationVariables
>;
export const WithdrawMeccaConversationDocument = gql`
  mutation withdrawMeccaConversation($input: WithdrawMeccaMessageInputModel!) {
    withdrawMeccaMessage(input: $input)
  }
`;
export type WithdrawMeccaConversationMutationFn = Apollo.MutationFunction<
  WithdrawMeccaConversationMutation,
  WithdrawMeccaConversationMutationVariables
>;

/**
 * __useWithdrawMeccaConversationMutation__
 *
 * To run a mutation, you first call `useWithdrawMeccaConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawMeccaConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawMeccaConversationMutation, { data, loading, error }] = useWithdrawMeccaConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWithdrawMeccaConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WithdrawMeccaConversationMutation,
    WithdrawMeccaConversationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WithdrawMeccaConversationMutation,
    WithdrawMeccaConversationMutationVariables
  >(WithdrawMeccaConversationDocument, options);
}
export type WithdrawMeccaConversationMutationHookResult = ReturnType<
  typeof useWithdrawMeccaConversationMutation
>;
export type WithdrawMeccaConversationMutationResult =
  Apollo.MutationResult<WithdrawMeccaConversationMutation>;
export type WithdrawMeccaConversationMutationOptions = Apollo.BaseMutationOptions<
  WithdrawMeccaConversationMutation,
  WithdrawMeccaConversationMutationVariables
>;
export const ConversationStructuredTypesDocument = gql`
  query conversationStructuredTypes($limit: Int, $skip: Int, $sort: [SortInput!]) {
    conversationStructuredTypes(limit: $limit, skip: $skip, sort: $sort) {
      count
      items {
        name
        fields {
          sequence
          isEditableByCustomer
          fieldType {
            name
            regExForValidation
            regExForValidChars
            mask
            maxLength
            errorMessage
          }
          label
          description
          required
          readonly
          defaultValue
          options
        }
      }
    }
  }
`;

/**
 * __useConversationStructuredTypesQuery__
 *
 * To run a query within a React component, call `useConversationStructuredTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationStructuredTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationStructuredTypesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useConversationStructuredTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConversationStructuredTypesQuery,
    ConversationStructuredTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConversationStructuredTypesQuery,
    ConversationStructuredTypesQueryVariables
  >(ConversationStructuredTypesDocument, options);
}
export function useConversationStructuredTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConversationStructuredTypesQuery,
    ConversationStructuredTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConversationStructuredTypesQuery,
    ConversationStructuredTypesQueryVariables
  >(ConversationStructuredTypesDocument, options);
}
export function useConversationStructuredTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConversationStructuredTypesQuery,
        ConversationStructuredTypesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ConversationStructuredTypesQuery,
    ConversationStructuredTypesQueryVariables
  >(ConversationStructuredTypesDocument, options);
}
export type ConversationStructuredTypesQueryHookResult = ReturnType<
  typeof useConversationStructuredTypesQuery
>;
export type ConversationStructuredTypesLazyQueryHookResult = ReturnType<
  typeof useConversationStructuredTypesLazyQuery
>;
export type ConversationStructuredTypesSuspenseQueryHookResult = ReturnType<
  typeof useConversationStructuredTypesSuspenseQuery
>;
export type ConversationStructuredTypesQueryResult = Apollo.QueryResult<
  ConversationStructuredTypesQuery,
  ConversationStructuredTypesQueryVariables
>;
export function refetchConversationStructuredTypesQuery(
  variables?: ConversationStructuredTypesQueryVariables,
) {
  return { query: ConversationStructuredTypesDocument, variables: variables };
}
export const GetUnreadConversationsCountDocument = gql`
  query getUnreadConversationsCount {
    socialConversations {
      count
    }
  }
`;

/**
 * __useGetUnreadConversationsCountQuery__
 *
 * To run a query within a React component, call `useGetUnreadConversationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadConversationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadConversationsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnreadConversationsCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUnreadConversationsCountQuery,
    GetUnreadConversationsCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUnreadConversationsCountQuery,
    GetUnreadConversationsCountQueryVariables
  >(GetUnreadConversationsCountDocument, options);
}
export function useGetUnreadConversationsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUnreadConversationsCountQuery,
    GetUnreadConversationsCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUnreadConversationsCountQuery,
    GetUnreadConversationsCountQueryVariables
  >(GetUnreadConversationsCountDocument, options);
}
export function useGetUnreadConversationsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUnreadConversationsCountQuery,
        GetUnreadConversationsCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetUnreadConversationsCountQuery,
    GetUnreadConversationsCountQueryVariables
  >(GetUnreadConversationsCountDocument, options);
}
export type GetUnreadConversationsCountQueryHookResult = ReturnType<
  typeof useGetUnreadConversationsCountQuery
>;
export type GetUnreadConversationsCountLazyQueryHookResult = ReturnType<
  typeof useGetUnreadConversationsCountLazyQuery
>;
export type GetUnreadConversationsCountSuspenseQueryHookResult = ReturnType<
  typeof useGetUnreadConversationsCountSuspenseQuery
>;
export type GetUnreadConversationsCountQueryResult = Apollo.QueryResult<
  GetUnreadConversationsCountQuery,
  GetUnreadConversationsCountQueryVariables
>;
export function refetchGetUnreadConversationsCountQuery(
  variables?: GetUnreadConversationsCountQueryVariables,
) {
  return { query: GetUnreadConversationsCountDocument, variables: variables };
}
export const AssignSocialConversationDocument = gql`
  mutation assignSocialConversation($input: AssignSocialConversationInputModel!) {
    assignSocialConversation(input: $input)
  }
`;
export type AssignSocialConversationMutationFn = Apollo.MutationFunction<
  AssignSocialConversationMutation,
  AssignSocialConversationMutationVariables
>;

/**
 * __useAssignSocialConversationMutation__
 *
 * To run a mutation, you first call `useAssignSocialConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignSocialConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignSocialConversationMutation, { data, loading, error }] = useAssignSocialConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignSocialConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignSocialConversationMutation,
    AssignSocialConversationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignSocialConversationMutation,
    AssignSocialConversationMutationVariables
  >(AssignSocialConversationDocument, options);
}
export type AssignSocialConversationMutationHookResult = ReturnType<
  typeof useAssignSocialConversationMutation
>;
export type AssignSocialConversationMutationResult =
  Apollo.MutationResult<AssignSocialConversationMutation>;
export type AssignSocialConversationMutationOptions = Apollo.BaseMutationOptions<
  AssignSocialConversationMutation,
  AssignSocialConversationMutationVariables
>;
export const BulkUpdateSocialConversationsDocument = gql`
  mutation bulkUpdateSocialConversations(
    $ids: [ID!]!
    $input: UpdateSocialConversationInputModel!
  ) {
    bulkUpdateSocialConversations(ids: $ids, input: $input) {
      id
    }
  }
`;
export type BulkUpdateSocialConversationsMutationFn = Apollo.MutationFunction<
  BulkUpdateSocialConversationsMutation,
  BulkUpdateSocialConversationsMutationVariables
>;

/**
 * __useBulkUpdateSocialConversationsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateSocialConversationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateSocialConversationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateSocialConversationsMutation, { data, loading, error }] = useBulkUpdateSocialConversationsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateSocialConversationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkUpdateSocialConversationsMutation,
    BulkUpdateSocialConversationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BulkUpdateSocialConversationsMutation,
    BulkUpdateSocialConversationsMutationVariables
  >(BulkUpdateSocialConversationsDocument, options);
}
export type BulkUpdateSocialConversationsMutationHookResult = ReturnType<
  typeof useBulkUpdateSocialConversationsMutation
>;
export type BulkUpdateSocialConversationsMutationResult =
  Apollo.MutationResult<BulkUpdateSocialConversationsMutation>;
export type BulkUpdateSocialConversationsMutationOptions = Apollo.BaseMutationOptions<
  BulkUpdateSocialConversationsMutation,
  BulkUpdateSocialConversationsMutationVariables
>;
export const SocialConversationBulkUpdatedDocument = gql`
  subscription SocialConversationBulkUpdated {
    SocialConversationBulkUpdated {
      ...socialConversationDetails
    }
  }
  ${SocialConversationDetailsFragmentDoc}
`;

/**
 * __useSocialConversationBulkUpdatedSubscription__
 *
 * To run a query within a React component, call `useSocialConversationBulkUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSocialConversationBulkUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialConversationBulkUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSocialConversationBulkUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    SocialConversationBulkUpdatedSubscription,
    SocialConversationBulkUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    SocialConversationBulkUpdatedSubscription,
    SocialConversationBulkUpdatedSubscriptionVariables
  >(SocialConversationBulkUpdatedDocument, options);
}
export type SocialConversationBulkUpdatedSubscriptionHookResult = ReturnType<
  typeof useSocialConversationBulkUpdatedSubscription
>;
export type SocialConversationBulkUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<SocialConversationBulkUpdatedSubscription>;
export const SocialNewReceivedMessageDocument = gql`
  subscription SocialNewReceivedMessage {
    SocialNewReceivedMessage {
      channelType
      attachments {
        fileName
        url
      }
      content
      external
      conversationId
      destination
      messageTime
      sender {
        id
        displayName
        __typename
      }
      source
    }
  }
`;

/**
 * __useSocialNewReceivedMessageSubscription__
 *
 * To run a query within a React component, call `useSocialNewReceivedMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSocialNewReceivedMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialNewReceivedMessageSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSocialNewReceivedMessageSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    SocialNewReceivedMessageSubscription,
    SocialNewReceivedMessageSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    SocialNewReceivedMessageSubscription,
    SocialNewReceivedMessageSubscriptionVariables
  >(SocialNewReceivedMessageDocument, options);
}
export type SocialNewReceivedMessageSubscriptionHookResult = ReturnType<
  typeof useSocialNewReceivedMessageSubscription
>;
export type SocialNewReceivedMessageSubscriptionResult =
  Apollo.SubscriptionResult<SocialNewReceivedMessageSubscription>;
export const SocialConversationUpdatedDocument = gql`
  subscription SocialConversationUpdated {
    SocialConversationUpdated {
      ...socialConversationDetails
    }
  }
  ${SocialConversationDetailsFragmentDoc}
`;

/**
 * __useSocialConversationUpdatedSubscription__
 *
 * To run a query within a React component, call `useSocialConversationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSocialConversationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialConversationUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSocialConversationUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    SocialConversationUpdatedSubscription,
    SocialConversationUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    SocialConversationUpdatedSubscription,
    SocialConversationUpdatedSubscriptionVariables
  >(SocialConversationUpdatedDocument, options);
}
export type SocialConversationUpdatedSubscriptionHookResult = ReturnType<
  typeof useSocialConversationUpdatedSubscription
>;
export type SocialConversationUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<SocialConversationUpdatedSubscription>;
export const GetSocialConversationDocument = gql`
  query getSocialConversation($id: ID!) {
    socialConversation(id: $id) {
      ...socialConversationDetails
    }
  }
  ${SocialConversationDetailsFragmentDoc}
`;

/**
 * __useGetSocialConversationQuery__
 *
 * To run a query within a React component, call `useGetSocialConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSocialConversationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSocialConversationQuery,
    GetSocialConversationQueryVariables
  > &
    ({ variables: GetSocialConversationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSocialConversationQuery, GetSocialConversationQueryVariables>(
    GetSocialConversationDocument,
    options,
  );
}
export function useGetSocialConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSocialConversationQuery,
    GetSocialConversationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSocialConversationQuery, GetSocialConversationQueryVariables>(
    GetSocialConversationDocument,
    options,
  );
}
export function useGetSocialConversationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSocialConversationQuery,
        GetSocialConversationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSocialConversationQuery, GetSocialConversationQueryVariables>(
    GetSocialConversationDocument,
    options,
  );
}
export type GetSocialConversationQueryHookResult = ReturnType<typeof useGetSocialConversationQuery>;
export type GetSocialConversationLazyQueryHookResult = ReturnType<
  typeof useGetSocialConversationLazyQuery
>;
export type GetSocialConversationSuspenseQueryHookResult = ReturnType<
  typeof useGetSocialConversationSuspenseQuery
>;
export type GetSocialConversationQueryResult = Apollo.QueryResult<
  GetSocialConversationQuery,
  GetSocialConversationQueryVariables
>;
export function refetchGetSocialConversationQuery(variables: GetSocialConversationQueryVariables) {
  return { query: GetSocialConversationDocument, variables: variables };
}
export const GetSocialConversationsPreviewDocument = gql`
  query getSocialConversationsPreview(
    $filter: SocialConversationFilterModel
    $sort: SortOrder
    $skip: Int
    $limit: Int
  ) {
    socialConversations(filter: $filter, sort: $sort, skip: $skip, limit: $limit) {
      count
      items {
        ...socialConversationPreview
      }
    }
  }
  ${SocialConversationPreviewFragmentDoc}
`;

/**
 * __useGetSocialConversationsPreviewQuery__
 *
 * To run a query within a React component, call `useGetSocialConversationsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialConversationsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialConversationsPreviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSocialConversationsPreviewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSocialConversationsPreviewQuery,
    GetSocialConversationsPreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSocialConversationsPreviewQuery,
    GetSocialConversationsPreviewQueryVariables
  >(GetSocialConversationsPreviewDocument, options);
}
export function useGetSocialConversationsPreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSocialConversationsPreviewQuery,
    GetSocialConversationsPreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSocialConversationsPreviewQuery,
    GetSocialConversationsPreviewQueryVariables
  >(GetSocialConversationsPreviewDocument, options);
}
export function useGetSocialConversationsPreviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSocialConversationsPreviewQuery,
        GetSocialConversationsPreviewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSocialConversationsPreviewQuery,
    GetSocialConversationsPreviewQueryVariables
  >(GetSocialConversationsPreviewDocument, options);
}
export type GetSocialConversationsPreviewQueryHookResult = ReturnType<
  typeof useGetSocialConversationsPreviewQuery
>;
export type GetSocialConversationsPreviewLazyQueryHookResult = ReturnType<
  typeof useGetSocialConversationsPreviewLazyQuery
>;
export type GetSocialConversationsPreviewSuspenseQueryHookResult = ReturnType<
  typeof useGetSocialConversationsPreviewSuspenseQuery
>;
export type GetSocialConversationsPreviewQueryResult = Apollo.QueryResult<
  GetSocialConversationsPreviewQuery,
  GetSocialConversationsPreviewQueryVariables
>;
export function refetchGetSocialConversationsPreviewQuery(
  variables?: GetSocialConversationsPreviewQueryVariables,
) {
  return { query: GetSocialConversationsPreviewDocument, variables: variables };
}
export const GetSocialRelatedConversationsDocument = gql`
  query getSocialRelatedConversations($id: ID!) {
    socialConversation(id: $id) {
      id
      related {
        ...socialConversationPreview
      }
    }
  }
  ${SocialConversationPreviewFragmentDoc}
`;

/**
 * __useGetSocialRelatedConversationsQuery__
 *
 * To run a query within a React component, call `useGetSocialRelatedConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialRelatedConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialRelatedConversationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSocialRelatedConversationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSocialRelatedConversationsQuery,
    GetSocialRelatedConversationsQueryVariables
  > &
    (
      | { variables: GetSocialRelatedConversationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSocialRelatedConversationsQuery,
    GetSocialRelatedConversationsQueryVariables
  >(GetSocialRelatedConversationsDocument, options);
}
export function useGetSocialRelatedConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSocialRelatedConversationsQuery,
    GetSocialRelatedConversationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSocialRelatedConversationsQuery,
    GetSocialRelatedConversationsQueryVariables
  >(GetSocialRelatedConversationsDocument, options);
}
export function useGetSocialRelatedConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSocialRelatedConversationsQuery,
        GetSocialRelatedConversationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSocialRelatedConversationsQuery,
    GetSocialRelatedConversationsQueryVariables
  >(GetSocialRelatedConversationsDocument, options);
}
export type GetSocialRelatedConversationsQueryHookResult = ReturnType<
  typeof useGetSocialRelatedConversationsQuery
>;
export type GetSocialRelatedConversationsLazyQueryHookResult = ReturnType<
  typeof useGetSocialRelatedConversationsLazyQuery
>;
export type GetSocialRelatedConversationsSuspenseQueryHookResult = ReturnType<
  typeof useGetSocialRelatedConversationsSuspenseQuery
>;
export type GetSocialRelatedConversationsQueryResult = Apollo.QueryResult<
  GetSocialRelatedConversationsQuery,
  GetSocialRelatedConversationsQueryVariables
>;
export function refetchGetSocialRelatedConversationsQuery(
  variables: GetSocialRelatedConversationsQueryVariables,
) {
  return { query: GetSocialRelatedConversationsDocument, variables: variables };
}
export const RemoveSocialConversationAttachementDocument = gql`
  mutation removeSocialConversationAttachement($input: RemoveSocialMessageAttachmentInputModel!) {
    removeSocialConversationAttachment(input: $input)
  }
`;
export type RemoveSocialConversationAttachementMutationFn = Apollo.MutationFunction<
  RemoveSocialConversationAttachementMutation,
  RemoveSocialConversationAttachementMutationVariables
>;

/**
 * __useRemoveSocialConversationAttachementMutation__
 *
 * To run a mutation, you first call `useRemoveSocialConversationAttachementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSocialConversationAttachementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSocialConversationAttachementMutation, { data, loading, error }] = useRemoveSocialConversationAttachementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveSocialConversationAttachementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveSocialConversationAttachementMutation,
    RemoveSocialConversationAttachementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveSocialConversationAttachementMutation,
    RemoveSocialConversationAttachementMutationVariables
  >(RemoveSocialConversationAttachementDocument, options);
}
export type RemoveSocialConversationAttachementMutationHookResult = ReturnType<
  typeof useRemoveSocialConversationAttachementMutation
>;
export type RemoveSocialConversationAttachementMutationResult =
  Apollo.MutationResult<RemoveSocialConversationAttachementMutation>;
export type RemoveSocialConversationAttachementMutationOptions = Apollo.BaseMutationOptions<
  RemoveSocialConversationAttachementMutation,
  RemoveSocialConversationAttachementMutationVariables
>;
export const SendSocialConversationTextDocument = gql`
  mutation sendSocialConversationText($id: ID!, $input: SendConversationTextInput!) {
    sendSocialConversationText(id: $id, input: $input) {
      success
      message
    }
  }
`;
export type SendSocialConversationTextMutationFn = Apollo.MutationFunction<
  SendSocialConversationTextMutation,
  SendSocialConversationTextMutationVariables
>;

/**
 * __useSendSocialConversationTextMutation__
 *
 * To run a mutation, you first call `useSendSocialConversationTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSocialConversationTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSocialConversationTextMutation, { data, loading, error }] = useSendSocialConversationTextMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSocialConversationTextMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendSocialConversationTextMutation,
    SendSocialConversationTextMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendSocialConversationTextMutation,
    SendSocialConversationTextMutationVariables
  >(SendSocialConversationTextDocument, options);
}
export type SendSocialConversationTextMutationHookResult = ReturnType<
  typeof useSendSocialConversationTextMutation
>;
export type SendSocialConversationTextMutationResult =
  Apollo.MutationResult<SendSocialConversationTextMutation>;
export type SendSocialConversationTextMutationOptions = Apollo.BaseMutationOptions<
  SendSocialConversationTextMutation,
  SendSocialConversationTextMutationVariables
>;
export const UpdateSocialConversationDocument = gql`
  mutation updateSocialConversation($id: ID!, $input: UpdateSocialConversationInputModel!) {
    updateSocialConversation(id: $id, input: $input) {
      ...socialConversationPreview
    }
  }
  ${SocialConversationPreviewFragmentDoc}
`;
export type UpdateSocialConversationMutationFn = Apollo.MutationFunction<
  UpdateSocialConversationMutation,
  UpdateSocialConversationMutationVariables
>;

/**
 * __useUpdateSocialConversationMutation__
 *
 * To run a mutation, you first call `useUpdateSocialConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocialConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocialConversationMutation, { data, loading, error }] = useUpdateSocialConversationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSocialConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSocialConversationMutation,
    UpdateSocialConversationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSocialConversationMutation,
    UpdateSocialConversationMutationVariables
  >(UpdateSocialConversationDocument, options);
}
export type UpdateSocialConversationMutationHookResult = ReturnType<
  typeof useUpdateSocialConversationMutation
>;
export type UpdateSocialConversationMutationResult =
  Apollo.MutationResult<UpdateSocialConversationMutation>;
export type UpdateSocialConversationMutationOptions = Apollo.BaseMutationOptions<
  UpdateSocialConversationMutation,
  UpdateSocialConversationMutationVariables
>;
export const WithdrawSocialConversationDocument = gql`
  mutation withdrawSocialConversation($input: WithdrawSocialConversationInputModel!) {
    withdrawSocialConversation(input: $input)
  }
`;
export type WithdrawSocialConversationMutationFn = Apollo.MutationFunction<
  WithdrawSocialConversationMutation,
  WithdrawSocialConversationMutationVariables
>;

/**
 * __useWithdrawSocialConversationMutation__
 *
 * To run a mutation, you first call `useWithdrawSocialConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawSocialConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawSocialConversationMutation, { data, loading, error }] = useWithdrawSocialConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWithdrawSocialConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WithdrawSocialConversationMutation,
    WithdrawSocialConversationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WithdrawSocialConversationMutation,
    WithdrawSocialConversationMutationVariables
  >(WithdrawSocialConversationDocument, options);
}
export type WithdrawSocialConversationMutationHookResult = ReturnType<
  typeof useWithdrawSocialConversationMutation
>;
export type WithdrawSocialConversationMutationResult =
  Apollo.MutationResult<WithdrawSocialConversationMutation>;
export type WithdrawSocialConversationMutationOptions = Apollo.BaseMutationOptions<
  WithdrawSocialConversationMutation,
  WithdrawSocialConversationMutationVariables
>;
export const CreateCustomerCrmContactDocument = gql`
  mutation createCustomerCrmContact($input: CreateCustomerCrmContactInput!) {
    createCustomerCrmContact(input: $input) {
      id
      title
      firstName
      lastName
      sex
      functionName
      addresses {
        id
        city
        country
        postalCode
        address
        description
      }
      communications {
        type {
          id
          name
          category
        }
        sequence
        value
        description
        forwardStatus
        forwardCondition
        passThroughStatus
        passThroughCondition
      }
      groups {
        groupId
        group {
          id
          name
          subGroups {
            id
            name
          }
        }
        subGroupId
        subGroup {
          id
          name
        }
      }
    }
  }
`;
export type CreateCustomerCrmContactMutationFn = Apollo.MutationFunction<
  CreateCustomerCrmContactMutation,
  CreateCustomerCrmContactMutationVariables
>;

/**
 * __useCreateCustomerCrmContactMutation__
 *
 * To run a mutation, you first call `useCreateCustomerCrmContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerCrmContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerCrmContactMutation, { data, loading, error }] = useCreateCustomerCrmContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerCrmContactMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomerCrmContactMutation,
    CreateCustomerCrmContactMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCustomerCrmContactMutation,
    CreateCustomerCrmContactMutationVariables
  >(CreateCustomerCrmContactDocument, options);
}
export type CreateCustomerCrmContactMutationHookResult = ReturnType<
  typeof useCreateCustomerCrmContactMutation
>;
export type CreateCustomerCrmContactMutationResult =
  Apollo.MutationResult<CreateCustomerCrmContactMutation>;
export type CreateCustomerCrmContactMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomerCrmContactMutation,
  CreateCustomerCrmContactMutationVariables
>;
export const DeleteCustomerCrmContactDocument = gql`
  mutation deleteCustomerCrmContact($id: Int!) {
    deleteCustomerCrmContact(id: $id) {
      success
    }
  }
`;
export type DeleteCustomerCrmContactMutationFn = Apollo.MutationFunction<
  DeleteCustomerCrmContactMutation,
  DeleteCustomerCrmContactMutationVariables
>;

/**
 * __useDeleteCustomerCrmContactMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerCrmContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerCrmContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerCrmContactMutation, { data, loading, error }] = useDeleteCustomerCrmContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomerCrmContactMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomerCrmContactMutation,
    DeleteCustomerCrmContactMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCustomerCrmContactMutation,
    DeleteCustomerCrmContactMutationVariables
  >(DeleteCustomerCrmContactDocument, options);
}
export type DeleteCustomerCrmContactMutationHookResult = ReturnType<
  typeof useDeleteCustomerCrmContactMutation
>;
export type DeleteCustomerCrmContactMutationResult =
  Apollo.MutationResult<DeleteCustomerCrmContactMutation>;
export type DeleteCustomerCrmContactMutationOptions = Apollo.BaseMutationOptions<
  DeleteCustomerCrmContactMutation,
  DeleteCustomerCrmContactMutationVariables
>;
export const GetCustomerCrmContactCommunicationTypesDocument = gql`
  query getCustomerCrmContactCommunicationTypes(
    $filter: CustomerCrmContactCommunicationTypeFilter
    $limit: Int
    $skip: Int
    $sort: [SortInput!]
  ) {
    customerCrmContactCommunicationTypes(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
      count
      items {
        id
        name
        category
      }
    }
  }
`;

/**
 * __useGetCustomerCrmContactCommunicationTypesQuery__
 *
 * To run a query within a React component, call `useGetCustomerCrmContactCommunicationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerCrmContactCommunicationTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerCrmContactCommunicationTypesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCustomerCrmContactCommunicationTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerCrmContactCommunicationTypesQuery,
    GetCustomerCrmContactCommunicationTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerCrmContactCommunicationTypesQuery,
    GetCustomerCrmContactCommunicationTypesQueryVariables
  >(GetCustomerCrmContactCommunicationTypesDocument, options);
}
export function useGetCustomerCrmContactCommunicationTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerCrmContactCommunicationTypesQuery,
    GetCustomerCrmContactCommunicationTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerCrmContactCommunicationTypesQuery,
    GetCustomerCrmContactCommunicationTypesQueryVariables
  >(GetCustomerCrmContactCommunicationTypesDocument, options);
}
export function useGetCustomerCrmContactCommunicationTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomerCrmContactCommunicationTypesQuery,
        GetCustomerCrmContactCommunicationTypesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCustomerCrmContactCommunicationTypesQuery,
    GetCustomerCrmContactCommunicationTypesQueryVariables
  >(GetCustomerCrmContactCommunicationTypesDocument, options);
}
export type GetCustomerCrmContactCommunicationTypesQueryHookResult = ReturnType<
  typeof useGetCustomerCrmContactCommunicationTypesQuery
>;
export type GetCustomerCrmContactCommunicationTypesLazyQueryHookResult = ReturnType<
  typeof useGetCustomerCrmContactCommunicationTypesLazyQuery
>;
export type GetCustomerCrmContactCommunicationTypesSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomerCrmContactCommunicationTypesSuspenseQuery
>;
export type GetCustomerCrmContactCommunicationTypesQueryResult = Apollo.QueryResult<
  GetCustomerCrmContactCommunicationTypesQuery,
  GetCustomerCrmContactCommunicationTypesQueryVariables
>;
export function refetchGetCustomerCrmContactCommunicationTypesQuery(
  variables?: GetCustomerCrmContactCommunicationTypesQueryVariables,
) {
  return { query: GetCustomerCrmContactCommunicationTypesDocument, variables: variables };
}
export const GetCustomerCrmContactGroupsDocument = gql`
  query getCustomerCrmContactGroups(
    $filter: CustomerCrmContactGroupFilter
    $limit: Int
    $skip: Int
    $sort: [SortInput!]
  ) {
    customerCrmContactGroups(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
      count
      items {
        id
        name
        subGroups {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useGetCustomerCrmContactGroupsQuery__
 *
 * To run a query within a React component, call `useGetCustomerCrmContactGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerCrmContactGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerCrmContactGroupsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCustomerCrmContactGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerCrmContactGroupsQuery,
    GetCustomerCrmContactGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerCrmContactGroupsQuery,
    GetCustomerCrmContactGroupsQueryVariables
  >(GetCustomerCrmContactGroupsDocument, options);
}
export function useGetCustomerCrmContactGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerCrmContactGroupsQuery,
    GetCustomerCrmContactGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerCrmContactGroupsQuery,
    GetCustomerCrmContactGroupsQueryVariables
  >(GetCustomerCrmContactGroupsDocument, options);
}
export function useGetCustomerCrmContactGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomerCrmContactGroupsQuery,
        GetCustomerCrmContactGroupsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCustomerCrmContactGroupsQuery,
    GetCustomerCrmContactGroupsQueryVariables
  >(GetCustomerCrmContactGroupsDocument, options);
}
export type GetCustomerCrmContactGroupsQueryHookResult = ReturnType<
  typeof useGetCustomerCrmContactGroupsQuery
>;
export type GetCustomerCrmContactGroupsLazyQueryHookResult = ReturnType<
  typeof useGetCustomerCrmContactGroupsLazyQuery
>;
export type GetCustomerCrmContactGroupsSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomerCrmContactGroupsSuspenseQuery
>;
export type GetCustomerCrmContactGroupsQueryResult = Apollo.QueryResult<
  GetCustomerCrmContactGroupsQuery,
  GetCustomerCrmContactGroupsQueryVariables
>;
export function refetchGetCustomerCrmContactGroupsQuery(
  variables?: GetCustomerCrmContactGroupsQueryVariables,
) {
  return { query: GetCustomerCrmContactGroupsDocument, variables: variables };
}
export const GetCustomerCrmContactsDocument = gql`
  query getCustomerCrmContacts(
    $filter: CustomerCrmContactFilter
    $limit: Int
    $skip: Int
    $sort: [SortInput!]
  ) {
    customerCrmContacts(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
      count
      items {
        id
        title
        firstName
        lastName
        sex
        functionName
        addresses {
          id
          city
          country
          postalCode
          address
          description
        }
        communications {
          type {
            id
            name
            category
          }
          sequence
          value
          description
          forwardStatus
          forwardCondition
          passThroughStatus
          passThroughCondition
        }
        groups {
          groupId
          group {
            id
            name
            subGroups {
              id
              name
            }
          }
          subGroupId
          subGroup {
            id
            name
          }
        }
      }
    }
  }
`;

/**
 * __useGetCustomerCrmContactsQuery__
 *
 * To run a query within a React component, call `useGetCustomerCrmContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerCrmContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerCrmContactsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCustomerCrmContactsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerCrmContactsQuery,
    GetCustomerCrmContactsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomerCrmContactsQuery, GetCustomerCrmContactsQueryVariables>(
    GetCustomerCrmContactsDocument,
    options,
  );
}
export function useGetCustomerCrmContactsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerCrmContactsQuery,
    GetCustomerCrmContactsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomerCrmContactsQuery, GetCustomerCrmContactsQueryVariables>(
    GetCustomerCrmContactsDocument,
    options,
  );
}
export function useGetCustomerCrmContactsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomerCrmContactsQuery,
        GetCustomerCrmContactsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCustomerCrmContactsQuery, GetCustomerCrmContactsQueryVariables>(
    GetCustomerCrmContactsDocument,
    options,
  );
}
export type GetCustomerCrmContactsQueryHookResult = ReturnType<
  typeof useGetCustomerCrmContactsQuery
>;
export type GetCustomerCrmContactsLazyQueryHookResult = ReturnType<
  typeof useGetCustomerCrmContactsLazyQuery
>;
export type GetCustomerCrmContactsSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomerCrmContactsSuspenseQuery
>;
export type GetCustomerCrmContactsQueryResult = Apollo.QueryResult<
  GetCustomerCrmContactsQuery,
  GetCustomerCrmContactsQueryVariables
>;
export function refetchGetCustomerCrmContactsQuery(
  variables?: GetCustomerCrmContactsQueryVariables,
) {
  return { query: GetCustomerCrmContactsDocument, variables: variables };
}
export const UpdateCustomerCrmContactDocument = gql`
  mutation updateCustomerCrmContact($id: Int!, $input: UpdateCustomerCrmContactInput!) {
    updateCustomerCrmContact(id: $id, input: $input) {
      id
      title
      firstName
      lastName
      sex
      functionName
      addresses {
        id
        city
        country
        postalCode
        address
        description
      }
      communications {
        type {
          id
          name
          category
        }
        sequence
        value
        description
        forwardStatus
        forwardCondition
        passThroughStatus
        passThroughCondition
      }
      groups {
        groupId
        group {
          id
          name
          subGroups {
            id
            name
          }
        }
        subGroupId
        subGroup {
          id
          name
        }
      }
    }
  }
`;
export type UpdateCustomerCrmContactMutationFn = Apollo.MutationFunction<
  UpdateCustomerCrmContactMutation,
  UpdateCustomerCrmContactMutationVariables
>;

/**
 * __useUpdateCustomerCrmContactMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerCrmContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerCrmContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerCrmContactMutation, { data, loading, error }] = useUpdateCustomerCrmContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerCrmContactMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomerCrmContactMutation,
    UpdateCustomerCrmContactMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCustomerCrmContactMutation,
    UpdateCustomerCrmContactMutationVariables
  >(UpdateCustomerCrmContactDocument, options);
}
export type UpdateCustomerCrmContactMutationHookResult = ReturnType<
  typeof useUpdateCustomerCrmContactMutation
>;
export type UpdateCustomerCrmContactMutationResult =
  Apollo.MutationResult<UpdateCustomerCrmContactMutation>;
export type UpdateCustomerCrmContactMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomerCrmContactMutation,
  UpdateCustomerCrmContactMutationVariables
>;
export const GetDashboardDocument = gql`
  query getDashboard {
    dashboard {
      socialConversations {
        total
        countsByStatus {
          status
          total
        }
      }
      meccaConversations {
        total
        countsByStatus {
          status
          total
        }
      }
      invoices {
        current
        open
      }
    }
  }
`;

/**
 * __useGetDashboardQuery__
 *
 * To run a query within a React component, call `useGetDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardQuery(
  baseOptions?: Apollo.QueryHookOptions<GetDashboardQuery, GetDashboardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDashboardQuery, GetDashboardQueryVariables>(
    GetDashboardDocument,
    options,
  );
}
export function useGetDashboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardQuery, GetDashboardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDashboardQuery, GetDashboardQueryVariables>(
    GetDashboardDocument,
    options,
  );
}
export function useGetDashboardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDashboardQuery, GetDashboardQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDashboardQuery, GetDashboardQueryVariables>(
    GetDashboardDocument,
    options,
  );
}
export type GetDashboardQueryHookResult = ReturnType<typeof useGetDashboardQuery>;
export type GetDashboardLazyQueryHookResult = ReturnType<typeof useGetDashboardLazyQuery>;
export type GetDashboardSuspenseQueryHookResult = ReturnType<typeof useGetDashboardSuspenseQuery>;
export type GetDashboardQueryResult = Apollo.QueryResult<
  GetDashboardQuery,
  GetDashboardQueryVariables
>;
export function refetchGetDashboardQuery(variables?: GetDashboardQueryVariables) {
  return { query: GetDashboardDocument, variables: variables };
}
export const GetDashboardNotificationsDocument = gql`
  query getDashboardNotifications(
    $filter: NotificationFilter
    $limit: Int
    $skip: Int
    $sort: [SortInput!]
  ) {
    dashboard {
      notifications(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
        count
        items {
          date
          type
          ... on NotificationInvoice {
            amount
            invoice {
              id
            }
          }
          ... on NotificationConversation {
            status
            conversationId
            conversation {
              createdBy {
                displayName
                firstName
                lastName
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetDashboardNotificationsQuery__
 *
 * To run a query within a React component, call `useGetDashboardNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardNotificationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetDashboardNotificationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDashboardNotificationsQuery,
    GetDashboardNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDashboardNotificationsQuery, GetDashboardNotificationsQueryVariables>(
    GetDashboardNotificationsDocument,
    options,
  );
}
export function useGetDashboardNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardNotificationsQuery,
    GetDashboardNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardNotificationsQuery,
    GetDashboardNotificationsQueryVariables
  >(GetDashboardNotificationsDocument, options);
}
export function useGetDashboardNotificationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardNotificationsQuery,
        GetDashboardNotificationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardNotificationsQuery,
    GetDashboardNotificationsQueryVariables
  >(GetDashboardNotificationsDocument, options);
}
export type GetDashboardNotificationsQueryHookResult = ReturnType<
  typeof useGetDashboardNotificationsQuery
>;
export type GetDashboardNotificationsLazyQueryHookResult = ReturnType<
  typeof useGetDashboardNotificationsLazyQuery
>;
export type GetDashboardNotificationsSuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardNotificationsSuspenseQuery
>;
export type GetDashboardNotificationsQueryResult = Apollo.QueryResult<
  GetDashboardNotificationsQuery,
  GetDashboardNotificationsQueryVariables
>;
export function refetchGetDashboardNotificationsQuery(
  variables?: GetDashboardNotificationsQueryVariables,
) {
  return { query: GetDashboardNotificationsDocument, variables: variables };
}
export const CreateCustomerTemporaryInstructionDocument = gql`
  mutation createCustomerTemporaryInstruction($input: CreateCustomerTemporaryInstructionInput!) {
    createCustomerTemporaryInstruction(input: $input) {
      id
      updatedAt
      name
      content
      validFrom
      validUntil
      active
    }
  }
`;
export type CreateCustomerTemporaryInstructionMutationFn = Apollo.MutationFunction<
  CreateCustomerTemporaryInstructionMutation,
  CreateCustomerTemporaryInstructionMutationVariables
>;

/**
 * __useCreateCustomerTemporaryInstructionMutation__
 *
 * To run a mutation, you first call `useCreateCustomerTemporaryInstructionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerTemporaryInstructionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerTemporaryInstructionMutation, { data, loading, error }] = useCreateCustomerTemporaryInstructionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerTemporaryInstructionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomerTemporaryInstructionMutation,
    CreateCustomerTemporaryInstructionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCustomerTemporaryInstructionMutation,
    CreateCustomerTemporaryInstructionMutationVariables
  >(CreateCustomerTemporaryInstructionDocument, options);
}
export type CreateCustomerTemporaryInstructionMutationHookResult = ReturnType<
  typeof useCreateCustomerTemporaryInstructionMutation
>;
export type CreateCustomerTemporaryInstructionMutationResult =
  Apollo.MutationResult<CreateCustomerTemporaryInstructionMutation>;
export type CreateCustomerTemporaryInstructionMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomerTemporaryInstructionMutation,
  CreateCustomerTemporaryInstructionMutationVariables
>;
export const DeleteCustomerTemporaryInstructionDocument = gql`
  mutation deleteCustomerTemporaryInstruction($id: Int!) {
    deleteCustomerTemporaryInstruction(id: $id) {
      success
    }
  }
`;
export type DeleteCustomerTemporaryInstructionMutationFn = Apollo.MutationFunction<
  DeleteCustomerTemporaryInstructionMutation,
  DeleteCustomerTemporaryInstructionMutationVariables
>;

/**
 * __useDeleteCustomerTemporaryInstructionMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerTemporaryInstructionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerTemporaryInstructionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerTemporaryInstructionMutation, { data, loading, error }] = useDeleteCustomerTemporaryInstructionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomerTemporaryInstructionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomerTemporaryInstructionMutation,
    DeleteCustomerTemporaryInstructionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCustomerTemporaryInstructionMutation,
    DeleteCustomerTemporaryInstructionMutationVariables
  >(DeleteCustomerTemporaryInstructionDocument, options);
}
export type DeleteCustomerTemporaryInstructionMutationHookResult = ReturnType<
  typeof useDeleteCustomerTemporaryInstructionMutation
>;
export type DeleteCustomerTemporaryInstructionMutationResult =
  Apollo.MutationResult<DeleteCustomerTemporaryInstructionMutation>;
export type DeleteCustomerTemporaryInstructionMutationOptions = Apollo.BaseMutationOptions<
  DeleteCustomerTemporaryInstructionMutation,
  DeleteCustomerTemporaryInstructionMutationVariables
>;
export const GetCustomerFixedInstructionsDocument = gql`
  query getCustomerFixedInstructions(
    $limit: Int
    $skip: Int
    $sort: [SortInput!]
    $filter: CustomerFixedInstructionFilterInput
  ) {
    customerFixedInstructions(limit: $limit, skip: $skip, sort: $sort, filter: $filter) {
      count
      items {
        id
        updatedAt
        name
        content
      }
    }
  }
`;

/**
 * __useGetCustomerFixedInstructionsQuery__
 *
 * To run a query within a React component, call `useGetCustomerFixedInstructionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerFixedInstructionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerFixedInstructionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCustomerFixedInstructionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerFixedInstructionsQuery,
    GetCustomerFixedInstructionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerFixedInstructionsQuery,
    GetCustomerFixedInstructionsQueryVariables
  >(GetCustomerFixedInstructionsDocument, options);
}
export function useGetCustomerFixedInstructionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerFixedInstructionsQuery,
    GetCustomerFixedInstructionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerFixedInstructionsQuery,
    GetCustomerFixedInstructionsQueryVariables
  >(GetCustomerFixedInstructionsDocument, options);
}
export function useGetCustomerFixedInstructionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomerFixedInstructionsQuery,
        GetCustomerFixedInstructionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCustomerFixedInstructionsQuery,
    GetCustomerFixedInstructionsQueryVariables
  >(GetCustomerFixedInstructionsDocument, options);
}
export type GetCustomerFixedInstructionsQueryHookResult = ReturnType<
  typeof useGetCustomerFixedInstructionsQuery
>;
export type GetCustomerFixedInstructionsLazyQueryHookResult = ReturnType<
  typeof useGetCustomerFixedInstructionsLazyQuery
>;
export type GetCustomerFixedInstructionsSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomerFixedInstructionsSuspenseQuery
>;
export type GetCustomerFixedInstructionsQueryResult = Apollo.QueryResult<
  GetCustomerFixedInstructionsQuery,
  GetCustomerFixedInstructionsQueryVariables
>;
export function refetchGetCustomerFixedInstructionsQuery(
  variables?: GetCustomerFixedInstructionsQueryVariables,
) {
  return { query: GetCustomerFixedInstructionsDocument, variables: variables };
}
export const GetCustomerTemporaryInstructionsDocument = gql`
  query getCustomerTemporaryInstructions(
    $limit: Int
    $skip: Int
    $sort: [SortInput!]
    $filter: CustomerTemporaryInstructionFilterInput
  ) {
    customerTemporaryInstructions(limit: $limit, skip: $skip, sort: $sort, filter: $filter) {
      count
      items {
        id
        updatedAt
        name
        content
        validFrom
        validUntil
        active
        deleted
        createdInMeCCA
      }
    }
  }
`;

/**
 * __useGetCustomerTemporaryInstructionsQuery__
 *
 * To run a query within a React component, call `useGetCustomerTemporaryInstructionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerTemporaryInstructionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerTemporaryInstructionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCustomerTemporaryInstructionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerTemporaryInstructionsQuery,
    GetCustomerTemporaryInstructionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerTemporaryInstructionsQuery,
    GetCustomerTemporaryInstructionsQueryVariables
  >(GetCustomerTemporaryInstructionsDocument, options);
}
export function useGetCustomerTemporaryInstructionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerTemporaryInstructionsQuery,
    GetCustomerTemporaryInstructionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerTemporaryInstructionsQuery,
    GetCustomerTemporaryInstructionsQueryVariables
  >(GetCustomerTemporaryInstructionsDocument, options);
}
export function useGetCustomerTemporaryInstructionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomerTemporaryInstructionsQuery,
        GetCustomerTemporaryInstructionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCustomerTemporaryInstructionsQuery,
    GetCustomerTemporaryInstructionsQueryVariables
  >(GetCustomerTemporaryInstructionsDocument, options);
}
export type GetCustomerTemporaryInstructionsQueryHookResult = ReturnType<
  typeof useGetCustomerTemporaryInstructionsQuery
>;
export type GetCustomerTemporaryInstructionsLazyQueryHookResult = ReturnType<
  typeof useGetCustomerTemporaryInstructionsLazyQuery
>;
export type GetCustomerTemporaryInstructionsSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomerTemporaryInstructionsSuspenseQuery
>;
export type GetCustomerTemporaryInstructionsQueryResult = Apollo.QueryResult<
  GetCustomerTemporaryInstructionsQuery,
  GetCustomerTemporaryInstructionsQueryVariables
>;
export function refetchGetCustomerTemporaryInstructionsQuery(
  variables?: GetCustomerTemporaryInstructionsQueryVariables,
) {
  return { query: GetCustomerTemporaryInstructionsDocument, variables: variables };
}
export const UpdateCustomerTemporaryInstructionDocument = gql`
  mutation updateCustomerTemporaryInstruction(
    $input: UpdateCustomerTemporaryInstructionInput!
    $id: Int!
  ) {
    updateCustomerTemporaryInstruction(input: $input, id: $id) {
      id
    }
  }
`;
export type UpdateCustomerTemporaryInstructionMutationFn = Apollo.MutationFunction<
  UpdateCustomerTemporaryInstructionMutation,
  UpdateCustomerTemporaryInstructionMutationVariables
>;

/**
 * __useUpdateCustomerTemporaryInstructionMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerTemporaryInstructionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerTemporaryInstructionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerTemporaryInstructionMutation, { data, loading, error }] = useUpdateCustomerTemporaryInstructionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCustomerTemporaryInstructionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomerTemporaryInstructionMutation,
    UpdateCustomerTemporaryInstructionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCustomerTemporaryInstructionMutation,
    UpdateCustomerTemporaryInstructionMutationVariables
  >(UpdateCustomerTemporaryInstructionDocument, options);
}
export type UpdateCustomerTemporaryInstructionMutationHookResult = ReturnType<
  typeof useUpdateCustomerTemporaryInstructionMutation
>;
export type UpdateCustomerTemporaryInstructionMutationResult =
  Apollo.MutationResult<UpdateCustomerTemporaryInstructionMutation>;
export type UpdateCustomerTemporaryInstructionMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomerTemporaryInstructionMutation,
  UpdateCustomerTemporaryInstructionMutationVariables
>;
export const GetInvoicesDocument = gql`
  query getInvoices(
    $filter: InvoiceFilterInput
    $limit: Int
    $skip: Int
    $sort: [SortInput!]
    $year: Int
  ) {
    invoices(filter: $filter, limit: $limit, skip: $skip, sort: $sort, year: $year) {
      count
      items {
        id
        amount
        date
        dueDate
        year
        month
        invoiceNr
        paid
        type
        attachment {
          fileName
          url
        }
      }
    }
  }
`;

/**
 * __useGetInvoicesQuery__
 *
 * To run a query within a React component, call `useGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetInvoicesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
}
export function useGetInvoicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(
    GetInvoicesDocument,
    options,
  );
}
export function useGetInvoicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(
    GetInvoicesDocument,
    options,
  );
}
export type GetInvoicesQueryHookResult = ReturnType<typeof useGetInvoicesQuery>;
export type GetInvoicesLazyQueryHookResult = ReturnType<typeof useGetInvoicesLazyQuery>;
export type GetInvoicesSuspenseQueryHookResult = ReturnType<typeof useGetInvoicesSuspenseQuery>;
export type GetInvoicesQueryResult = Apollo.QueryResult<
  GetInvoicesQuery,
  GetInvoicesQueryVariables
>;
export function refetchGetInvoicesQuery(variables?: GetInvoicesQueryVariables) {
  return { query: GetInvoicesDocument, variables: variables };
}
export const PayInvoiceDocument = gql`
  mutation payInvoice($id: Int!) {
    payInvoice(id: $id) {
      redirectUrl
    }
  }
`;
export type PayInvoiceMutationFn = Apollo.MutationFunction<
  PayInvoiceMutation,
  PayInvoiceMutationVariables
>;

/**
 * __usePayInvoiceMutation__
 *
 * To run a mutation, you first call `usePayInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payInvoiceMutation, { data, loading, error }] = usePayInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePayInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<PayInvoiceMutation, PayInvoiceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PayInvoiceMutation, PayInvoiceMutationVariables>(
    PayInvoiceDocument,
    options,
  );
}
export type PayInvoiceMutationHookResult = ReturnType<typeof usePayInvoiceMutation>;
export type PayInvoiceMutationResult = Apollo.MutationResult<PayInvoiceMutation>;
export type PayInvoiceMutationOptions = Apollo.BaseMutationOptions<
  PayInvoiceMutation,
  PayInvoiceMutationVariables
>;
export const ActivateChannelDocument = gql`
  mutation activateChannel($id: ID!) {
    activateChannel(id: $id) {
      success
    }
  }
`;
export type ActivateChannelMutationFn = Apollo.MutationFunction<
  ActivateChannelMutation,
  ActivateChannelMutationVariables
>;

/**
 * __useActivateChannelMutation__
 *
 * To run a mutation, you first call `useActivateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateChannelMutation, { data, loading, error }] = useActivateChannelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivateChannelMutation,
    ActivateChannelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ActivateChannelMutation, ActivateChannelMutationVariables>(
    ActivateChannelDocument,
    options,
  );
}
export type ActivateChannelMutationHookResult = ReturnType<typeof useActivateChannelMutation>;
export type ActivateChannelMutationResult = Apollo.MutationResult<ActivateChannelMutation>;
export type ActivateChannelMutationOptions = Apollo.BaseMutationOptions<
  ActivateChannelMutation,
  ActivateChannelMutationVariables
>;
export const DeactivateChannelDocument = gql`
  mutation deactivateChannel($id: ID!) {
    deactivateChannel(id: $id) {
      success
    }
  }
`;
export type DeactivateChannelMutationFn = Apollo.MutationFunction<
  DeactivateChannelMutation,
  DeactivateChannelMutationVariables
>;

/**
 * __useDeactivateChannelMutation__
 *
 * To run a mutation, you first call `useDeactivateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateChannelMutation, { data, loading, error }] = useDeactivateChannelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeactivateChannelMutation,
    DeactivateChannelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeactivateChannelMutation, DeactivateChannelMutationVariables>(
    DeactivateChannelDocument,
    options,
  );
}
export type DeactivateChannelMutationHookResult = ReturnType<typeof useDeactivateChannelMutation>;
export type DeactivateChannelMutationResult = Apollo.MutationResult<DeactivateChannelMutation>;
export type DeactivateChannelMutationOptions = Apollo.BaseMutationOptions<
  DeactivateChannelMutation,
  DeactivateChannelMutationVariables
>;
export const GetPairedChannelsDocument = gql`
  query getPairedChannels(
    $filter: PairedChannelFilterInput
    $sort: [SortInput!]
    $skip: Int
    $limit: Int
  ) {
    pairedChannels(filter: $filter, sort: $sort, skip: $skip, limit: $limit) {
      count
      items {
        id
        type
        account
        active
        channelIdentifier
        redirect
        redirectDelay
      }
    }
  }
`;

/**
 * __useGetPairedChannelsQuery__
 *
 * To run a query within a React component, call `useGetPairedChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPairedChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPairedChannelsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPairedChannelsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPairedChannelsQuery, GetPairedChannelsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPairedChannelsQuery, GetPairedChannelsQueryVariables>(
    GetPairedChannelsDocument,
    options,
  );
}
export function useGetPairedChannelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPairedChannelsQuery,
    GetPairedChannelsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPairedChannelsQuery, GetPairedChannelsQueryVariables>(
    GetPairedChannelsDocument,
    options,
  );
}
export function useGetPairedChannelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPairedChannelsQuery, GetPairedChannelsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPairedChannelsQuery, GetPairedChannelsQueryVariables>(
    GetPairedChannelsDocument,
    options,
  );
}
export type GetPairedChannelsQueryHookResult = ReturnType<typeof useGetPairedChannelsQuery>;
export type GetPairedChannelsLazyQueryHookResult = ReturnType<typeof useGetPairedChannelsLazyQuery>;
export type GetPairedChannelsSuspenseQueryHookResult = ReturnType<
  typeof useGetPairedChannelsSuspenseQuery
>;
export type GetPairedChannelsQueryResult = Apollo.QueryResult<
  GetPairedChannelsQuery,
  GetPairedChannelsQueryVariables
>;
export function refetchGetPairedChannelsQuery(variables?: GetPairedChannelsQueryVariables) {
  return { query: GetPairedChannelsDocument, variables: variables };
}
export const PairChannelDocument = gql`
  mutation pairChannel($input: PairChannelInput!) {
    pairChannel(input: $input) {
      id
      type
      account
      active
    }
  }
`;
export type PairChannelMutationFn = Apollo.MutationFunction<
  PairChannelMutation,
  PairChannelMutationVariables
>;

/**
 * __usePairChannelMutation__
 *
 * To run a mutation, you first call `usePairChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePairChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pairChannelMutation, { data, loading, error }] = usePairChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePairChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<PairChannelMutation, PairChannelMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PairChannelMutation, PairChannelMutationVariables>(
    PairChannelDocument,
    options,
  );
}
export type PairChannelMutationHookResult = ReturnType<typeof usePairChannelMutation>;
export type PairChannelMutationResult = Apollo.MutationResult<PairChannelMutation>;
export type PairChannelMutationOptions = Apollo.BaseMutationOptions<
  PairChannelMutation,
  PairChannelMutationVariables
>;
export const UnpairChannelDocument = gql`
  mutation unpairChannel($id: ID!) {
    unpairChannel(id: $id) {
      success
    }
  }
`;
export type UnpairChannelMutationFn = Apollo.MutationFunction<
  UnpairChannelMutation,
  UnpairChannelMutationVariables
>;

/**
 * __useUnpairChannelMutation__
 *
 * To run a mutation, you first call `useUnpairChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpairChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpairChannelMutation, { data, loading, error }] = useUnpairChannelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnpairChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<UnpairChannelMutation, UnpairChannelMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnpairChannelMutation, UnpairChannelMutationVariables>(
    UnpairChannelDocument,
    options,
  );
}
export type UnpairChannelMutationHookResult = ReturnType<typeof useUnpairChannelMutation>;
export type UnpairChannelMutationResult = Apollo.MutationResult<UnpairChannelMutation>;
export type UnpairChannelMutationOptions = Apollo.BaseMutationOptions<
  UnpairChannelMutation,
  UnpairChannelMutationVariables
>;
export const UpdateChannelDocument = gql`
  mutation updateChannel($id: ID!, $input: PairedChannelUpdateInput!) {
    updateChannel(id: $id, input: $input) {
      id
    }
  }
`;
export type UpdateChannelMutationFn = Apollo.MutationFunction<
  UpdateChannelMutation,
  UpdateChannelMutationVariables
>;

/**
 * __useUpdateChannelMutation__
 *
 * To run a mutation, you first call `useUpdateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelMutation, { data, loading, error }] = useUpdateChannelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateChannelMutation, UpdateChannelMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateChannelMutation, UpdateChannelMutationVariables>(
    UpdateChannelDocument,
    options,
  );
}
export type UpdateChannelMutationHookResult = ReturnType<typeof useUpdateChannelMutation>;
export type UpdateChannelMutationResult = Apollo.MutationResult<UpdateChannelMutation>;
export type UpdateChannelMutationOptions = Apollo.BaseMutationOptions<
  UpdateChannelMutation,
  UpdateChannelMutationVariables
>;
export const CallReportingDocument = gql`
  query callReporting($filter: FilterInput) {
    callReporting(filter: $filter) {
      waitingTimeStatistics {
        ...baseCallReporting
        averageWaitingTime
      }
      durationTimeStatistics {
        ...baseCallReporting
        averageDuration
      }
      missedCallStatistics {
        ...baseCallReporting
        canBeDisplayed
        averageWaitingTime
      }
      nrOfCallsPerHourStatistics {
        ...baseCallReporting
      }
    }
  }
  ${BaseCallReportingFragmentDoc}
`;

/**
 * __useCallReportingQuery__
 *
 * To run a query within a React component, call `useCallReportingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallReportingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallReportingQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCallReportingQuery(
  baseOptions?: Apollo.QueryHookOptions<CallReportingQuery, CallReportingQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CallReportingQuery, CallReportingQueryVariables>(
    CallReportingDocument,
    options,
  );
}
export function useCallReportingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CallReportingQuery, CallReportingQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CallReportingQuery, CallReportingQueryVariables>(
    CallReportingDocument,
    options,
  );
}
export function useCallReportingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CallReportingQuery, CallReportingQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CallReportingQuery, CallReportingQueryVariables>(
    CallReportingDocument,
    options,
  );
}
export type CallReportingQueryHookResult = ReturnType<typeof useCallReportingQuery>;
export type CallReportingLazyQueryHookResult = ReturnType<typeof useCallReportingLazyQuery>;
export type CallReportingSuspenseQueryHookResult = ReturnType<typeof useCallReportingSuspenseQuery>;
export type CallReportingQueryResult = Apollo.QueryResult<
  CallReportingQuery,
  CallReportingQueryVariables
>;
export function refetchCallReportingQuery(variables?: CallReportingQueryVariables) {
  return { query: CallReportingDocument, variables: variables };
}
export const DownloadIncomingCallReportingDocument = gql`
  query downloadIncomingCallReporting(
    $filter: FilterInput
    $sort: [SortInput!]
    $phoneNumber: String
    $lang: LangEnum
  ) {
    downloadIncomingCallReporting(
      filter: $filter
      sort: $sort
      lang: $lang
      phoneNumber: $phoneNumber
    ) {
      content
      contentType
      fileName
    }
  }
`;

/**
 * __useDownloadIncomingCallReportingQuery__
 *
 * To run a query within a React component, call `useDownloadIncomingCallReportingQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadIncomingCallReportingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadIncomingCallReportingQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      phoneNumber: // value for 'phoneNumber'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useDownloadIncomingCallReportingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DownloadIncomingCallReportingQuery,
    DownloadIncomingCallReportingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DownloadIncomingCallReportingQuery,
    DownloadIncomingCallReportingQueryVariables
  >(DownloadIncomingCallReportingDocument, options);
}
export function useDownloadIncomingCallReportingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DownloadIncomingCallReportingQuery,
    DownloadIncomingCallReportingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DownloadIncomingCallReportingQuery,
    DownloadIncomingCallReportingQueryVariables
  >(DownloadIncomingCallReportingDocument, options);
}
export function useDownloadIncomingCallReportingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DownloadIncomingCallReportingQuery,
        DownloadIncomingCallReportingQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DownloadIncomingCallReportingQuery,
    DownloadIncomingCallReportingQueryVariables
  >(DownloadIncomingCallReportingDocument, options);
}
export type DownloadIncomingCallReportingQueryHookResult = ReturnType<
  typeof useDownloadIncomingCallReportingQuery
>;
export type DownloadIncomingCallReportingLazyQueryHookResult = ReturnType<
  typeof useDownloadIncomingCallReportingLazyQuery
>;
export type DownloadIncomingCallReportingSuspenseQueryHookResult = ReturnType<
  typeof useDownloadIncomingCallReportingSuspenseQuery
>;
export type DownloadIncomingCallReportingQueryResult = Apollo.QueryResult<
  DownloadIncomingCallReportingQuery,
  DownloadIncomingCallReportingQueryVariables
>;
export function refetchDownloadIncomingCallReportingQuery(
  variables?: DownloadIncomingCallReportingQueryVariables,
) {
  return { query: DownloadIncomingCallReportingDocument, variables: variables };
}
export const DownloadOutgoingCallReportingDocument = gql`
  query downloadOutgoingCallReporting(
    $filter: FilterInput
    $sort: [SortInput!]
    $phoneNumber: String
    $lang: LangEnum
  ) {
    downloadOutgoingCallReporting(
      filter: $filter
      sort: $sort
      lang: $lang
      phoneNumber: $phoneNumber
    ) {
      content
      contentType
      fileName
    }
  }
`;

/**
 * __useDownloadOutgoingCallReportingQuery__
 *
 * To run a query within a React component, call `useDownloadOutgoingCallReportingQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadOutgoingCallReportingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadOutgoingCallReportingQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      phoneNumber: // value for 'phoneNumber'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useDownloadOutgoingCallReportingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DownloadOutgoingCallReportingQuery,
    DownloadOutgoingCallReportingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DownloadOutgoingCallReportingQuery,
    DownloadOutgoingCallReportingQueryVariables
  >(DownloadOutgoingCallReportingDocument, options);
}
export function useDownloadOutgoingCallReportingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DownloadOutgoingCallReportingQuery,
    DownloadOutgoingCallReportingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DownloadOutgoingCallReportingQuery,
    DownloadOutgoingCallReportingQueryVariables
  >(DownloadOutgoingCallReportingDocument, options);
}
export function useDownloadOutgoingCallReportingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DownloadOutgoingCallReportingQuery,
        DownloadOutgoingCallReportingQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DownloadOutgoingCallReportingQuery,
    DownloadOutgoingCallReportingQueryVariables
  >(DownloadOutgoingCallReportingDocument, options);
}
export type DownloadOutgoingCallReportingQueryHookResult = ReturnType<
  typeof useDownloadOutgoingCallReportingQuery
>;
export type DownloadOutgoingCallReportingLazyQueryHookResult = ReturnType<
  typeof useDownloadOutgoingCallReportingLazyQuery
>;
export type DownloadOutgoingCallReportingSuspenseQueryHookResult = ReturnType<
  typeof useDownloadOutgoingCallReportingSuspenseQuery
>;
export type DownloadOutgoingCallReportingQueryResult = Apollo.QueryResult<
  DownloadOutgoingCallReportingQuery,
  DownloadOutgoingCallReportingQueryVariables
>;
export function refetchDownloadOutgoingCallReportingQuery(
  variables?: DownloadOutgoingCallReportingQueryVariables,
) {
  return { query: DownloadOutgoingCallReportingDocument, variables: variables };
}
export const IncomingCallsDocument = gql`
  query incomingCalls($filter: CallFilterInput, $limit: Int, $skip: Int, $sort: [SortInput!]) {
    incomingCalls(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
      ...callDetail
    }
  }
  ${CallDetailFragmentDoc}
`;

/**
 * __useIncomingCallsQuery__
 *
 * To run a query within a React component, call `useIncomingCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncomingCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncomingCallsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useIncomingCallsQuery(
  baseOptions?: Apollo.QueryHookOptions<IncomingCallsQuery, IncomingCallsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IncomingCallsQuery, IncomingCallsQueryVariables>(
    IncomingCallsDocument,
    options,
  );
}
export function useIncomingCallsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IncomingCallsQuery, IncomingCallsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IncomingCallsQuery, IncomingCallsQueryVariables>(
    IncomingCallsDocument,
    options,
  );
}
export function useIncomingCallsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IncomingCallsQuery, IncomingCallsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IncomingCallsQuery, IncomingCallsQueryVariables>(
    IncomingCallsDocument,
    options,
  );
}
export type IncomingCallsQueryHookResult = ReturnType<typeof useIncomingCallsQuery>;
export type IncomingCallsLazyQueryHookResult = ReturnType<typeof useIncomingCallsLazyQuery>;
export type IncomingCallsSuspenseQueryHookResult = ReturnType<typeof useIncomingCallsSuspenseQuery>;
export type IncomingCallsQueryResult = Apollo.QueryResult<
  IncomingCallsQuery,
  IncomingCallsQueryVariables
>;
export function refetchIncomingCallsQuery(variables?: IncomingCallsQueryVariables) {
  return { query: IncomingCallsDocument, variables: variables };
}
export const OutgoingCallsDocument = gql`
  query outgoingCalls(
    $filter: CallFilterInput
    $limit: Int
    $ignoreLimitOffset: Boolean
    $skip: Int
    $sort: [SortInput!]
  ) {
    outgoingCalls(
      filter: $filter
      limit: $limit
      skip: $skip
      sort: $sort
      ignoreLimitOffset: $ignoreLimitOffset
    ) {
      ...callDetail
    }
  }
  ${CallDetailFragmentDoc}
`;

/**
 * __useOutgoingCallsQuery__
 *
 * To run a query within a React component, call `useOutgoingCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutgoingCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutgoingCallsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      ignoreLimitOffset: // value for 'ignoreLimitOffset'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useOutgoingCallsQuery(
  baseOptions?: Apollo.QueryHookOptions<OutgoingCallsQuery, OutgoingCallsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OutgoingCallsQuery, OutgoingCallsQueryVariables>(
    OutgoingCallsDocument,
    options,
  );
}
export function useOutgoingCallsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OutgoingCallsQuery, OutgoingCallsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OutgoingCallsQuery, OutgoingCallsQueryVariables>(
    OutgoingCallsDocument,
    options,
  );
}
export function useOutgoingCallsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OutgoingCallsQuery, OutgoingCallsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<OutgoingCallsQuery, OutgoingCallsQueryVariables>(
    OutgoingCallsDocument,
    options,
  );
}
export type OutgoingCallsQueryHookResult = ReturnType<typeof useOutgoingCallsQuery>;
export type OutgoingCallsLazyQueryHookResult = ReturnType<typeof useOutgoingCallsLazyQuery>;
export type OutgoingCallsSuspenseQueryHookResult = ReturnType<typeof useOutgoingCallsSuspenseQuery>;
export type OutgoingCallsQueryResult = Apollo.QueryResult<
  OutgoingCallsQuery,
  OutgoingCallsQueryVariables
>;
export function refetchOutgoingCallsQuery(variables?: OutgoingCallsQueryVariables) {
  return { query: OutgoingCallsDocument, variables: variables };
}
export const SearchDocument = gql`
  query search(
    $filter: SearchFilterInput
    $search: String!
    $limit: Int
    $skip: Int
    $sort: [SortInput!]
  ) {
    search(filter: $filter, search: $search, limit: $limit, skip: $skip, sort: $sort) {
      count
      countByType {
        count
        type
      }
      items {
        type
        ... on SearchMessage {
          message {
            id
            channelType
            content
            conversationId
            messageTime
            sender {
              id
              firstName
              lastName
            }
          }
        }
        ... on SearchAgentMessage {
          agentMessage {
            id
            channelType
            content
            conversationId
            messageTime
            sender {
              id
              firstName
              lastName
            }
          }
        }
        ... on SearchAttachment {
          attachment {
            fileName
            url
          }
        }
        ... on SearchCustomerCrmContact {
          customerCrmContact {
            id
            title
            firstName
            lastName
            sex
            functionName
            addresses {
              id
              city
              country
              postalCode
              address
              description
            }
            communications {
              type {
                id
                name
                category
              }
              sequence
              value
              description
              forwardStatus
              forwardCondition
              passThroughStatus
              passThroughCondition
            }
            groups {
              groupId
              group {
                id
                name
                subGroups {
                  id
                  name
                }
              }
              subGroupId
              subGroup {
                id
                name
              }
            }
          }
        }
        ... on SearchCustomerFixedInstruction {
          customerFixedInstruction {
            id
            updatedAt
            name
            content
          }
        }
        ... on SearchCustomerTemporaryInstruction {
          customerTemporaryInstruction {
            id
            updatedAt
            name
            content
            validFrom
            validUntil
            active
          }
        }
      }
    }
  }
`;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchQuery(
  baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables> &
    ({ variables: SearchQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
}
export function useSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
}
export function useSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
}
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchSuspenseQueryHookResult = ReturnType<typeof useSearchSuspenseQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export function refetchSearchQuery(variables: SearchQueryVariables) {
  return { query: SearchDocument, variables: variables };
}
export const GetThemeDocument = gql`
  query getTheme {
    theme {
      colors {
        error
        info
        primary
        primaryDarkShade
        primaryLightShade
        secondary
        secondaryDarkShade
        secondaryLightShade
        success
        warning
      }
      images {
        type
        url
      }
    }
  }
`;

/**
 * __useGetThemeQuery__
 *
 * To run a query within a React component, call `useGetThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThemeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetThemeQuery(
  baseOptions?: Apollo.QueryHookOptions<GetThemeQuery, GetThemeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetThemeQuery, GetThemeQueryVariables>(GetThemeDocument, options);
}
export function useGetThemeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetThemeQuery, GetThemeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetThemeQuery, GetThemeQueryVariables>(GetThemeDocument, options);
}
export function useGetThemeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetThemeQuery, GetThemeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetThemeQuery, GetThemeQueryVariables>(GetThemeDocument, options);
}
export type GetThemeQueryHookResult = ReturnType<typeof useGetThemeQuery>;
export type GetThemeLazyQueryHookResult = ReturnType<typeof useGetThemeLazyQuery>;
export type GetThemeSuspenseQueryHookResult = ReturnType<typeof useGetThemeSuspenseQuery>;
export type GetThemeQueryResult = Apollo.QueryResult<GetThemeQuery, GetThemeQueryVariables>;
export function refetchGetThemeQuery(variables?: GetThemeQueryVariables) {
  return { query: GetThemeDocument, variables: variables };
}
export const CreateUserDocument = gql`
  mutation createUser($input: CreateUserInput!) {
    createUser(input: $input) {
      id
    }
  }
`;
export type CreateUserMutationFn = Apollo.MutationFunction<
  CreateUserMutation,
  CreateUserMutationVariables
>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(
    CreateUserDocument,
    options,
  );
}
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<
  CreateUserMutation,
  CreateUserMutationVariables
>;
export const DeleteUserDocument = gql`
  mutation deleteUser($id: ID!) {
    deleteUser(id: $id) {
      success
    }
  }
`;
export type DeleteUserMutationFn = Apollo.MutationFunction<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(
    DeleteUserDocument,
    options,
  );
}
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;
export const GetCurrentUserDocument = gql`
  query getCurrentUser {
    getCurrentUser {
      id
      firstName
      lastName
      customers
      emailAddress
      role
      phoneNumber
      locale
    }
  }
`;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(
    GetCurrentUserDocument,
    options,
  );
}
export function useGetCurrentUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(
    GetCurrentUserDocument,
    options,
  );
}
export function useGetCurrentUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(
    GetCurrentUserDocument,
    options,
  );
}
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<
  typeof useGetCurrentUserSuspenseQuery
>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<
  GetCurrentUserQuery,
  GetCurrentUserQueryVariables
>;
export function refetchGetCurrentUserQuery(variables?: GetCurrentUserQueryVariables) {
  return { query: GetCurrentUserDocument, variables: variables };
}
export const GetCountriesDocument = gql`
  query getCountries($filter: CountryFilter, $limit: Int, $skip: Int, $sort: [SortInput!]) {
    countries(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
      count
      items {
        iso
        name
      }
    }
  }
`;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCountriesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(
    GetCountriesDocument,
    options,
  );
}
export function useGetCountriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(
    GetCountriesDocument,
    options,
  );
}
export function useGetCountriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCountriesQuery, GetCountriesQueryVariables>(
    GetCountriesDocument,
    options,
  );
}
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<
  GetCountriesQuery,
  GetCountriesQueryVariables
>;
export function refetchGetCountriesQuery(variables?: GetCountriesQueryVariables) {
  return { query: GetCountriesDocument, variables: variables };
}
export const GetCustomerDocument = gql`
  query getCustomer($filter: CustomerFilterInput) {
    customer(filter: $filter) {
      id
      name
      platformId
      parentId
      groupId
      appointmentContractYn
    }
  }
`;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCustomerQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
}
export function useGetCustomerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(
    GetCustomerDocument,
    options,
  );
}
export function useGetCustomerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCustomerQuery, GetCustomerQueryVariables>(
    GetCustomerDocument,
    options,
  );
}
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerSuspenseQueryHookResult = ReturnType<typeof useGetCustomerSuspenseQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<
  GetCustomerQuery,
  GetCustomerQueryVariables
>;
export function refetchGetCustomerQuery(variables?: GetCustomerQueryVariables) {
  return { query: GetCustomerDocument, variables: variables };
}
export const GetCustomerChatDataDocument = gql`
  query getCustomerChatData {
    customerChatData {
      guid
      username
      extension
      mainFicheId
      customerId
      userEmail
      serviceGroup
    }
  }
`;

/**
 * __useGetCustomerChatDataQuery__
 *
 * To run a query within a React component, call `useGetCustomerChatDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerChatDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerChatDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerChatDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerChatDataQuery,
    GetCustomerChatDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomerChatDataQuery, GetCustomerChatDataQueryVariables>(
    GetCustomerChatDataDocument,
    options,
  );
}
export function useGetCustomerChatDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerChatDataQuery,
    GetCustomerChatDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomerChatDataQuery, GetCustomerChatDataQueryVariables>(
    GetCustomerChatDataDocument,
    options,
  );
}
export function useGetCustomerChatDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCustomerChatDataQuery, GetCustomerChatDataQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCustomerChatDataQuery, GetCustomerChatDataQueryVariables>(
    GetCustomerChatDataDocument,
    options,
  );
}
export type GetCustomerChatDataQueryHookResult = ReturnType<typeof useGetCustomerChatDataQuery>;
export type GetCustomerChatDataLazyQueryHookResult = ReturnType<
  typeof useGetCustomerChatDataLazyQuery
>;
export type GetCustomerChatDataSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomerChatDataSuspenseQuery
>;
export type GetCustomerChatDataQueryResult = Apollo.QueryResult<
  GetCustomerChatDataQuery,
  GetCustomerChatDataQueryVariables
>;
export function refetchGetCustomerChatDataQuery(variables?: GetCustomerChatDataQueryVariables) {
  return { query: GetCustomerChatDataDocument, variables: variables };
}
export const GetCustomersDocument = gql`
  query getCustomers($limit: Int, $skip: Int, $sort: [SortInput!], $filter: CustomerFilterInput) {
    customers(limit: $limit, skip: $skip, sort: $sort, filter: $filter) {
      count
      items {
        id
        platformId
        parentId
        name
        groupId
        appointmentContractYn
      }
    }
  }
`;

/**
 * __useGetCustomersQuery__
 *
 * To run a query within a React component, call `useGetCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCustomersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomersQuery, GetCustomersQueryVariables>(
    GetCustomersDocument,
    options,
  );
}
export function useGetCustomersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomersQuery, GetCustomersQueryVariables>(
    GetCustomersDocument,
    options,
  );
}
export function useGetCustomersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCustomersQuery, GetCustomersQueryVariables>(
    GetCustomersDocument,
    options,
  );
}
export type GetCustomersQueryHookResult = ReturnType<typeof useGetCustomersQuery>;
export type GetCustomersLazyQueryHookResult = ReturnType<typeof useGetCustomersLazyQuery>;
export type GetCustomersSuspenseQueryHookResult = ReturnType<typeof useGetCustomersSuspenseQuery>;
export type GetCustomersQueryResult = Apollo.QueryResult<
  GetCustomersQuery,
  GetCustomersQueryVariables
>;
export function refetchGetCustomersQuery(variables?: GetCustomersQueryVariables) {
  return { query: GetCustomersDocument, variables: variables };
}
export const GetCustomersWithInfoDocument = gql`
  query getCustomersWithInfo(
    $limit: Int
    $skip: Int
    $sort: [SortInput!]
    $filter: CustomerFilterInput
  ) {
    customers(limit: $limit, skip: $skip, sort: $sort, filter: $filter) {
      count
      items {
        id
        platformId
        parentId
        name
        info {
          welcomeMessage
          contactInformationList {
            type
            address {
              city
              country
              postalCode
              street
              streetNumber
              box
            }
            emailAddress
            faxNumber
            mobilePhoneNumber
            phoneNumber1
            phoneNumber2
            website
          }
        }
      }
    }
  }
`;

/**
 * __useGetCustomersWithInfoQuery__
 *
 * To run a query within a React component, call `useGetCustomersWithInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersWithInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersWithInfoQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCustomersWithInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomersWithInfoQuery,
    GetCustomersWithInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomersWithInfoQuery, GetCustomersWithInfoQueryVariables>(
    GetCustomersWithInfoDocument,
    options,
  );
}
export function useGetCustomersWithInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomersWithInfoQuery,
    GetCustomersWithInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomersWithInfoQuery, GetCustomersWithInfoQueryVariables>(
    GetCustomersWithInfoDocument,
    options,
  );
}
export function useGetCustomersWithInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomersWithInfoQuery,
        GetCustomersWithInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCustomersWithInfoQuery, GetCustomersWithInfoQueryVariables>(
    GetCustomersWithInfoDocument,
    options,
  );
}
export type GetCustomersWithInfoQueryHookResult = ReturnType<typeof useGetCustomersWithInfoQuery>;
export type GetCustomersWithInfoLazyQueryHookResult = ReturnType<
  typeof useGetCustomersWithInfoLazyQuery
>;
export type GetCustomersWithInfoSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomersWithInfoSuspenseQuery
>;
export type GetCustomersWithInfoQueryResult = Apollo.QueryResult<
  GetCustomersWithInfoQuery,
  GetCustomersWithInfoQueryVariables
>;
export function refetchGetCustomersWithInfoQuery(variables?: GetCustomersWithInfoQueryVariables) {
  return { query: GetCustomersWithInfoDocument, variables: variables };
}
export const GetDefaultLocaleDocument = gql`
  query getDefaultLocale {
    defaultLocale {
      type
      content {
        language
        value
      }
    }
  }
`;

/**
 * __useGetDefaultLocaleQuery__
 *
 * To run a query within a React component, call `useGetDefaultLocaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultLocaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultLocaleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultLocaleQuery(
  baseOptions?: Apollo.QueryHookOptions<GetDefaultLocaleQuery, GetDefaultLocaleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDefaultLocaleQuery, GetDefaultLocaleQueryVariables>(
    GetDefaultLocaleDocument,
    options,
  );
}
export function useGetDefaultLocaleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultLocaleQuery, GetDefaultLocaleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDefaultLocaleQuery, GetDefaultLocaleQueryVariables>(
    GetDefaultLocaleDocument,
    options,
  );
}
export function useGetDefaultLocaleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDefaultLocaleQuery, GetDefaultLocaleQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDefaultLocaleQuery, GetDefaultLocaleQueryVariables>(
    GetDefaultLocaleDocument,
    options,
  );
}
export type GetDefaultLocaleQueryHookResult = ReturnType<typeof useGetDefaultLocaleQuery>;
export type GetDefaultLocaleLazyQueryHookResult = ReturnType<typeof useGetDefaultLocaleLazyQuery>;
export type GetDefaultLocaleSuspenseQueryHookResult = ReturnType<
  typeof useGetDefaultLocaleSuspenseQuery
>;
export type GetDefaultLocaleQueryResult = Apollo.QueryResult<
  GetDefaultLocaleQuery,
  GetDefaultLocaleQueryVariables
>;
export function refetchGetDefaultLocaleQuery(variables?: GetDefaultLocaleQueryVariables) {
  return { query: GetDefaultLocaleDocument, variables: variables };
}
export const GetUserDocument = gql`
  query getUser($id: ID!) {
    user(id: $id) {
      id
      firstName
      lastName
      customers
      emailAddress
      role
      phoneNumber
      locale
    }
  }
`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> &
    ({ variables: GetUserQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export function useGetUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export function useGetUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export function refetchGetUserQuery(variables: GetUserQueryVariables) {
  return { query: GetUserDocument, variables: variables };
}
export const GetUserStatusDocument = gql`
  query getUserStatus {
    userStatus {
      active
    }
  }
`;

/**
 * __useGetUserStatusQuery__
 *
 * To run a query within a React component, call `useGetUserStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUserStatusQuery, GetUserStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserStatusQuery, GetUserStatusQueryVariables>(
    GetUserStatusDocument,
    options,
  );
}
export function useGetUserStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserStatusQuery, GetUserStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserStatusQuery, GetUserStatusQueryVariables>(
    GetUserStatusDocument,
    options,
  );
}
export function useGetUserStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserStatusQuery, GetUserStatusQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserStatusQuery, GetUserStatusQueryVariables>(
    GetUserStatusDocument,
    options,
  );
}
export type GetUserStatusQueryHookResult = ReturnType<typeof useGetUserStatusQuery>;
export type GetUserStatusLazyQueryHookResult = ReturnType<typeof useGetUserStatusLazyQuery>;
export type GetUserStatusSuspenseQueryHookResult = ReturnType<typeof useGetUserStatusSuspenseQuery>;
export type GetUserStatusQueryResult = Apollo.QueryResult<
  GetUserStatusQuery,
  GetUserStatusQueryVariables
>;
export function refetchGetUserStatusQuery(variables?: GetUserStatusQueryVariables) {
  return { query: GetUserStatusDocument, variables: variables };
}
export const GetUsersDocument = gql`
  query getUsers($filter: UsersFilterInput, $sort: [SortInput!], $skip: Int, $limit: Int) {
    users(filter: $filter, sort: $sort, skip: $skip, limit: $limit) {
      count
      items {
        id
        emailAddress
        firstName
        lastName
        phoneNumber
        role
      }
    }
  }
`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
}
export function useGetUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
}
export function useGetUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
}
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function refetchGetUsersQuery(variables?: GetUsersQueryVariables) {
  return { query: GetUsersDocument, variables: variables };
}
export const LogoutDocument = gql`
  query logout {
    logout
  }
`;

/**
 * __useLogoutQuery__
 *
 * To run a query within a React component, call `useLogoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useLogoutQuery(
  baseOptions?: Apollo.QueryHookOptions<LogoutQuery, LogoutQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LogoutQuery, LogoutQueryVariables>(LogoutDocument, options);
}
export function useLogoutLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LogoutQuery, LogoutQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LogoutQuery, LogoutQueryVariables>(LogoutDocument, options);
}
export function useLogoutSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LogoutQuery, LogoutQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LogoutQuery, LogoutQueryVariables>(LogoutDocument, options);
}
export type LogoutQueryHookResult = ReturnType<typeof useLogoutQuery>;
export type LogoutLazyQueryHookResult = ReturnType<typeof useLogoutLazyQuery>;
export type LogoutSuspenseQueryHookResult = ReturnType<typeof useLogoutSuspenseQuery>;
export type LogoutQueryResult = Apollo.QueryResult<LogoutQuery, LogoutQueryVariables>;
export function refetchLogoutQuery(variables?: LogoutQueryVariables) {
  return { query: LogoutDocument, variables: variables };
}
export const UpdateCurrentUserLocaleDocument = gql`
  mutation updateCurrentUserLocale($locale: String!) {
    updateCurrentUserLocale(locale: $locale)
  }
`;
export type UpdateCurrentUserLocaleMutationFn = Apollo.MutationFunction<
  UpdateCurrentUserLocaleMutation,
  UpdateCurrentUserLocaleMutationVariables
>;

/**
 * __useUpdateCurrentUserLocaleMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentUserLocaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserLocaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentUserLocaleMutation, { data, loading, error }] = useUpdateCurrentUserLocaleMutation({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useUpdateCurrentUserLocaleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCurrentUserLocaleMutation,
    UpdateCurrentUserLocaleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCurrentUserLocaleMutation,
    UpdateCurrentUserLocaleMutationVariables
  >(UpdateCurrentUserLocaleDocument, options);
}
export type UpdateCurrentUserLocaleMutationHookResult = ReturnType<
  typeof useUpdateCurrentUserLocaleMutation
>;
export type UpdateCurrentUserLocaleMutationResult =
  Apollo.MutationResult<UpdateCurrentUserLocaleMutation>;
export type UpdateCurrentUserLocaleMutationOptions = Apollo.BaseMutationOptions<
  UpdateCurrentUserLocaleMutation,
  UpdateCurrentUserLocaleMutationVariables
>;
export const UpdateCustomerDocument = gql`
  mutation updateCustomer($id: ID!, $input: UpdateCustomerInput!) {
    updateCustomer(id: $id, input: $input) {
      id
      name
      info {
        contactInformationList {
          type
          address {
            city
            country
            postalCode
            street
            streetNumber
            box
          }
          emailAddress
          faxNumber
          mobilePhoneNumber
          phoneNumber1
          phoneNumber2
          website
        }
      }
    }
  }
`;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables
>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(
    UpdateCustomerDocument,
    options,
  );
}
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables
>;
export const UpdateUserDocument = gql`
  mutation updateUser($id: ID!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      id
    }
  }
`;
export type UpdateUserMutationFn = Apollo.MutationFunction<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(
    UpdateUserDocument,
    options,
  );
}
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;
export const UpdateUserStatusDocument = gql`
  mutation updateUserStatus($input: UpdateUserStatusInput!) {
    updateUserStatus(input: $input) {
      active
    }
  }
`;
export type UpdateUserStatusMutationFn = Apollo.MutationFunction<
  UpdateUserStatusMutation,
  UpdateUserStatusMutationVariables
>;

/**
 * __useUpdateUserStatusMutation__
 *
 * To run a mutation, you first call `useUpdateUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserStatusMutation, { data, loading, error }] = useUpdateUserStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserStatusMutation,
    UpdateUserStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>(
    UpdateUserStatusDocument,
    options,
  );
}
export type UpdateUserStatusMutationHookResult = ReturnType<typeof useUpdateUserStatusMutation>;
export type UpdateUserStatusMutationResult = Apollo.MutationResult<UpdateUserStatusMutation>;
export type UpdateUserStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserStatusMutation,
  UpdateUserStatusMutationVariables
>;
export const UserStatusUpdatedDocument = gql`
  subscription userStatusUpdated {
    userStatusUpdated {
      active
    }
  }
`;

/**
 * __useUserStatusUpdatedSubscription__
 *
 * To run a query within a React component, call `useUserStatusUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserStatusUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStatusUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserStatusUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    UserStatusUpdatedSubscription,
    UserStatusUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    UserStatusUpdatedSubscription,
    UserStatusUpdatedSubscriptionVariables
  >(UserStatusUpdatedDocument, options);
}
export type UserStatusUpdatedSubscriptionHookResult = ReturnType<
  typeof useUserStatusUpdatedSubscription
>;
export type UserStatusUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<UserStatusUpdatedSubscription>;
export const RegisterWebpushDocument = gql`
  mutation registerWebpush($input: RegisterWebPushInput!) {
    registerWebpush(input: $input) {
      success
    }
  }
`;
export type RegisterWebpushMutationFn = Apollo.MutationFunction<
  RegisterWebpushMutation,
  RegisterWebpushMutationVariables
>;

/**
 * __useRegisterWebpushMutation__
 *
 * To run a mutation, you first call `useRegisterWebpushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterWebpushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerWebpushMutation, { data, loading, error }] = useRegisterWebpushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterWebpushMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterWebpushMutation,
    RegisterWebpushMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RegisterWebpushMutation, RegisterWebpushMutationVariables>(
    RegisterWebpushDocument,
    options,
  );
}
export type RegisterWebpushMutationHookResult = ReturnType<typeof useRegisterWebpushMutation>;
export type RegisterWebpushMutationResult = Apollo.MutationResult<RegisterWebpushMutation>;
export type RegisterWebpushMutationOptions = Apollo.BaseMutationOptions<
  RegisterWebpushMutation,
  RegisterWebpushMutationVariables
>;
